/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Trove
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customClient } from './client';
import type { BodyType } from './client';
export type AccessStatus = typeof AccessStatus[keyof typeof AccessStatus];


export const AccessStatus = {
  initial: 'initial',
  success: 'success',
  failed: 'failed',
  pending: 'pending',
  disabled: 'disabled',
  deleted: 'deleted',
} as const;

export interface AccountIn {
  access_status: AccessStatus;
}

export type Provider = typeof Provider[keyof typeof Provider];


export const Provider = {
  google: 'google',
  microsoft: 'microsoft',
  slack: 'slack',
  xero: 'xero',
  stripe: 'stripe',
  sage: 'sage',
  quickbooks: 'quickbooks',
  dynamics: 'dynamics',
  netsuite: 'netsuite',
  freeagent: 'freeagent',
} as const;

export interface AccountOut {
  id: string;
  name: string;
  external_id: string;
  access_status: AccessStatus;
  provider: Provider;
  deeplink_info?: string | null;
  base_currency?: string | null;
  initial_sync_progress?: number | null;
}

export type ContactRole = typeof ContactRole[keyof typeof ContactRole];


export const ContactRole = {
  primary: 'primary',
  cc: 'cc',
} as const;

export interface ContactDetails {
  id?: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  default_role?: ContactRole | null;
  escalation_role?: ContactRole | null;
}

export interface ActionAddContact {
  kind: 'add_new_contacts';
  contacts: ContactDetails[];
}

export const ActionCreateSubcustomerValue = {
  kind: 'create_subcustomer',
} as const;
export type ActionCreateSubcustomer = typeof ActionCreateSubcustomerValue;

export interface SimpleCustomer {
  name: string | null;
  id: string;
}

export interface SimpleInvoice {
  id: string;
  number: string;
  amount_due: number;
  total_amount: number;
  currency: string;
  due: string;
}

export type WorkflowState = typeof WorkflowState[keyof typeof WorkflowState];


export const WorkflowState = {
  sending: 'sending',
  manual: 'manual',
  disabled: 'disabled',
} as const;

export interface SimpleWorkflow {
  id: string;
  name: string;
  state: WorkflowState;
  is_default: boolean;
}

export type EventStatus = typeof EventStatus[keyof typeof EventStatus];


export const EventStatus = {
  pending: 'pending',
  success: 'success',
  failure: 'failure',
  superseded: 'superseded',
} as const;

export interface PersonalEventOut {
  id: string;
  status: EventStatus;
  trigger_at: string;
}

export type SubcustomerHistoryState = typeof SubcustomerHistoryState[keyof typeof SubcustomerHistoryState];


export const SubcustomerHistoryState = {
  draft: 'draft',
  applied: 'applied',
  manual_applied: 'manual_applied',
} as const;

export interface CustomFieldOut {
  id: string;
  value?: string | null;
}

export type NoteStatus = typeof NoteStatus[keyof typeof NoteStatus];


export const NoteStatus = {
  unpublished: 'unpublished',
  published: 'published',
} as const;

export interface NoteEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'note';
  status: NoteStatus;
}

export type EventReadStatusOut = typeof EventReadStatusOut[keyof typeof EventReadStatusOut];


export const EventReadStatusOut = {
  read: 'read',
  new: 'new',
} as const;

export interface InboundEmailEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_email';
  status: EventReadStatusOut;
}

export type EventStatusOut = typeof EventStatusOut[keyof typeof EventStatusOut];


export const EventStatusOut = {
  superseded: 'superseded',
  skipped: 'skipped',
  pending: 'pending',
  queued: 'queued',
  pending_approved: 'pending_approved',
  pending_overdue: 'pending_overdue',
  success: 'success',
  failure: 'failure',
} as const;

export const PersonalReminderEventOutStatus = {...EventStatusOut,...EventReadStatusOut,} as const
export interface PersonalReminderEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'personal_reminder';
  status: typeof PersonalReminderEventOutStatus[keyof typeof PersonalReminderEventOutStatus];
}

export const PhoneReminderEventOutStatus = {...EventStatusOut,...NoteStatus,} as const
export interface PhoneReminderEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'phonecall_reminder';
  status: typeof PhoneReminderEventOutStatus[keyof typeof PhoneReminderEventOutStatus];
}

export interface OutboundEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_email';
  status: EventStatusOut;
}

export interface OutboundLetterEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_letter';
  status: EventStatusOut;
}

export interface OutboundSmsEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_sms';
  status: EventStatusOut;
}

export interface InboundSmsEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_sms';
  status: EventReadStatusOut;
}

export interface InboundCallEventOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer?: SimpleCustomer | null;
  invoices?: SimpleInvoice[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_call';
  status: EventReadStatusOut;
}

export interface SimpleInvoiceWithExpected {
  id: string;
  number: string;
  amount_due: number;
  total_amount: number;
  currency: string;
  due: string;
  expected_payment_date: string | null;
}

export type WriteReplyReason = typeof WriteReplyReason[keyof typeof WriteReplyReason];


export const WriteReplyReason = {
  missed_payment_date: 'missed_payment_date',
  provided_payment_date: 'provided_payment_date',
  says_paid: 'says_paid',
  says_will_come_back: 'says_will_come_back',
  extra_information_requested: 'extra_information_requested',
} as const;

export interface ActionWriteReply {
  kind: 'send_reply';
  reason?: WriteReplyReason | null;
  subject: string | null;
  body: string | null;
}

export type ActionSetExpectedPaymentDateOriginalDates = {[key: string]: string | null} | null;

export interface ActionSetExpectedPaymentDate {
  kind: 'set_expected_payment_date';
  suggested_date?: string | null;
  original_dates?: ActionSetExpectedPaymentDateOriginalDates;
}

export interface ActionUpdateContact {
  kind: 'update_broken_contact';
  contacts: ContactDetails[];
}

export interface ActionOut {
  id: string;
  customer: SimpleCustomer;
  source_event: NoteEventOut | InboundEmailEventOut | PersonalReminderEventOut | PhoneReminderEventOut | OutboundEventOut | OutboundLetterEventOut | OutboundSmsEventOut | InboundSmsEventOut | InboundCallEventOut;
  to_deal_with_at: string;
  invoices: SimpleInvoiceWithExpected[];
  step: ActionWriteReply | ActionSetExpectedPaymentDate | ActionAddContact | ActionUpdateContact | ActionCreateSubcustomer;
}

export type ActionStatus = typeof ActionStatus[keyof typeof ActionStatus];


export const ActionStatus = {
  single_missed: 'single_missed',
  multiple_missed: 'multiple_missed',
} as const;

export type ActivityCategory = typeof ActivityCategory[keyof typeof ActivityCategory];


export const ActivityCategory = {
  email: 'email',
  personal_reminder: 'personal_reminder',
  activity: 'activity',
  user_note: 'user_note',
  invoice_paid: 'invoice_paid',
  xero_reminder: 'xero_reminder',
  system_note: 'system_note',
  entity_edited: 'entity_edited',
  invoice_sent: 'invoice_sent',
} as const;

export const ActivityOutCategory = {...ActivityCategory,  Letter: 'Letter',
  Phone: 'Phone',
} as const
export interface ActivityOut {
  customer_name: string;
  customer_id: string;
  category: typeof ActivityOutCategory[keyof typeof ActivityOutCategory];
  column_0: number;
  column_1: number;
  column_2: number;
}

export interface ActivitiesOut {
  rows: ActivityOut[];
  column_0: string;
  column_1: string;
  column_2: string;
}

export interface ActivityRecord {
  invoice_url: string | null;
  date: string;
  description: string;
  reference: string | null;
  due_date: string | null;
  total_amount: number | null;
  payment_amount: number | null;
  balance_amount: number;
}

export interface ActivityData {
  activities: ActivityRecord[];
  after_balance: number;
  currency: string;
  customer_name: string;
}

export type ActivityStatus = typeof ActivityStatus[keyof typeof ActivityStatus];


export const ActivityStatus = {
  not_applicable: 'not_applicable',
  excluded: 'excluded',
  customer_excluded: 'customer_excluded',
  late_fee: 'late_fee',
  sending: 'sending',
  completed: 'completed',
  failing: 'failing',
} as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];


export const AddressType = {
  billing: 'billing',
  shipping: 'shipping',
} as const;

export interface AddressIn {
  id: string | null;
  type: AddressType;
  address_line1?: string | null;
  address_line2?: string | null;
  address_line3?: string | null;
  address_line4?: string | null;
  city?: string | null;
  address_state?: string | null;
  postal_code?: string | null;
  country?: string | null;
}

export type ContactSource = typeof ContactSource[keyof typeof ContactSource];


export const ContactSource = {
  accounting: 'accounting',
  incoming_emails: 'incoming_emails',
  manual: 'manual',
  subcustomer: 'subcustomer',
} as const;

export interface AddressOut {
  id: string;
  type: AddressType;
  address_line1?: string | null;
  address_line2?: string | null;
  address_line3?: string | null;
  address_line4?: string | null;
  city?: string | null;
  address_state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  source: ContactSource;
  customized: boolean;
}

export interface AifySentences {
  sentences: string[];
}

export interface AssignCard {
  customer_id: string;
  email_settings_id: string | null;
}

export interface AssigneeOut {
  first_name: string | null;
  last_name: string | null;
  email: string;
  id: string;
  avatar: string | null;
}

export interface AttachmentSchema {
  id: string;
  name: string;
  content_type: string;
  is_inline: boolean;
  content_id: string | null;
  size: number;
}

export type Combinator = typeof Combinator[keyof typeof Combinator];


export const Combinator = {
  and: 'and',
  or: 'or',
  nor: 'nor',
} as const;

export type RuleEnumOperators = typeof RuleEnumOperators[keyof typeof RuleEnumOperators];


export const RuleEnumOperators = {
  is_in: 'is_in',
  is_not_in: 'is_not_in',
} as const;

export type RuleDateOperators = typeof RuleDateOperators[keyof typeof RuleDateOperators];


export const RuleDateOperators = {
  on: 'on',
  not_on: 'not_on',
  before: 'before',
  on_or_before: 'on_or_before',
  after: 'after',
  on_or_after: 'on_or_after',
} as const;

export type RuleTextOperators = typeof RuleTextOperators[keyof typeof RuleTextOperators];


export const RuleTextOperators = {
  contains: 'contains',
  not_contains: 'not_contains',
  is: 'is',
  is_not: 'is_not',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
} as const;

export type RuleNumberOperators = typeof RuleNumberOperators[keyof typeof RuleNumberOperators];


export const RuleNumberOperators = {
  '=': '=',
  '<>': '<>',
  '>': '>',
  '<': '<',
  '>=': '>=',
  '<=': '<=',
} as const;

export type RuleUnaryOperators = typeof RuleUnaryOperators[keyof typeof RuleUnaryOperators];


export const RuleUnaryOperators = {
  is_empty: 'is_empty',
  is_not_empty: 'is_not_empty',
} as const;

export const WorkflowRuleOperator = {...RuleEnumOperators,...RuleDateOperators,...RuleTextOperators,...RuleNumberOperators,...RuleUnaryOperators,} as const
export type WorkflowRuleOperator = typeof WorkflowRuleOperator[keyof typeof WorkflowRuleOperator];

export type WorkflowRuleEntity = typeof WorkflowRuleEntity[keyof typeof WorkflowRuleEntity];


export const WorkflowRuleEntity = {
  customer: 'customer',
  address: 'address',
  invoice: 'invoice',
  repeating_invoice: 'repeating_invoice',
  line_item: 'line_item',
} as const;

export interface Rule {
  field: string;
  value: string[] | string;
  operator: WorkflowRuleOperator;
  entity: WorkflowRuleEntity;
}

export interface RulesOutput {
  combinator: Combinator;
  rules: (Rule | RulesOutput)[];
}

export interface CurrencyAmount {
  currency: string;
  amount: number;
}

export interface CardOut {
  name: string | null;
  id: string;
  weight: number;
  invoice_count: number;
  amount_due: CurrencyAmount[];
  earliest_due: string | null;
  workflows: SimpleWorkflow[];
  assignee: AssigneeOut | null;
  excluded: boolean;
}

export interface LaneOut {
  id: string | 'unassigned' | 'paid';
  name: string;
  criteria?: RulesOutput | null;
  customers: CardOut[];
  total_count: number;
}

export interface BoardOut {
  lanes: LaneOut[];
}

export interface BodyAddIntegration {
  token: string;
}

export type SortingSortOrder = typeof SortingSortOrder[keyof typeof SortingSortOrder];


export const SortingSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export interface Sorting {
  field: string;
  sort_order: SortingSortOrder;
}

export interface Filter {
  field: string;
  value: string[] | string;
  operator: WorkflowRuleOperator;
}

export interface FiltersInput {
  combinator: Combinator;
  rules: (Filter | FiltersInput)[];
}

export interface BodyGetCustomers {
  sorting?: Sorting[] | null;
  filters?: FiltersInput | null;
  columns?: string[] | null;
}

export interface BodyGetEvents {
  sorting?: Sorting[] | null;
  filters?: FiltersInput | null;
  columns?: string[] | null;
}

export interface BodyGetInvoices {
  sorting?: Sorting[] | null;
  filters?: FiltersInput | null;
  columns?: string[] | null;
}

export interface BodyGetTasks {
  filters?: FiltersInput | null;
  columns?: string[] | null;
}

export type StatementType = typeof StatementType[keyof typeof StatementType];


export const StatementType = {
  outstanding: 'outstanding',
  overdue: 'overdue',
  activity: 'activity',
} as const;

export interface BodySendImmediateEmail {
  customer_id?: string | null;
  subject: string;
  body: string;
  sender: string;
  recipients: string[];
  cc?: string[] | null;
  bcc?: string[] | null;
  in_reply_to?: string | null;
  invoices?: string[] | null;
  attach_invoice?: boolean;
  attach_invoice_attachments?: boolean;
  statement_type?: StatementType | null;
  activity_statement_months?: number;
  include_partial?: boolean;
  priority?: number | null;
  attachments?: (Blob | File)[] | null;
}

export type ReportableEntity = typeof ReportableEntity[keyof typeof ReportableEntity];


export const ReportableEntity = {
  invoice: 'invoice',
  customer: 'customer',
  event: 'event',
} as const;

export interface ColumnSort {
  desc: boolean;
  id: string;
}

export interface Column {
  id: string;
  visible: boolean;
}

export type ReportInColumnSizing = {[key: string]: number};

export interface ReportIn {
  id: string | null;
  entity: ReportableEntity;
  name: string;
  description: string;
  sorting: ColumnSort[];
  filters: FiltersInput;
  columns: Column[];
  column_sizing: ReportInColumnSizing;
}

export interface EmailIdentityOut {
  first_name: string | null;
  last_name: string | null;
  email: string;
}

export type SlackChannelKind = typeof SlackChannelKind[keyof typeof SlackChannelKind];


export const SlackChannelKind = {
  channel: 'channel',
  user: 'user',
} as const;

export interface SlackChannel {
  id: string;
  name: string;
  kind: SlackChannelKind;
}

export interface BodySendReportNow {
  report: ReportIn;
  emails: EmailIdentityOut[];
  slack_channels: SlackChannel[];
}

export interface BodyUpdateLogo {
  upload: Blob | File;
}

export type EventReadStatus = typeof EventReadStatus[keyof typeof EventReadStatus];


export const EventReadStatus = {
  new: 'new',
  read: 'read',
} as const;

export interface BulkReadStatusIn {
  event_ids: string[];
  read_status: EventReadStatus;
}

export interface ContactIn {
  id?: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string;
  phone_number?: string | null;
  default_role?: ContactRole | null;
  escalation_role?: ContactRole | null;
}

export type ContactStatus = typeof ContactStatus[keyof typeof ContactStatus];


export const ContactStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;

export interface ContactOut {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone_number_id?: string | null;
  phone_number?: string | null;
  default_role?: ContactRole | null;
  escalation_role?: ContactRole | null;
  source: ContactSource;
  status: ContactStatus;
  customer: SimpleCustomer;
  customized: boolean;
}

export interface CustomFieldDefinition {
  id: string;
  label: string;
  type: string;
}

export interface ContainerAnnotatedUnionNoteEventOutInboundEmailEventOutPersonalReminderEventOutPhoneReminderEventOutOutboundEventOutOutboundLetterEventOutOutboundSmsEventOutInboundSmsEventOutInboundCallEventOutFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorKind {
  rows: (NoteEventOut | InboundEmailEventOut | PersonalReminderEventOut | PhoneReminderEventOut | OutboundEventOut | OutboundLetterEventOut | OutboundSmsEventOut | InboundSmsEventOut | InboundCallEventOut)[];
  row_count: number;
  custom_fields: CustomFieldDefinition[];
}

export type CustomerState = typeof CustomerState[keyof typeof CustomerState];


export const CustomerState = {
  paused: 'paused',
  active: 'active',
} as const;

export interface NextCustomerChase {
  event_id: string;
  action_id: string;
  label: string;
  driver_invoice_id: string;
}

export interface EventSummary {
  id: string;
  label?: string | null;
  trigger_at: string;
  title: string;
}

export type DebtorType = typeof DebtorType[keyof typeof DebtorType];


export const DebtorType = {
  cleared: 'cleared',
  improving: 'improving',
  new: 'new',
  no_change: 'no_change',
  deteriorating: 'deteriorating',
} as const;

export interface SimpleOrganizationSchema {
  id: string;
  name: string;
  external_id: string;
}

export interface CustomerOut {
  id: string;
  external_id?: string | null;
  name: string | null;
  alias: string | null;
  parent_id: string | null;
  status: CustomerState;
  amount_overdue?: number | null;
  overdue?: CurrencyAmount[] | null;
  amount_due?: number | null;
  due?: CurrencyAmount[] | null;
  next_activity_at?: string | null;
  next_chase?: NextCustomerChase | null;
  provider?: Provider | null;
  has_payment_plan?: boolean;
  workflows?: SimpleWorkflow[] | null;
  manual_enrolled: string | null;
  account_number?: string | null;
  last_contacted?: EventSummary | null;
  recent_activity?: EventSummary[] | null;
  overdue_this_month?: number | null;
  overdue_last_month?: number | null;
  overdue_greatlast_month?: number | null;
  overdue_delta?: number | null;
  overdue_rate?: number | null;
  debtor_type?: DebtorType | null;
  overdue_this_week?: number | null;
  overdue_last_week?: number | null;
  overdue_greatlast_week?: number | null;
  overdue_delta_week?: number | null;
  overdue_rate_week?: number | null;
  debtor_type_week?: DebtorType | null;
  custom_fields: CustomFieldOut[];
  overdue_invoices?: SimpleInvoice[] | null;
  children: SimpleCustomer[];
  organization: SimpleOrganizationSchema;
}

export interface ContainerCustomerOut {
  rows: CustomerOut[];
  row_count: number;
  custom_fields: CustomFieldDefinition[];
}

export type InvoiceNextAction = typeof InvoiceNextAction[keyof typeof InvoiceNextAction];


export const InvoiceNextAction = {
  in_query: 'in_query',
  debt_recovery: 'debt_recovery',
  payment_plan: 'payment_plan',
  late_payment_fee: 'late_payment_fee',
  other: 'other',
} as const;

export interface NextInvoiceChase {
  event_id: string;
  action_id: string;
  label: string;
}

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];


export const InvoiceStatus = {
  unknown: 'unknown',
  cancelled: 'cancelled',
  draft: 'draft',
  paid: 'paid',
  subscription: 'subscription',
  posted: 'posted',
  overdue: 'overdue',
} as const;

export interface SimpleCustomerWithPausedState {
  name: string | null;
  id: string;
  state: CustomerState;
}

export interface InvoiceOut {
  id: string;
  number: string;
  external_id: string;
  amount_due: number;
  due: string;
  reference: string | null;
  in_dispute: boolean;
  currency: string;
  posted_at: string | null;
  paid_at: string | null;
  total_amount: number;
  amount_paid: number;
  currency_rate: number | null;
  expected_payment_date: string | null;
  type: Provider;
  next_action: InvoiceNextAction | null;
  organization: SimpleOrganizationSchema;
  manual_enrolled_id: string | null;
  next_event_at?: string | null;
  next_chase?: NextInvoiceChase | null;
  status?: InvoiceStatus | null;
  account_id?: string | null;
  customer: SimpleCustomerWithPausedState | null;
  workflow?: SimpleWorkflow | null;
  activity_status?: ActivityStatus | null;
  personal_reminder?: PersonalEventOut | null;
  has_payment_plan?: boolean;
  days_overdue?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  recent_activity?: EventSummary[] | null;
  note_summary?: string | null;
  last_contacted?: EventSummary | null;
  custom_fields: CustomFieldOut[];
  readonly total_amount_internal: number;
  readonly amount_due_internal: number;
}

export interface ContainerInvoiceOut {
  rows: InvoiceOut[];
  row_count: number;
  custom_fields: CustomFieldDefinition[];
}

export interface CreditNoteOut {
  id: string;
  type?: 'credit_note';
  external_id: string;
  number: string;
  customer: SimpleCustomerWithPausedState;
  currency: string;
  reference: string | null;
  amount_remaining: number;
  total_amount: number;
  posted_at: string;
}

export interface CustomVariablesOut {
  customer_custom_fields: CustomFieldDefinition[];
  invoice_custom_fields: CustomFieldDefinition[];
  template_custom_fields: CustomFieldDefinition[];
}

export type PhoneType = typeof PhoneType[keyof typeof PhoneType];


export const PhoneType = {
  default: 'default',
  ddi: 'ddi',
  mobile: 'mobile',
  fax: 'fax',
} as const;

export interface PhoneOut {
  id: string;
  type: PhoneType;
  number: string;
  source: ContactSource;
  customized: boolean;
}

export interface PinnedNoteOut {
  id: string;
  text: string | null;
  event_id: string | null;
}

export interface CustomerDetailOut {
  id: string;
  external_id?: string | null;
  name: string | null;
  alias: string | null;
  parent_id: string | null;
  status: CustomerState;
  amount_overdue?: number | null;
  overdue?: CurrencyAmount[] | null;
  amount_due?: number | null;
  due?: CurrencyAmount[] | null;
  next_activity_at?: string | null;
  next_chase?: NextCustomerChase | null;
  provider?: Provider | null;
  has_payment_plan?: boolean;
  workflows?: SimpleWorkflow[] | null;
  manual_enrolled: string | null;
  account_number?: string | null;
  last_contacted?: EventSummary | null;
  overdue_this_month?: number | null;
  overdue_last_month?: number | null;
  overdue_greatlast_month?: number | null;
  overdue_delta?: number | null;
  overdue_rate?: number | null;
  debtor_type?: DebtorType | null;
  overdue_this_week?: number | null;
  overdue_last_week?: number | null;
  overdue_greatlast_week?: number | null;
  overdue_delta_week?: number | null;
  overdue_rate_week?: number | null;
  debtor_type_week?: DebtorType | null;
  custom_fields: CustomFieldOut[];
  overdue_invoices?: SimpleInvoice[] | null;
  children: SimpleCustomer[];
  organization: SimpleOrganizationSchema;
  primary_contacts: ContactOut[];
  phones: PhoneOut[];
  addresses: AddressOut[];
  portal_url: string;
  parents: SimpleCustomer[];
  pinned_note?: PinnedNoteOut | null;
}

export interface PaymentInstructions {
  currency: string | null;
  text_instructions: string;
  account_name: string;
  account_number: string;
  sort_code: string;
  bank_name: string;
  bic: string;
  iban: string;
}

export type LetterPostage = typeof LetterPostage[keyof typeof LetterPostage];


export const LetterPostage = {
  first: 'first',
  second: 'second',
} as const;

export interface DocumentIn {
  id: string;
  document_name: string;
  name: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  company_number: string;
  vat_number: string;
  footer: string;
  include_logo: boolean;
  include_details: boolean;
  include_payment: boolean;
  include_footer: boolean;
  payment_instructions: PaymentInstructions[];
  postage: LetterPostage;
  duplex: boolean;
  statement_to_paused_customers?: boolean | null;
  statement_about_excluded_invoices?: boolean | null;
}

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


export const DocumentType = {
  statement: 'statement',
  letter: 'letter',
} as const;

export interface SimpleWorkflowAction {
  id: string;
  workflow_id: string;
  workflow_name: string;
  action_label: string;
}

export interface DocumentOut {
  id: string;
  document_name: string;
  name: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  company_number: string;
  vat_number: string;
  footer: string;
  include_logo: boolean;
  include_details: boolean;
  include_payment: boolean;
  include_footer: boolean;
  payment_instructions: PaymentInstructions[];
  postage: LetterPostage;
  duplex: boolean;
  type: DocumentType;
  used_in: SimpleWorkflowAction[];
  updated_at: string;
}

export interface EmailAccountIn {
  id: string;
  is_global: boolean;
}

export interface EmailAccountOut {
  id: string;
  access_status: AccessStatus;
  email: string;
  first_name: string | null;
  last_name: string | null;
  provider: Provider;
  is_global: boolean;
  can_share_inbox: boolean;
  can_share_sending: boolean;
}

export type EmailBodyType = typeof EmailBodyType[keyof typeof EmailBodyType];


export const EmailBodyType = {
  text: 'text',
  html: 'html',
} as const;

export type StatementFormat = typeof StatementFormat[keyof typeof StatementFormat];


export const StatementFormat = {
  pdf: 'pdf',
  csv: 'csv',
} as const;

export interface EmailDetailsOut {
  id: string;
  sent_at: string | null;
  sender: string | null;
  email_settings_id: string | null;
  recipient: string[];
  cc: string[];
  bcc: string[];
  body_type: EmailBodyType;
  subject: string;
  body: string;
  attach_invoice: boolean;
  attach_invoice_attachments?: boolean;
  statement_type?: StatementType | null;
  activity_statement_months: number;
  include_partial: boolean;
  statement_formats: StatementFormat[];
  priority: number;
  attachments: AttachmentSchema[] | null;
}

export interface EmailGroupIn {
  id: string | null;
  name: string;
  sender: string | null;
  cc: string[];
  bcc: string[];
  reply_to: string | null;
}

export interface EmailGroupOut {
  id: string;
  name: string;
  sender: string | null;
  cc: string[];
  bcc: string[];
  reply_to: string | null;
  workflows: SimpleWorkflow[];
}

export type EmailSettingsRole = typeof EmailSettingsRole[keyof typeof EmailSettingsRole];


export const EmailSettingsRole = {
  primary: 'primary',
  cc: 'cc',
  bcc: 'bcc',
  reply_to: 'reply_to',
} as const;

export interface EmailGroupRoleOut {
  email_group_id: string;
  role: EmailSettingsRole;
  name: string;
}

export interface EmailIn {
  recipients: string[];
  subject: string;
  body: string;
  cc: string[];
  bcc?: string[] | null;
  sender: string | null;
  invoices?: string[] | null;
  attach_invoice?: boolean;
  attach_invoice_attachments?: boolean;
  statement_type?: StatementType | null;
  activity_statement_months?: number;
  statement_formats: StatementFormat[];
  priority?: number | null;
}

export type EmailInboxSharing = typeof EmailInboxSharing[keyof typeof EmailInboxSharing];


export const EmailInboxSharing = {
  none: 'none',
  thread: 'thread',
  all: 'all',
} as const;

export interface EmailSettingsIn {
  id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  share_inbox?: EmailInboxSharing | null;
  signature?: string | null;
  signature_html?: string | null;
  share_sending?: boolean | null;
}

export type EmailSettingsStatus = typeof EmailSettingsStatus[keyof typeof EmailSettingsStatus];


export const EmailSettingsStatus = {
  receive_only: 'receive_only',
  pending: 'pending',
  success: 'success',
  error: 'error',
} as const;

export interface EmailSettingsOut {
  id: string;
  email_account: EmailAccountOut | null;
  email: string;
  first_name: string | null;
  last_name: string | null;
  share_inbox: EmailInboxSharing;
  share_sending: boolean;
  roles: EmailGroupRoleOut[];
  signature: string | null;
  signature_html: string | null;
  last_attempted_provider: Provider | null;
  avatar: string | null;
  status: EmailSettingsStatus;
}

export interface EnrollIn {
  invoices: string[];
  customers: string[];
}

export interface EventCustomer {
  name: string | null;
  id: string;
  provider: Provider | null;
  external_id: string | null;
}

export interface EventIn {
  event_ids: string[];
  read_status?: EventReadStatus | null;
  snooze_until?: string | null;
}

export interface EventInvoiceOut {
  id: string;
  number: string;
  status: InvoiceStatus;
}

export interface ExtractedContact {
  first_name: string | null;
  last_name: string | null;
  email: string;
}

export interface Extracted {
  contacts: ExtractedContact[];
}

export type PaymentFeeType = typeof PaymentFeeType[keyof typeof PaymentFeeType];


export const PaymentFeeType = {
  fixed_percentage: 'fixed_percentage',
  fixed_amount: 'fixed_amount',
  percent_pa: 'percent_pa',
  bank_of_england_plus: 'bank_of_england_plus',
} as const;

export interface FeeConfigInput {
  payment_fee_type: PaymentFeeType;
  amount: number | string;
  days_after_due: number;
  when_amount_above?: number | string | null;
}

export interface FeeConfigOutput {
  payment_fee_type: PaymentFeeType;
  amount: string;
  days_after_due: number;
  when_amount_above?: string | null;
}

export interface FeeInvoiceDetailsOut {
  id: string;
  number: string;
  external_id: string;
  amount_due: number;
  due: string;
  reference: string | null;
  in_dispute: boolean;
  currency: string;
  posted_at: string | null;
  paid_at: string | null;
  total_amount: number;
  amount_paid: number;
  currency_rate: number | null;
  expected_payment_date: string | null;
  type: Provider;
  next_action: InvoiceNextAction | null;
  organization: SimpleOrganizationSchema;
  manual_enrolled_id: string | null;
  next_event_at?: string | null;
  next_chase?: NextInvoiceChase | null;
  status?: InvoiceStatus | null;
  account_id?: string | null;
  customer: SimpleCustomerWithPausedState | null;
  workflow?: SimpleWorkflow | null;
  activity_status?: ActivityStatus | null;
  personal_reminder?: PersonalEventOut | null;
  has_payment_plan?: boolean;
  days_overdue?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  recent_activity?: EventSummary[] | null;
  note_summary?: string | null;
  last_contacted?: EventSummary | null;
  custom_fields: CustomFieldOut[];
  parents: SimpleCustomer[];
  portal_url: string | null;
  frequency: string | null;
  payment_fee_for: SimpleInvoice;
  readonly total_amount_internal: number;
  readonly amount_due_internal: number;
}

export interface FeePreviewOut {
  payment_fee_type: PaymentFeeType;
  amount: string;
  days_after_due: number;
  when_amount_above?: string | null;
  total_amount: string;
  description: string;
}

export interface FieldDef {
  label: string;
  operators: WorkflowRuleOperator[];
}

export interface FiltersOutput {
  combinator: Combinator;
  rules: (Filter | FiltersOutput)[];
}

export type Font = typeof Font[keyof typeof Font];


export const Font = {
  Segoe_UI: 'Segoe UI',
  SF_Pro: 'SF Pro',
  Aptos: 'Aptos',
  Arial: 'Arial',
  Helvetica: 'Helvetica',
  Verdana: 'Verdana',
  Tahoma: 'Tahoma',
  Trebuchet_MS: 'Trebuchet MS',
  Geneva: 'Geneva',
  Calibri: 'Calibri',
  Candara: 'Candara',
  Franklin_Gothic: 'Franklin Gothic',
  Century_Gothic: 'Century Gothic',
  Avant_Garde: 'Avant Garde',
  Futura: 'Futura',
  Times_New_Roman: 'Times New Roman',
  Georgia: 'Georgia',
  Garamond: 'Garamond',
  Palatino: 'Palatino',
  Book_Antiqua: 'Book Antiqua',
  Baskerville: 'Baskerville',
  Cambria: 'Cambria',
  Didot: 'Didot',
  Bodoni: 'Bodoni',
  Rockwell: 'Rockwell',
  Courier: 'Courier',
  Consolas: 'Consolas',
  Monaco: 'Monaco',
  Lucida_Console: 'Lucida Console',
  Menlo: 'Menlo',
  SF_Mono: 'SF Mono',
  Cascadia_Code: 'Cascadia Code',
  Impact: 'Impact',
  Copperplate: 'Copperplate',
  Optima: 'Optima',
  Gill_Sans: 'Gill Sans',
} as const;

export type FormattingInvoiceCustom = {[key: string]: string};

export interface FormattingInvoice {
  id: string;
  number: string;
  due: string;
  amountDue: string;
  invoiceUrl: string;
  dueDaysAgo: string;
  allPreviousEmailDates: string;
  custom: FormattingInvoiceCustom;
}

export interface GenerateEmail {
  subject: string;
  body: string;
}

export interface GenerateEmails {
  single_outstanding: GenerateEmail;
  multiple_outstanding: GenerateEmail;
}

export type TriggerType = typeof TriggerType[keyof typeof TriggerType];


export const TriggerType = {
  days_passed: 'days_passed',
  debt_paid: 'debt_paid',
  calendar_day: 'calendar_day',
  subscription_renewal: 'subscription_renewal',
} as const;

export type RecipientType = typeof RecipientType[keyof typeof RecipientType];


export const RecipientType = {
  default: 'default',
  escalation: 'escalation',
  custom: 'custom',
} as const;

export type WorkflowActionMedium = typeof WorkflowActionMedium[keyof typeof WorkflowActionMedium];


export const WorkflowActionMedium = {
  email: 'email',
  phone: 'phone',
  sms: 'sms',
  letter: 'letter',
} as const;

export type WorkflowActionMatchesStatus = typeof WorkflowActionMatchesStatus[keyof typeof WorkflowActionMatchesStatus];


export const WorkflowActionMatchesStatus = {
  paid: 'paid',
  overdue: 'overdue',
  upcoming: 'upcoming',
  late_fee: 'late_fee',
} as const;

export type WorkflowActionSchedule = typeof WorkflowActionSchedule[keyof typeof WorkflowActionSchedule];


export const WorkflowActionSchedule = {
  immediate: 'immediate',
  follow: 'follow',
  no_group: 'no_group',
} as const;

export interface WorkflowActionIn {
  id: string | null;
  workflow_id: string;
  trigger: TriggerType;
  sender_group_id: string | null;
  recipient: RecipientType;
  custom_recipient: string[] | null;
  custom_sender: string | null;
  cc: string[];
  bcc: string[];
  days_passed: number;
  medium: WorkflowActionMedium;
  document_id?: string | null;
  single_template_id: string | null;
  multi_template_id: string | null;
  matches_status: WorkflowActionMatchesStatus[];
  follow_schedule?: WorkflowActionSchedule | null;
}

export interface GenerateParams {
  prompt: string;
  action: WorkflowActionIn;
}

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export type HandleReplyStep = typeof HandleReplyStep[keyof typeof HandleReplyStep];


export const HandleReplyStep = {
  send_reply: 'send_reply',
  set_expected_payment_date: 'set_expected_payment_date',
  add_new_contacts: 'add_new_contacts',
  update_broken_contact: 'update_broken_contact',
  create_subcustomer: 'create_subcustomer',
} as const;

export interface SmsDetailOut {
  id: string;
  sent_at?: string | null;
  sender: string | null;
  twilio_settings_id: string | null;
  recipient: string | null;
  message: string;
  attachments: AttachmentSchema[];
}

export interface InboundCallEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_call';
  status: EventReadStatusOut;
  sms: SmsDetailOut;
}

export interface InboundEmailEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_email';
  status: EventReadStatusOut;
  email: EmailDetailsOut;
}

export interface InboundSmsEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'inbound_sms';
  status: EventReadStatusOut;
  sms: SmsDetailOut;
}

export interface InvoiceDetailsOut {
  id: string;
  number: string;
  external_id: string;
  amount_due: number;
  due: string;
  reference: string | null;
  in_dispute: boolean;
  currency: string;
  posted_at: string | null;
  paid_at: string | null;
  total_amount: number;
  amount_paid: number;
  currency_rate: number | null;
  expected_payment_date: string | null;
  type: Provider;
  next_action: InvoiceNextAction | null;
  organization: SimpleOrganizationSchema;
  manual_enrolled_id: string | null;
  next_event_at?: string | null;
  next_chase?: NextInvoiceChase | null;
  status?: InvoiceStatus | null;
  account_id?: string | null;
  customer: SimpleCustomerWithPausedState | null;
  workflow?: SimpleWorkflow | null;
  activity_status?: ActivityStatus | null;
  personal_reminder?: PersonalEventOut | null;
  has_payment_plan?: boolean;
  days_overdue?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  recent_activity?: EventSummary[] | null;
  note_summary?: string | null;
  last_contacted?: EventSummary | null;
  custom_fields: CustomFieldOut[];
  parents: SimpleCustomer[];
  portal_url: string | null;
  frequency: string | null;
  readonly total_amount_internal: number;
  readonly amount_due_internal: number;
}

export interface InvoiceIn {
  id: string;
  excluded?: boolean | null;
}

export interface InvoiceOutcome {
  month: string;
  unchased_paid: number;
  chased_paid: number;
  unpaid: number;
}

export interface InvoiceOutcomes {
  currency: string | null;
  months: InvoiceOutcome[];
}

export interface LabelId {
  label: string;
  id: string;
}

export interface LaneCustomerIn {
  lane_id: string | null;
  customer_id: string;
  weight: number;
}

export interface RulesInput {
  combinator: Combinator;
  rules: (Rule | RulesInput)[];
}

export interface LaneIn {
  id: string | null;
  name: string;
  criteria?: RulesInput | null;
}

export type TemplateAify = typeof TemplateAify[keyof typeof TemplateAify];


export const TemplateAify = {
  vary: 'vary',
  none: 'none',
} as const;

export interface TemplateFragment {
  content: string[];
  aify: TemplateAify;
}

export interface TemplateIn {
  id?: string | null;
  name?: string | null;
  subject: TemplateFragment;
  body: TemplateFragment[];
  attach_invoice?: boolean;
  attach_invoice_attachments?: boolean;
  statement_type?: StatementType | null;
  activity_statement_months?: number;
  include_partial?: boolean;
  statement_formats: StatementFormat[];
  priority?: number | null;
  matches_status: WorkflowActionMatchesStatus[];
}

export interface LetterPreviewIn {
  action: WorkflowActionIn;
  template: TemplateIn;
  in_state: ActionStatus;
}

export interface LineItemOut {
  id: string;
  description: string;
  quantity: number;
  amount_tax: number | null;
  total_amount: number;
}

export interface MakeAndSendSms {
  customer_id: string | null;
  message: string;
  sender: string;
  recipient: string;
  invoices?: string[] | null;
  in_reply_to: string | null;
  set_as_contact?: string | null;
}

export interface MonthlyDSOOut {
  dso_days: number;
  month: string;
}

export interface NoteOut {
  id: string;
  type: string | null;
  text: string;
  trigger_at: string;
  published: boolean;
  user_id: string | null;
  username: string;
}

export interface NoteEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'note';
  status: NoteStatus;
  note: NoteOut[];
}

export type NoteTroveType = typeof NoteTroveType[keyof typeof NoteTroveType];


export const NoteTroveType = {
  Note: 'Note',
  Email: 'Email',
  Phone: 'Phone',
  Letter: 'Letter',
  Payment: 'Payment',
  Change_payment_date: 'Change payment date',
  Excluded_customer: 'Excluded customer',
  Enrolled_customer: 'Enrolled customer',
  Excluded_invoice: 'Excluded invoice',
  Enrolled_invoice: 'Enrolled invoice',
  Marked_disputed: 'Marked disputed',
  Dispute_removed: 'Dispute removed',
  Other: 'Other',
} as const;

export type NotePublishType = typeof NotePublishType[keyof typeof NotePublishType];


export const NotePublishType = {
  customer: 'customer',
  invoice: 'invoice',
} as const;

export interface NoteIn {
  event_id?: string | null;
  type: NoteTroveType | string;
  customer_id: string | null;
  publish: boolean;
  publish_type?: NotePublishType | null;
  invoice_ids: string[];
  expected_payment_date?: string | null;
  notify_date?: string | null;
  notify_emails?: string[] | null;
  next_action?: InvoiceNextAction | null;
  text?: string | null;
  workflow_id?: string | null;
  trigger_at?: string | null;
}

export type NotificationFrequency = typeof NotificationFrequency[keyof typeof NotificationFrequency];


export const NotificationFrequency = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export const NotificationType = {
  scheduled_messages: 'scheduled_messages',
  report: 'report',
} as const;

export type Weekday = typeof Weekday[keyof typeof Weekday];


export const Weekday = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday',
} as const;

export interface NotificationIn {
  id?: string | null;
  type: NotificationType;
  emails: EmailIdentityOut[];
  slack_channels: SlackChannel[];
  frequency: NotificationFrequency | null;
  hours_before?: number | null;
  time_of_day: string | null;
  day_of_week: Weekday | null;
  day_of_month: number | null;
  report: string;
}

export interface NotificationOut {
  id: string;
  type: NotificationType;
  emails: EmailIdentityOut[];
  slack_channels: SlackChannel[];
  frequency: NotificationFrequency | null;
  hours_before?: number | null;
  time_of_day: string | null;
  day_of_week: Weekday | null;
  day_of_month: number | null;
}

export interface NotificationProviderOut {
  id: string;
  name: string;
  provider: Provider;
}

export interface SubOrganization {
  id: string;
  external_id: string;
  name: string;
  logo: string | null;
  integrations: AccountOut[];
  default_sender: EmailSettingsOut | null;
  next_run?: string | null;
  customers: number;
  pending: number;
  workflow_count: number;
  is_multitenant: boolean;
}

export interface OrganizationAdmin {
  id: string;
  seats: number;
  trial_end: string;
  sub_organizations: SubOrganization[];
}

export interface TableDisplay {
  key: string;
  setting: string;
}

export interface OrganizationIn {
  post_note_about_email?: boolean | null;
  publish_notes_by_default?: boolean | null;
  visible_activity_categories?: ActivityCategory[] | null;
  font_name?: Font | null;
  font_size?: number | null;
  font_color?: string | null;
  microsoft_include_prompt?: boolean | null;
  locale?: string | null;
  outbox_notification?: boolean | null;
  inbox_notification?: boolean | null;
  default_customer_address?: string | null;
  table_display?: TableDisplay[] | null;
}

export interface OrganizationOut {
  id: string;
  external_id: string;
  name: string;
  parent_account_id: string | null;
  logo: string | null;
  post_note_about_email: boolean;
  publish_notes_by_default: boolean;
  visible_activity_categories: ActivityCategory[];
  font_name?: Font | null;
  font_size?: number | null;
  font_color?: string | null;
  mark_new_invoices_excluded: boolean;
  mark_new_customers_paused: boolean;
  statement_to_paused_customers: boolean;
  statement_about_excluded_invoices: boolean;
  locale: string;
  is_rescheduling: boolean;
  outbox_notification: boolean;
  inbox_notification: boolean;
  default_customer_address: string;
  table_display?: TableDisplay[] | null;
}

export interface OutboundEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_email';
  status: EventStatusOut;
  email: EmailDetailsOut;
}

export interface OutboundLetterEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_letter';
  status: EventStatusOut;
  email: EmailDetailsOut;
}

export interface OutboundSmsEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'outbound_sms';
  status: EventStatusOut;
  sms: SmsDetailOut;
}

export interface OverpaymentOut {
  id: string;
  type?: 'overpayment';
  external_id: string;
  customer: SimpleCustomerWithPausedState;
  currency: string;
  reference: string | null;
  number?: string;
  amount_remaining: number;
  total_amount: number;
  posted_at: string;
}

export interface ParentCustomerHistoryOut {
  id: string;
  state: SubcustomerHistoryState;
  field_value: string;
  invoice: SimpleInvoice;
  parent_customer: SimpleCustomer | null;
  extracted: Extracted;
  subcustomer: SimpleCustomer;
}

export interface ParentCustomerIn {
  parent_customer_id: string | null;
  parent_customer_name: string;
  note: string | null;
}

export interface PauseIn {
  starts_at: string;
  ends_at: string;
}

export interface PauseOut {
  id: string;
  starts_at: string;
  ends_at: string;
}

export interface PaymentFeeCreateIn {
  workflow_id: string | null;
  customer_id: string;
  invoice_id: string;
  description: string;
  categorized_as: string;
  as_draft: boolean;
  starting_from: string;
  fees: FeeConfigInput[];
}

export interface PaymentFeeSettingsIn {
  description: string;
  categorized_as: string;
  start_when_overdue_days: number;
  as_draft: boolean;
  fees: FeeConfigInput[];
}

export interface PaymentFeeSettingsOut {
  id: string;
  description: string;
  categorized_as: string;
  start_when_overdue_days: number;
  as_draft: boolean;
  workflow_id?: string | null;
  fees: FeeConfigOutput[];
}

export type PaymentPlanFrequency = typeof PaymentPlanFrequency[keyof typeof PaymentPlanFrequency];


export const PaymentPlanFrequency = {
  weekly: 'weekly',
  fortnightly: 'fortnightly',
  monthly: 'monthly',
  quarterly: 'quarterly',
} as const;

export interface PaymentPlanInstallmentIn {
  to_pay_at: string;
  total_amount: number;
}

export type PaymentPlanState = typeof PaymentPlanState[keyof typeof PaymentPlanState];


export const PaymentPlanState = {
  pending: 'pending',
  success: 'success',
  superseded: 'superseded',
} as const;

export interface PaymentPlanIn {
  id?: string | null;
  customer_id: string;
  invoice_ids: string[];
  installments: PaymentPlanInstallmentIn[];
  state: PaymentPlanState;
}

export interface PaymentPlanInstallmentOut {
  to_pay_at: string;
  total_amount: number;
  amount_paid: number;
  amount_due: number;
}

export interface PaymentPlanOut {
  id: string;
  customer: SimpleCustomer;
  invoices: SimpleInvoice[];
  installments: PaymentPlanInstallmentOut[];
  paid_installments: number;
  is_on_track: boolean;
}

export interface PaymentPlanSettingsIn {
  frequency: PaymentPlanFrequency;
  installments: number;
}

export interface PaymentPlanSettingsOut {
  id: string;
  frequency: PaymentPlanFrequency;
  installments: number;
}

export const PersonalReminderEventDetailsOutStatus = {...EventStatusOut,...EventReadStatusOut,} as const
export interface PersonalReminderEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'personal_reminder';
  status: typeof PersonalReminderEventDetailsOutStatus[keyof typeof PersonalReminderEventDetailsOutStatus];
  email: EmailDetailsOut;
}

export interface PhoneIn {
  id: string | null;
  type: PhoneType;
  number: string;
}

export const PhoneReminderEventDetailsOutStatus = {...EventStatusOut,...NoteStatus,} as const
export interface PhoneReminderEventDetailsOut {
  id: string;
  trigger_at: string;
  snooze_until: string | null;
  type?: string | null;
  sent_at?: string | null;
  customer: EventCustomer | null;
  invoices: EventInvoiceOut[];
  title?: string | null;
  workflow?: SimpleWorkflow | null;
  sender?: string | null;
  recipient?: string[] | null;
  contacts?: string[] | null;
  anything_unpublished?: boolean;
  personal_reminder?: PersonalEventOut | null;
  is_bouncing?: boolean;
  has_reply?: string | null;
  has_steps?: number | null;
  subcustomer_state?: SubcustomerHistoryState | null;
  email_settings_id?: string | null;
  custom_fields: CustomFieldOut[];
  kind: 'phonecall_reminder';
  status: typeof PhoneReminderEventDetailsOutStatus[keyof typeof PhoneReminderEventDetailsOutStatus];
  email: EmailDetailsOut;
  note: NoteOut[];
}

export interface PinNoteIn {
  event_id: string;
}

export interface Plan {
  plan_name: string;
  parent_name?: string | null;
  trial_end: string;
}

export interface PortalOrganizationOut {
  name: string;
  logo: string | null;
}

export interface PortalCustomerOut {
  organization: PortalOrganizationOut;
  name: string;
}

export interface PortalInstallmentDetailsOut {
  id: string;
  number: string;
  status: InvoiceStatus;
  currency: string;
  due: string;
  amount_paid: number;
  amount_due: number;
  total_amount: number;
  invoices: SimpleInvoice[];
  nth: number;
  total: number;
}

export interface PortalInstallmentOut {
  id: string;
  number: string;
  status: InvoiceStatus;
  currency: string;
  due: string;
  amount_paid: number;
  amount_due: number;
  total_amount: number;
}

export interface PortalInvoiceDetailsOut {
  id: string;
  number: string;
  status: InvoiceStatus;
  currency: string;
  posted_at: string;
  due: string;
  amount_paid: number;
  amount_due: number;
  total_amount: number;
  line_items: LineItemOut[] | null;
}

export interface PortalInvoiceOut {
  id: string;
  number: string;
  status: InvoiceStatus;
  currency: string;
  posted_at: string;
  due: string;
  amount_paid: number;
  amount_due: number;
  total_amount: number;
}

export interface PortalPlanOut {
  id: string;
  invoices: SimpleInvoice[];
  installments: PortalInstallmentOut[];
}

export interface PortalInvoices {
  invoices: PortalInvoiceOut[];
  plans: PortalPlanOut[];
}

export type RenderArgsCustom = {[key: string]: string};

export interface RenderArgs {
  customerName: string;
  customerAccountNumber: string;
  contactLastName: string;
  myEmail: string;
  myFirstName: string;
  myLastName: string;
  myOrganizationName: string;
  totalAmountDue: string;
  totalInvoicesDue: string;
  previousEmailDate: string;
  invoices: FormattingInvoice[];
  overdueInvoices: FormattingInvoice[];
  upcomingInvoices: FormattingInvoice[];
  unpaidInvoices: FormattingInvoice[];
  paidInvoices: FormattingInvoice[];
  allPreviousEmailDates: string;
  number: string;
  overdueNumbers: string;
  upcomingNumbers: string;
  unpaidNumbers: string;
  paidNumbers: string;
  due: string;
  amountDue: string;
  invoiceUrl: string;
  dueDaysAgo: string;
  portalUrl: string;
  invoicesTable: string;
  overdueInvoicesTable: string;
  upcomingInvoicesTable: string;
  unpaidInvoicesTable: string;
  paidInvoicesTable: string;
  custom: RenderArgsCustom;
  contactName: string;
  contactFirstName: string;
}

export interface PreviewOut {
  single_missed: RenderArgs;
  multiple_missed: RenderArgs;
  base_label: string;
}

export type PricingFeature = typeof PricingFeature[keyof typeof PricingFeature];


export const PricingFeature = {
  statements: 'statements',
  multi_account: 'multi_account',
  bill_child_organizations: 'bill_child_organizations',
  chase: 'chase',
  premium_integrations: 'premium_integrations',
  api: 'api',
  auto_subcompanies: 'auto_subcompanies',
  custom_grouping: 'custom_grouping',
  beta: 'beta',
  cross_organization_invoices: 'cross_organization_invoices',
  uk_letters: 'uk_letters',
  onboarding: 'onboarding',
  attachments: 'attachments',
} as const;

export type PricingStatusStatus = typeof PricingStatusStatus[keyof typeof PricingStatusStatus];


export const PricingStatusStatus = {
  OK: 'OK',
  SOFT_ERROR: 'SOFT_ERROR',
  ERROR: 'ERROR',
  TRIAL: 'TRIAL',
} as const;

export interface PricingStatus {
  status: PricingStatusStatus;
  features: PricingFeature[];
  main_account: string | null;
  trial_end: string | null;
}

export interface QuestionAnswer {
  question: string;
  answer: string;
}

export interface RecoveredRevenueEntry {
  id: string;
  number: string;
  customer: SimpleCustomer;
  amount: CurrencyAmount;
  first_chased_at: string;
  paid_at: string;
}

export interface RecoveredRevenueOut {
  entries: RecoveredRevenueEntry[];
  totals: CurrencyAmount[];
}

export type ReportDetailsOutColumnSizing = {[key: string]: number};

export interface ReportDetailsOut {
  id: string;
  entity: ReportableEntity;
  name: string;
  description: string;
  sorting: ColumnSort[];
  filters: FiltersOutput;
  columns: Column[];
  column_sizing: ReportDetailsOutColumnSizing;
  notifications?: NotificationOut[] | null;
}

export interface ReportOut {
  id: string;
  entity: ReportableEntity;
  name: string;
  description: string;
  last_sent_at: string | null;
}

export interface RulesTrace {
  outcome: boolean | null;
  rules: RulesTrace[] | null;
}

export interface ScheduleIn {
  weekdays?: Weekday[] | null;
  working_weekdays?: Weekday[] | null;
  timezone?: string | null;
  run_time?: string | null;
  warnings_before?: number | null;
  working_hours_start?: string | null;
  working_hours_end?: string | null;
}

export interface ScheduleOut {
  weekdays: Weekday[];
  timezone: string;
  warnings_before: number;
  run_time: string;
  working_hours_start: string;
  working_hours_end: string;
  working_weekdays: Weekday[];
}

export type SearchResultType = typeof SearchResultType[keyof typeof SearchResultType];


export const SearchResultType = {
  invoice: 'invoice',
  event: 'event',
  customer: 'customer',
  contact: 'contact',
} as const;

export interface SearchOut {
  title: string;
  type: SearchResultType;
  id: string;
}

export interface SetAction {
  action_id: string;
  invoice_id: string;
  event_id: string | null;
}

export interface SmsIn {
  recipient: string;
  message: string;
  invoices?: string[] | null;
}

export interface StatementOut {
  id: string;
  type: StatementType;
  statement: string | null;
  display_name: string | null;
  total_due: number;
  currency: string;
  recipient: string[];
  date: string;
}

export type SubcustomerDirection = typeof SubcustomerDirection[keyof typeof SubcustomerDirection];


export const SubcustomerDirection = {
  up: 'up',
  down: 'down',
} as const;

export interface SubcustomerExtract {
  entity: WorkflowRuleEntity;
  field: string;
}

export interface SubcustomerHistoryOut {
  id: string;
  state: SubcustomerHistoryState;
  field_value: string;
  invoice: SimpleInvoice;
  parent_customer: SimpleCustomer;
  extracted: Extracted;
  subcustomer: SimpleCustomer | null;
}

export interface SubcustomerIn {
  contact: string | null;
  invoices: string[];
  note: string | null;
}

export interface SubcustomerSettingsOutInput {
  rules: RulesInput;
  extract: SubcustomerExtract;
  automatic: boolean;
  direction: SubcustomerDirection;
}

export interface SubcustomerSettingsOutOutput {
  rules: RulesOutput;
  extract: SubcustomerExtract;
  automatic: boolean;
  direction: SubcustomerDirection;
}

export type SupportedFields = Partial<Record<WorkflowRuleEntity, {[key: string]: FieldDef}>>;

export interface TaskActionsOut {
  status: HandleReplyStep;
  tasks: ActionOut[];
}

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];


export const TaskStatus = {
  auto_approved: 'auto_approved',
  approved: 'approved',
  unapproved_overdue: 'unapproved_overdue',
  no_sender: 'no_sender',
  invalid_recipient: 'invalid_recipient',
} as const;

export interface TaskEventsOut {
  status: TaskStatus;
  tasks: (OutboundEventOut | OutboundLetterEventOut | OutboundSmsEventOut | PhoneReminderEventOut | PersonalReminderEventOut)[];
}

export interface TasksOut {
  events: TaskEventsOut[];
  actions: TaskActionsOut[];
  custom_fields?: CustomFieldDefinition[] | null;
}

export interface TemplateDetailsOut {
  id?: string | null;
  subject: TemplateFragment;
  body: TemplateFragment[];
  used_in: SimpleWorkflowAction[];
  name?: string | null;
  attach_invoice: boolean;
  attach_invoice_attachments: boolean;
  statement_type: StatementType | null;
  activity_statement_months: number;
  include_partial: boolean;
  statement_formats: StatementFormat[];
  matches_status: WorkflowActionMatchesStatus[];
  priority: number;
}

export interface TemplateOut {
  id: string;
  name: string | null;
  subject: TemplateFragment;
  body: TemplateFragment[];
  used_in_workflow: number;
}

export interface TenantOption {
  name: string;
  id: string;
  exists: boolean;
}

export interface TestEmailOptions {
  font_name?: Font | null;
  font_size?: number | null;
  font_color?: string | null;
}

export interface ToNotify {
  new_incoming: number;
  outbox_due: number;
}

export interface TwilioSettingsOut {
  id: string;
  phone_number: string;
  monthly_usage: number;
  workflows: SimpleWorkflow[];
}

export interface VerifiedDomainOut {
  domains: string[];
}

export interface WorkflowActionTemplateOut {
  template_name: string;
  id: string;
}

export interface WorkflowActionOut {
  id: string;
  trigger: TriggerType;
  days_passed: number;
  label: string;
  recipient: RecipientType;
  custom_recipient: string[] | null;
  cc: string[];
  bcc: string[];
  sender_group_id?: string | null;
  custom_sender_id?: string | null;
  workflow_id?: string | null;
  medium: WorkflowActionMedium;
  document_id?: string | null;
  follow_schedule: WorkflowActionSchedule | null;
  payment_fee_settings?: PaymentFeeSettingsOut | null;
  single_template: WorkflowActionTemplateOut | null;
  multi_template: WorkflowActionTemplateOut | null;
  matches_status: WorkflowActionMatchesStatus[];
}

export type WorkflowRole = typeof WorkflowRole[keyof typeof WorkflowRole];


export const WorkflowRole = {
  statements_only: 'statements_only',
  chase_flow: 'chase_flow',
  debt_recovery: 'debt_recovery',
  late_payment_fee: 'late_payment_fee',
} as const;

export interface WorkflowAdmin {
  id: string;
  name: string;
  description: string | null;
  state: WorkflowState;
  role: WorkflowRole | null;
  no_enrolled: number;
  enable_subscriptions: boolean;
  is_default: boolean;
  say_thanks_only_after_chase: boolean;
  reschedule_last_step_forever: boolean;
  organization: SimpleOrganizationSchema;
}

export interface WorkflowClone {
  source: string;
  target: string;
}

export interface WorkflowIn {
  id?: string | null;
  state?: WorkflowState | null;
  name?: string | null;
  description?: string | null;
  clone_from?: string | null;
  role?: WorkflowRole | null;
  enable_subscriptions?: boolean | null;
  is_default?: boolean | null;
  say_thanks_only_after_chase?: boolean | null;
  reschedule_last_step_forever?: boolean | null;
  priority?: number | null;
}

export interface WorkflowOut {
  id: string;
  name: string;
  description: string | null;
  state: WorkflowState;
  role: WorkflowRole | null;
  no_enrolled: number;
  enable_subscriptions: boolean;
  is_default: boolean;
  say_thanks_only_after_chase: boolean;
  reschedule_last_step_forever: boolean;
}

/**
 * Available EventKind values
 */
export type EventKind = typeof EventKind[keyof typeof EventKind];


export const EventKind = {
  inbound_email: 'inbound_email',
  outbound_email: 'outbound_email',
  note: 'note',
  personal_reminder: 'personal_reminder',
  phonecall_reminder: 'phonecall_reminder',
  inbound_sms: 'inbound_sms',
  outbound_sms: 'outbound_sms',
  inbound_call: 'inbound_call',
  outbound_letter: 'outbound_letter',
} as const;

export type AddIntegrationParams = {
redirect_to: string;
api?: string | null;
email_settings_id?: string | null;
};

export type SignupParams = {
redirect_to?: string | null;
};

export type LinkOrganizationsParams = {
parent_id: string;
};

export type UnlinkOrganizationsParams = {
child_id: string;
};

export type GetFontFamilyParams = {
font?: Font | null;
};

export type GetTerritoriesParams = {
language?: string | null;
};

export type GetTasksParams = {
search?: string | null;
for_date?: string | null;
};

export type GetEventsParams = {
offset?: number;
limit?: number;
search?: string | null;
};

export type GetActivityReportParams = {
end_date: string;
};

export type ExecuteEventParams = {
only_mark_as_sent?: boolean;
};

export type RecoveredRevenueParams = {
start: string;
end: string;
};

export type GetCustomersParams = {
/**
 * @minimum 0
 */
offset?: number;
/**
 * @exclusiveMinimum 0
 */
limit?: number;
search?: string | null;
};

export type DeleteWorkflowParams = {
include_templates?: boolean;
};

export type GetEmailsParams = {
include_users?: boolean;
};

export type TopParams = {
query: string;
};

export type GetTemplatesParams = {
medium?: WorkflowActionMedium | null;
in_state?: ActionStatus | null;
trigger?: TriggerType | null;
days_passed?: number | null;
};

export type GetVariablesParams = {
customer_id: string;
matches_status: WorkflowActionMatchesStatus[];
invoice_ids?: string[] | null;
};

export type GetUpdatedInvoiceSummaryParams = {
invoice_ids: string[];
};

export type GetUpdatedInvoiceSummary200 = {[key: string]: string | null};

export type GetCreditsParams = {
customer_id?: string | null;
};

export type GetInvoicesParams = {
offset?: number;
limit?: number;
search?: string | null;
};

export type GetRuleFieldsParams = {
workflow_id?: string | null;
};

export type GetFieldAlternativesParams = {
workflow_id?: string | null;
selected?: string[] | null;
search?: string | null;
};

export type TraceParams = {
invoice_id: string;
};

export type GetStatementsParams = {
customer?: string | null;
};

export type GetStatementParams = {
type: StatementType;
request_id: string;
starts_at?: string | null;
ends_at?: string | null;
send_email?: boolean;
};

export type GetActivityDataParams = {
starts_at: string;
ends_at: string;
};

export type PortalParams = {
token: string;
};

export type PortalInvoicesParams = {
token: string;
};

export type PortalInvoiceParams = {
token: string;
};

export type PortalPlanInstallmentParams = {
token: string;
};

export type PortalInvoiceDownloadParams = {
token: string;
};

export type GetReportsParams = {
entity: ReportableEntity;
};

export type GetSubcustomerSettingsParams = {
direction: SubcustomerDirection;
};

export type DeleteSubcustomerSettingsParams = {
direction: SubcustomerDirection;
};

export type GetSubcustomerHistoryParams = {
direction: SubcustomerDirection;
};

export type GetPendingSubcustomerParams = {
invoices: string[];
};

export type GetLaneParams = {
invoice_state: GetLaneInvoiceState;
search?: string | null;
workflow_id?: string | 'excluded' | null;
lane_id: string | 'unassigned' | 'paid';
assignee?: string | 'unassigned' | null;
offset: number;
};

export type GetLaneInvoiceState = typeof GetLaneInvoiceState[keyof typeof GetLaneInvoiceState];


export const GetLaneInvoiceState = {
  overdue: 'overdue',
  outstanding: 'outstanding',
  all: 'all',
} as const;

export type GetBankAccounts200 = {[key: string]: string};

export type GetWorkflowFeesSettingsParams = {
workflow_id?: string | null;
};

export type UpdateWorkflowFeesSettingsParams = {
workflow_id?: string | null;
};

export type DeleteWorkflowFeesSettingsParams = {
workflow_id?: string | null;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Add Integration
 */
export const addIntegration = (
    provider: Provider,
    bodyAddIntegration: BodyType<BodyAddIntegration>,
    params: AddIntegrationParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {

      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append(`token`, bodyAddIntegration.token);

      return customClient<unknown>(
      {url: `/api/auth/initiate/${provider}/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded,
        params, signal
    },
      options);
    }




export const getAddIntegrationMutationKey = () => ['addIntegration'] as const;

export const getAddIntegrationMutationOptions = <TError = unknown | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,AddIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,AddIntegrationMutationVariables, TContext> => {

const mutationKey = getAddIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addIntegration>>, AddIntegrationMutationVariables> = (props) => {
          const {provider,data,params} = props ?? {};

          return  addIntegration(provider,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof addIntegration>>>
    export type AddIntegrationMutationBody = BodyType<BodyAddIntegration>
    export type AddIntegrationMutationError = unknown | HTTPValidationError
    export type AddIntegrationMutationVariables = {provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams}

    /**
 * @summary Add Integration
 */
export const useAddIntegration = <TError = unknown | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,AddIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addIntegration>>,
        TError,
        AddIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getAddIntegrationMutationOptions(options), queryClient);
    }

/**
 * @summary Signup
 */
export const signup = (
    provider: Provider,
    params?: SignupParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/auth/signup/${provider}/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSignupQueryKey = (provider: Provider,
    params?: SignupParams,) => {
    return [
    `/api/auth/signup/${provider}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSignupQueryOptions = <TData = Awaited<ReturnType<typeof signup>>, TError = HTTPValidationError>(provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSignupQueryKey(provider,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof signup>>> = ({ signal }) => signup(provider,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: provider !== null && provider !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SignupQueryResult = NonNullable<Awaited<ReturnType<typeof signup>>>
export type SignupQueryError = HTTPValidationError


export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = HTTPValidationError>(
 provider: Provider,
    params: undefined |  SignupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof signup>>,
          TError,
          Awaited<ReturnType<typeof signup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = HTTPValidationError>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof signup>>,
          TError,
          Awaited<ReturnType<typeof signup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = HTTPValidationError>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Signup
 */

export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = HTTPValidationError>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSignupQueryOptions(provider,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Complete Oauth
 */
export const completeOauth = (
    provider: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/auth/complete/${provider}/`, method: 'GET', signal
    },
      options);
    }




export const getCompleteOauthQueryKey = (provider: string,) => {
    return [
    `/api/auth/complete/${provider}/`
    ] as const;
    }


export const getCompleteOauthQueryOptions = <TData = Awaited<ReturnType<typeof completeOauth>>, TError = HTTPValidationError>(provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompleteOauthQueryKey(provider);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof completeOauth>>> = ({ signal }) => completeOauth(provider, requestOptions, signal);





   return  { queryKey, queryFn, enabled: provider !== null && provider !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompleteOauthQueryResult = NonNullable<Awaited<ReturnType<typeof completeOauth>>>
export type CompleteOauthQueryError = HTTPValidationError


export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = HTTPValidationError>(
 provider: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeOauth>>,
          TError,
          Awaited<ReturnType<typeof completeOauth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = HTTPValidationError>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeOauth>>,
          TError,
          Awaited<ReturnType<typeof completeOauth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = HTTPValidationError>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Complete Oauth
 */

export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = HTTPValidationError>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompleteOauthQueryOptions(provider,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Status
 */
export const status = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PricingStatus>(
      {url: `/api/pricing/status`, method: 'GET', signal
    },
      options);
    }




export const getStatusQueryKey = () => {
    return [
    `/api/pricing/status`
    ] as const;
    }


export const getStatusQueryOptions = <TData = Awaited<ReturnType<typeof status>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof status>>> = ({ signal }) => status(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StatusQueryResult = NonNullable<Awaited<ReturnType<typeof status>>>
export type StatusQueryError = HTTPValidationError


export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Status
 */

export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Plan
 */
export const plan = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Plan>(
      {url: `/api/pricing/plan`, method: 'GET', signal
    },
      options);
    }




export const getPlanQueryKey = () => {
    return [
    `/api/pricing/plan`
    ] as const;
    }


export const getPlanQueryOptions = <TData = Awaited<ReturnType<typeof plan>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof plan>>> = ({ signal }) => plan(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanQueryResult = NonNullable<Awaited<ReturnType<typeof plan>>>
export type PlanQueryError = HTTPValidationError


export function usePlan<TData = Awaited<ReturnType<typeof plan>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof plan>>,
          TError,
          Awaited<ReturnType<typeof plan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlan<TData = Awaited<ReturnType<typeof plan>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof plan>>,
          TError,
          Awaited<ReturnType<typeof plan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlan<TData = Awaited<ReturnType<typeof plan>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Plan
 */

export function usePlan<TData = Awaited<ReturnType<typeof plan>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plan>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Link Organizations
 */
export const linkOrganizations = (
    params: LinkOrganizationsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/admin/organizations/link`, method: 'POST',
        params, signal
    },
      options);
    }




export const getLinkOrganizationsMutationKey = () => ['linkOrganizations'] as const;

export const getLinkOrganizationsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkOrganizations>>, TError,LinkOrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof linkOrganizations>>, TError,LinkOrganizationsMutationVariables, TContext> => {

const mutationKey = getLinkOrganizationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkOrganizations>>, LinkOrganizationsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  linkOrganizations(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkOrganizationsMutationResult = NonNullable<Awaited<ReturnType<typeof linkOrganizations>>>

    export type LinkOrganizationsMutationError = HTTPValidationError
    export type LinkOrganizationsMutationVariables = {params: LinkOrganizationsParams}

    /**
 * @summary Link Organizations
 */
export const useLinkOrganizations = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkOrganizations>>, TError,LinkOrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkOrganizations>>,
        TError,
        LinkOrganizationsMutationVariables,
        TContext
      > => {
      return useMutation(getLinkOrganizationsMutationOptions(options), queryClient);
    }

/**
 * @summary Unlink Organizations
 */
export const unlinkOrganizations = (
    params: UnlinkOrganizationsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/admin/organizations/unlink`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnlinkOrganizationsMutationKey = () => ['unlinkOrganizations'] as const;

export const getUnlinkOrganizationsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkOrganizations>>, TError,UnlinkOrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkOrganizations>>, TError,UnlinkOrganizationsMutationVariables, TContext> => {

const mutationKey = getUnlinkOrganizationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkOrganizations>>, UnlinkOrganizationsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  unlinkOrganizations(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkOrganizationsMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkOrganizations>>>

    export type UnlinkOrganizationsMutationError = HTTPValidationError
    export type UnlinkOrganizationsMutationVariables = {params: UnlinkOrganizationsParams}

    /**
 * @summary Unlink Organizations
 */
export const useUnlinkOrganizations = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkOrganizations>>, TError,UnlinkOrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkOrganizations>>,
        TError,
        UnlinkOrganizationsMutationVariables,
        TContext
      > => {
      return useMutation(getUnlinkOrganizationsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Admin Organizations
 */
export const getAdminOrganizations = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<OrganizationAdmin>(
      {url: `/api/admin/organizations`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminOrganizationsQueryKey = () => {
    return [
    `/api/admin/organizations`
    ] as const;
    }


export const getGetAdminOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizations>>> = ({ signal }) => getAdminOrganizations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizations>>>
export type GetAdminOrganizationsQueryError = HTTPValidationError


export function useGetAdminOrganizations<TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOrganizations<TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOrganizations<TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Organizations
 */

export function useGetAdminOrganizations<TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Subtenants
 */
export const getSubtenants = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<TenantOption[]>(
      {url: `/api/admin/subtenants`, method: 'GET', signal
    },
      options);
    }




export const getGetSubtenantsQueryKey = () => {
    return [
    `/api/admin/subtenants`
    ] as const;
    }


export const getGetSubtenantsQueryOptions = <TData = Awaited<ReturnType<typeof getSubtenants>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubtenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubtenants>>> = ({ signal }) => getSubtenants(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubtenantsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubtenants>>>
export type GetSubtenantsQueryError = HTTPValidationError


export function useGetSubtenants<TData = Awaited<ReturnType<typeof getSubtenants>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubtenants>>,
          TError,
          Awaited<ReturnType<typeof getSubtenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubtenants<TData = Awaited<ReturnType<typeof getSubtenants>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubtenants>>,
          TError,
          Awaited<ReturnType<typeof getSubtenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubtenants<TData = Awaited<ReturnType<typeof getSubtenants>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Subtenants
 */

export function useGetSubtenants<TData = Awaited<ReturnType<typeof getSubtenants>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubtenants>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubtenantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Add Subtenants
 */
export const addSubtenants = (
    tenantOption: BodyType<TenantOption[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/admin/subtenants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantOption, signal
    },
      options);
    }




export const getAddSubtenantsMutationKey = () => ['addSubtenants'] as const;

export const getAddSubtenantsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSubtenants>>, TError,AddSubtenantsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof addSubtenants>>, TError,AddSubtenantsMutationVariables, TContext> => {

const mutationKey = getAddSubtenantsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSubtenants>>, AddSubtenantsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addSubtenants(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSubtenantsMutationResult = NonNullable<Awaited<ReturnType<typeof addSubtenants>>>
    export type AddSubtenantsMutationBody = BodyType<TenantOption[]>
    export type AddSubtenantsMutationError = HTTPValidationError
    export type AddSubtenantsMutationVariables = {data: BodyType<TenantOption[]>}

    /**
 * @summary Add Subtenants
 */
export const useAddSubtenants = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSubtenants>>, TError,AddSubtenantsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSubtenants>>,
        TError,
        AddSubtenantsMutationVariables,
        TContext
      > => {
      return useMutation(getAddSubtenantsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Admin Workflows
 */
export const getAdminWorkflows = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowAdmin[]>(
      {url: `/api/admin/workflows`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminWorkflowsQueryKey = () => {
    return [
    `/api/admin/workflows`
    ] as const;
    }


export const getGetAdminWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminWorkflows>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminWorkflowsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminWorkflows>>> = ({ signal }) => getAdminWorkflows(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminWorkflows>>>
export type GetAdminWorkflowsQueryError = HTTPValidationError


export function useGetAdminWorkflows<TData = Awaited<ReturnType<typeof getAdminWorkflows>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAdminWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminWorkflows<TData = Awaited<ReturnType<typeof getAdminWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAdminWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminWorkflows<TData = Awaited<ReturnType<typeof getAdminWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Workflows
 */

export function useGetAdminWorkflows<TData = Awaited<ReturnType<typeof getAdminWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminWorkflowsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Doesn't actually support all of WorkflowIn, just state.
 * @summary Update Admin Workflow
 */
export const updateAdminWorkflow = (
    workflowIn: BodyType<WorkflowIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/admin/workflows`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workflowIn, signal
    },
      options);
    }




export const getUpdateAdminWorkflowMutationKey = () => ['updateAdminWorkflow'] as const;

export const getUpdateAdminWorkflowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminWorkflow>>, TError,UpdateAdminWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminWorkflow>>, TError,UpdateAdminWorkflowMutationVariables, TContext> => {

const mutationKey = getUpdateAdminWorkflowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminWorkflow>>, UpdateAdminWorkflowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminWorkflow>>>
    export type UpdateAdminWorkflowMutationBody = BodyType<WorkflowIn>
    export type UpdateAdminWorkflowMutationError = HTTPValidationError
    export type UpdateAdminWorkflowMutationVariables = {data: BodyType<WorkflowIn>}

    /**
 * @summary Update Admin Workflow
 */
export const useUpdateAdminWorkflow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminWorkflow>>, TError,UpdateAdminWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminWorkflow>>,
        TError,
        UpdateAdminWorkflowMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminWorkflowMutationOptions(options), queryClient);
    }

/**
 * @summary Clone Admin Workflow
 */
export const cloneAdminWorkflow = (
    workflowClone: BodyType<WorkflowClone>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/admin/workflows/clone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowClone, signal
    },
      options);
    }




export const getCloneAdminWorkflowMutationKey = () => ['cloneAdminWorkflow'] as const;

export const getCloneAdminWorkflowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAdminWorkflow>>, TError,CloneAdminWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneAdminWorkflow>>, TError,CloneAdminWorkflowMutationVariables, TContext> => {

const mutationKey = getCloneAdminWorkflowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneAdminWorkflow>>, CloneAdminWorkflowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cloneAdminWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneAdminWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof cloneAdminWorkflow>>>
    export type CloneAdminWorkflowMutationBody = BodyType<WorkflowClone>
    export type CloneAdminWorkflowMutationError = HTTPValidationError
    export type CloneAdminWorkflowMutationVariables = {data: BodyType<WorkflowClone>}

    /**
 * @summary Clone Admin Workflow
 */
export const useCloneAdminWorkflow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAdminWorkflow>>, TError,CloneAdminWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneAdminWorkflow>>,
        TError,
        CloneAdminWorkflowMutationVariables,
        TContext
      > => {
      return useMutation(getCloneAdminWorkflowMutationOptions(options), queryClient);
    }

/**
 * @summary Get Documents
 */
export const getDocuments = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<DocumentOut[]>(
      {url: `/api/documents`, method: 'GET', signal
    },
      options);
    }




export const getGetDocumentsQueryKey = () => {
    return [
    `/api/documents`
    ] as const;
    }


export const getGetDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getDocuments>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>> = ({ signal }) => getDocuments(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsQueryError = HTTPValidationError


export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Documents
 */

export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Document
 */
export const updateDocument = (
    documentIn: BodyType<DocumentIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentIn, signal
    },
      options);
    }




export const getUpdateDocumentMutationKey = () => ['updateDocument'] as const;

export const getUpdateDocumentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,UpdateDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,UpdateDocumentMutationVariables, TContext> => {

const mutationKey = getUpdateDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocument>>, UpdateDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocument>>>
    export type UpdateDocumentMutationBody = BodyType<DocumentIn>
    export type UpdateDocumentMutationError = HTTPValidationError
    export type UpdateDocumentMutationVariables = {data: BodyType<DocumentIn>}

    /**
 * @summary Update Document
 */
export const useUpdateDocument = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocument>>, TError,UpdateDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocument>>,
        TError,
        UpdateDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDocumentMutationOptions(options), queryClient);
    }

/**
 * @summary Add Letter
 */
export const addLetter = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/documents/letter`, method: 'POST', signal
    },
      options);
    }




export const getAddLetterMutationKey = () => ['addLetter'] as const;

export const getAddLetterMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLetter>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof addLetter>>, TError,void, TContext> => {

const mutationKey = getAddLetterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLetter>>, void> = () => {


          return  addLetter(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddLetterMutationResult = NonNullable<Awaited<ReturnType<typeof addLetter>>>

    export type AddLetterMutationError = HTTPValidationError


    /**
 * @summary Add Letter
 */
export const useAddLetter = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLetter>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLetter>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAddLetterMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Letter
 */
export const deleteLetter = (
    documentId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/documents/${documentId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteLetterMutationKey = () => ['deleteLetter'] as const;

export const getDeleteLetterMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLetter>>, TError,DeleteLetterMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLetter>>, TError,DeleteLetterMutationVariables, TContext> => {

const mutationKey = getDeleteLetterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLetter>>, DeleteLetterMutationVariables> = (props) => {
          const {documentId} = props ?? {};

          return  deleteLetter(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLetterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLetter>>>

    export type DeleteLetterMutationError = HTTPValidationError
    export type DeleteLetterMutationVariables = {documentId: string}

    /**
 * @summary Delete Letter
 */
export const useDeleteLetter = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLetter>>, TError,DeleteLetterMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLetter>>,
        TError,
        DeleteLetterMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLetterMutationOptions(options), queryClient);
    }

/**
 * @summary Preview Layout
 */
export const previewLayout = (
    documentIn: BodyType<DocumentIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/documents/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentIn, signal
    },
      options);
    }




export const getPreviewLayoutQueryKey = (documentIn?: BodyType<DocumentIn>,) => {
    return [
    'POST', `/api/documents/preview`, documentIn
    ] as const;
    }


export const getPreviewLayoutQueryOptions = <TData = Awaited<ReturnType<typeof previewLayout>>, TError = HTTPValidationError>(documentIn: BodyType<DocumentIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewLayoutQueryKey(documentIn);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewLayout>>> = ({ signal }) => previewLayout(documentIn, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof previewLayout>>>
export type PreviewLayoutQueryError = HTTPValidationError


export function usePreviewLayout<TData = Awaited<ReturnType<typeof previewLayout>>, TError = HTTPValidationError>(
 documentIn: BodyType<DocumentIn>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLayout>>,
          TError,
          Awaited<ReturnType<typeof previewLayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLayout<TData = Awaited<ReturnType<typeof previewLayout>>, TError = HTTPValidationError>(
 documentIn: BodyType<DocumentIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLayout>>,
          TError,
          Awaited<ReturnType<typeof previewLayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLayout<TData = Awaited<ReturnType<typeof previewLayout>>, TError = HTTPValidationError>(
 documentIn: BodyType<DocumentIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Layout
 */

export function usePreviewLayout<TData = Awaited<ReturnType<typeof previewLayout>>, TError = HTTPValidationError>(
 documentIn: BodyType<DocumentIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLayout>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewLayoutQueryOptions(documentIn,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Preview Layout Pdf
 */
export const previewLayoutPdf = (
    documentIn: BodyType<DocumentIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/documents/preview.pdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentIn,
        responseType: 'blob', signal
    },
      options);
    }




export const getPreviewLayoutPdfMutationKey = () => ['previewLayoutPdf'] as const;

export const getPreviewLayoutPdfMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLayoutPdf>>, TError,PreviewLayoutPdfMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof previewLayoutPdf>>, TError,PreviewLayoutPdfMutationVariables, TContext> => {

const mutationKey = getPreviewLayoutPdfMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewLayoutPdf>>, PreviewLayoutPdfMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  previewLayoutPdf(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewLayoutPdfMutationResult = NonNullable<Awaited<ReturnType<typeof previewLayoutPdf>>>
    export type PreviewLayoutPdfMutationBody = BodyType<DocumentIn>
    export type PreviewLayoutPdfMutationError = HTTPValidationError
    export type PreviewLayoutPdfMutationVariables = {data: BodyType<DocumentIn>}

    /**
 * @summary Preview Layout Pdf
 */
export const usePreviewLayoutPdf = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewLayoutPdf>>, TError,PreviewLayoutPdfMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewLayoutPdf>>,
        TError,
        PreviewLayoutPdfMutationVariables,
        TContext
      > => {
      return useMutation(getPreviewLayoutPdfMutationOptions(options), queryClient);
    }

/**
 * @summary Get Font Family
 */
export const getFontFamily = (
    params?: GetFontFamilyParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/font-family`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFontFamilyQueryKey = (params?: GetFontFamilyParams,) => {
    return [
    `/api/font-family`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFontFamilyQueryOptions = <TData = Awaited<ReturnType<typeof getFontFamily>>, TError = HTTPValidationError>(params?: GetFontFamilyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFontFamilyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFontFamily>>> = ({ signal }) => getFontFamily(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFontFamilyQueryResult = NonNullable<Awaited<ReturnType<typeof getFontFamily>>>
export type GetFontFamilyQueryError = HTTPValidationError


export function useGetFontFamily<TData = Awaited<ReturnType<typeof getFontFamily>>, TError = HTTPValidationError>(
 params: undefined |  GetFontFamilyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFontFamily>>,
          TError,
          Awaited<ReturnType<typeof getFontFamily>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFontFamily<TData = Awaited<ReturnType<typeof getFontFamily>>, TError = HTTPValidationError>(
 params?: GetFontFamilyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFontFamily>>,
          TError,
          Awaited<ReturnType<typeof getFontFamily>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFontFamily<TData = Awaited<ReturnType<typeof getFontFamily>>, TError = HTTPValidationError>(
 params?: GetFontFamilyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Font Family
 */

export function useGetFontFamily<TData = Awaited<ReturnType<typeof getFontFamily>>, TError = HTTPValidationError>(
 params?: GetFontFamilyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFontFamily>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFontFamilyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Languages
 */
export const getLanguages = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<LabelId[]>(
      {url: `/api/languages`, method: 'GET', signal
    },
      options);
    }




export const getGetLanguagesQueryKey = () => {
    return [
    `/api/languages`
    ] as const;
    }


export const getGetLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof getLanguages>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLanguagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({ signal }) => getLanguages(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>
export type GetLanguagesQueryError = HTTPValidationError


export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Languages
 */

export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLanguagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Territories
 */
export const getTerritories = (
    params?: GetTerritoriesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<LabelId[]>(
      {url: `/api/territories`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTerritoriesQueryKey = (params?: GetTerritoriesParams,) => {
    return [
    `/api/territories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTerritoriesQueryOptions = <TData = Awaited<ReturnType<typeof getTerritories>>, TError = HTTPValidationError>(params?: GetTerritoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTerritoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTerritories>>> = ({ signal }) => getTerritories(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTerritoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getTerritories>>>
export type GetTerritoriesQueryError = HTTPValidationError


export function useGetTerritories<TData = Awaited<ReturnType<typeof getTerritories>>, TError = HTTPValidationError>(
 params: undefined |  GetTerritoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTerritories>>,
          TError,
          Awaited<ReturnType<typeof getTerritories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerritories<TData = Awaited<ReturnType<typeof getTerritories>>, TError = HTTPValidationError>(
 params?: GetTerritoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTerritories>>,
          TError,
          Awaited<ReturnType<typeof getTerritories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerritories<TData = Awaited<ReturnType<typeof getTerritories>>, TError = HTTPValidationError>(
 params?: GetTerritoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Territories
 */

export function useGetTerritories<TData = Awaited<ReturnType<typeof getTerritories>>, TError = HTTPValidationError>(
 params?: GetTerritoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerritories>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTerritoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Current Organization
 */
export const getCurrentOrganization = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<OrganizationOut>(
      {url: `/api/organization`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentOrganizationQueryKey = () => {
    return [
    `/api/organization`
    ] as const;
    }


export const getGetCurrentOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentOrganization>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentOrganizationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentOrganization>>> = ({ signal }) => getCurrentOrganization(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentOrganization>>>
export type GetCurrentOrganizationQueryError = HTTPValidationError


export function useGetCurrentOrganization<TData = Awaited<ReturnType<typeof getCurrentOrganization>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentOrganization>>,
          TError,
          Awaited<ReturnType<typeof getCurrentOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentOrganization<TData = Awaited<ReturnType<typeof getCurrentOrganization>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentOrganization>>,
          TError,
          Awaited<ReturnType<typeof getCurrentOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentOrganization<TData = Awaited<ReturnType<typeof getCurrentOrganization>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current Organization
 */

export function useGetCurrentOrganization<TData = Awaited<ReturnType<typeof getCurrentOrganization>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentOrganization>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentOrganizationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Organization
 */
export const updateOrganization = (
    organizationIn: BodyType<OrganizationIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/update-organization`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationIn, signal
    },
      options);
    }




export const getUpdateOrganizationMutationKey = () => ['updateOrganization'] as const;

export const getUpdateOrganizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext> => {

const mutationKey = getUpdateOrganizationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganization>>, UpdateOrganizationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganization>>>
    export type UpdateOrganizationMutationBody = BodyType<OrganizationIn>
    export type UpdateOrganizationMutationError = HTTPValidationError
    export type UpdateOrganizationMutationVariables = {data: BodyType<OrganizationIn>}

    /**
 * @summary Update Organization
 */
export const useUpdateOrganization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganization>>,
        TError,
        UpdateOrganizationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrganizationMutationOptions(options), queryClient);
    }

/**
 * @summary Update Logo
 */
export const updateLogo = (
    bodyUpdateLogo: BodyType<BodyUpdateLogo>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`upload`, bodyUpdateLogo.upload);

      return customClient<boolean>(
      {url: `/api/update-logo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUpdateLogoMutationKey = () => ['updateLogo'] as const;

export const getUpdateLogoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLogo>>, TError,UpdateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLogo>>, TError,UpdateLogoMutationVariables, TContext> => {

const mutationKey = getUpdateLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLogo>>, UpdateLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLogoMutationResult = NonNullable<Awaited<ReturnType<typeof updateLogo>>>
    export type UpdateLogoMutationBody = BodyType<BodyUpdateLogo>
    export type UpdateLogoMutationError = HTTPValidationError
    export type UpdateLogoMutationVariables = {data: BodyType<BodyUpdateLogo>}

    /**
 * @summary Update Logo
 */
export const useUpdateLogo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLogo>>, TError,UpdateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLogo>>,
        TError,
        UpdateLogoMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLogoMutationOptions(options), queryClient);
    }

/**
 * @summary Submit Onboarding
 */
export const submitOnboarding = (
    questionAnswer: BodyType<QuestionAnswer[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/onboarding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: questionAnswer, signal
    },
      options);
    }




export const getSubmitOnboardingMutationKey = () => ['submitOnboarding'] as const;

export const getSubmitOnboardingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOnboarding>>, TError,SubmitOnboardingMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof submitOnboarding>>, TError,SubmitOnboardingMutationVariables, TContext> => {

const mutationKey = getSubmitOnboardingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOnboarding>>, SubmitOnboardingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  submitOnboarding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof submitOnboarding>>>
    export type SubmitOnboardingMutationBody = BodyType<QuestionAnswer[]>
    export type SubmitOnboardingMutationError = HTTPValidationError
    export type SubmitOnboardingMutationVariables = {data: BodyType<QuestionAnswer[]>}

    /**
 * @summary Submit Onboarding
 */
export const useSubmitOnboarding = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOnboarding>>, TError,SubmitOnboardingMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitOnboarding>>,
        TError,
        SubmitOnboardingMutationVariables,
        TContext
      > => {
      return useMutation(getSubmitOnboardingMutationOptions(options), queryClient);
    }

/**
 * @summary Send Email To Me
 */
export const sendEmailToMe = (
    emailId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emails/${emailId}/send_to_me`, method: 'POST', signal
    },
      options);
    }




export const getSendEmailToMeMutationKey = () => ['sendEmailToMe'] as const;

export const getSendEmailToMeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToMe>>, TError,SendEmailToMeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToMe>>, TError,SendEmailToMeMutationVariables, TContext> => {

const mutationKey = getSendEmailToMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToMe>>, SendEmailToMeMutationVariables> = (props) => {
          const {emailId} = props ?? {};

          return  sendEmailToMe(emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToMeMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToMe>>>

    export type SendEmailToMeMutationError = HTTPValidationError
    export type SendEmailToMeMutationVariables = {emailId: string}

    /**
 * @summary Send Email To Me
 */
export const useSendEmailToMe = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToMe>>, TError,SendEmailToMeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendEmailToMe>>,
        TError,
        SendEmailToMeMutationVariables,
        TContext
      > => {
      return useMutation(getSendEmailToMeMutationOptions(options), queryClient);
    }

/**
 * @summary Get Email Attachment
 */
export const getEmailAttachment = (
    emailId: string,
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/emails/${emailId}/attachment/${id}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetEmailAttachmentQueryKey = (emailId: string,
    id: string,) => {
    return [
    `/api/emails/${emailId}/attachment/${id}`
    ] as const;
    }


export const getGetEmailAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getEmailAttachment>>, TError = HTTPValidationError>(emailId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailAttachmentQueryKey(emailId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailAttachment>>> = ({ signal }) => getEmailAttachment(emailId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: emailId !== null && emailId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailAttachment>>>
export type GetEmailAttachmentQueryError = HTTPValidationError


export function useGetEmailAttachment<TData = Awaited<ReturnType<typeof getEmailAttachment>>, TError = HTTPValidationError>(
 emailId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmailAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailAttachment<TData = Awaited<ReturnType<typeof getEmailAttachment>>, TError = HTTPValidationError>(
 emailId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailAttachment>>,
          TError,
          Awaited<ReturnType<typeof getEmailAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailAttachment<TData = Awaited<ReturnType<typeof getEmailAttachment>>, TError = HTTPValidationError>(
 emailId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Email Attachment
 */

export function useGetEmailAttachment<TData = Awaited<ReturnType<typeof getEmailAttachment>>, TError = HTTPValidationError>(
 emailId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAttachment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailAttachmentQueryOptions(emailId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Send Test Email To Me
 */
export const sendTestEmailToMe = (
    testEmailOptions: BodyType<TestEmailOptions>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emails/send_test_to_me`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testEmailOptions, signal
    },
      options);
    }




export const getSendTestEmailToMeMutationKey = () => ['sendTestEmailToMe'] as const;

export const getSendTestEmailToMeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestEmailToMe>>, TError,SendTestEmailToMeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTestEmailToMe>>, TError,SendTestEmailToMeMutationVariables, TContext> => {

const mutationKey = getSendTestEmailToMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestEmailToMe>>, SendTestEmailToMeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendTestEmailToMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendTestEmailToMeMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestEmailToMe>>>
    export type SendTestEmailToMeMutationBody = BodyType<TestEmailOptions>
    export type SendTestEmailToMeMutationError = HTTPValidationError
    export type SendTestEmailToMeMutationVariables = {data: BodyType<TestEmailOptions>}

    /**
 * @summary Send Test Email To Me
 */
export const useSendTestEmailToMe = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestEmailToMe>>, TError,SendTestEmailToMeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTestEmailToMe>>,
        TError,
        SendTestEmailToMeMutationVariables,
        TContext
      > => {
      return useMutation(getSendTestEmailToMeMutationOptions(options), queryClient);
    }

/**
 * @summary Update Email
 */
export const updateEmail = (
    emailId: string,
    emailIn: BodyType<EmailIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<EmailDetailsOut>(
      {url: `/api/emails/${emailId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: emailIn, signal
    },
      options);
    }




export const getUpdateEmailMutationKey = () => ['updateEmail'] as const;

export const getUpdateEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,UpdateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,UpdateEmailMutationVariables, TContext> => {

const mutationKey = getUpdateEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmail>>, UpdateEmailMutationVariables> = (props) => {
          const {emailId,data} = props ?? {};

          return  updateEmail(emailId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmail>>>
    export type UpdateEmailMutationBody = BodyType<EmailIn>
    export type UpdateEmailMutationError = HTTPValidationError
    export type UpdateEmailMutationVariables = {emailId: string;data: BodyType<EmailIn>}

    /**
 * @summary Update Email
 */
export const useUpdateEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,UpdateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmail>>,
        TError,
        UpdateEmailMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEmailMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Event
 */
export const deleteEvent = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/events/${eventId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteEventMutationKey = () => ['deleteEvent'] as const;

export const getDeleteEventMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,DeleteEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,DeleteEventMutationVariables, TContext> => {

const mutationKey = getDeleteEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, DeleteEventMutationVariables> = (props) => {
          const {eventId} = props ?? {};

          return  deleteEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = HTTPValidationError
    export type DeleteEventMutationVariables = {eventId: string}

    /**
 * @summary Delete Event
 */
export const useDeleteEvent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,DeleteEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        DeleteEventMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options), queryClient);
    }

/**
 * @summary Get Event Details
 */
export const getEventDetails = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<NoteEventDetailsOut | InboundEmailEventDetailsOut | PersonalReminderEventDetailsOut | PhoneReminderEventDetailsOut | OutboundEventDetailsOut | OutboundLetterEventDetailsOut | OutboundSmsEventDetailsOut | InboundSmsEventDetailsOut | InboundCallEventDetailsOut>(
      {url: `/api/events/${eventId}/`, method: 'GET', signal
    },
      options);
    }




export const getGetEventDetailsQueryKey = (eventId: string,) => {
    return [
    `/api/events/${eventId}/`
    ] as const;
    }


export const getGetEventDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetails>>, TError = HTTPValidationError>(eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsQueryKey(eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetails>>> = ({ signal }) => getEventDetails(eventId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetails>>>
export type GetEventDetailsQueryError = HTTPValidationError


export function useGetEventDetails<TData = Awaited<ReturnType<typeof getEventDetails>>, TError = HTTPValidationError>(
 eventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventDetails>>,
          TError,
          Awaited<ReturnType<typeof getEventDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventDetails<TData = Awaited<ReturnType<typeof getEventDetails>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventDetails>>,
          TError,
          Awaited<ReturnType<typeof getEventDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventDetails<TData = Awaited<ReturnType<typeof getEventDetails>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Event Details
 */

export function useGetEventDetails<TData = Awaited<ReturnType<typeof getEventDetails>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventDetailsQueryOptions(eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get To Notify
 */
export const getToNotify = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ToNotify>(
      {url: `/api/events/to-notify/`, method: 'GET', signal
    },
      options);
    }




export const getGetToNotifyQueryKey = () => {
    return [
    `/api/events/to-notify/`
    ] as const;
    }


export const getGetToNotifyQueryOptions = <TData = Awaited<ReturnType<typeof getToNotify>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetToNotifyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToNotify>>> = ({ signal }) => getToNotify(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetToNotifyQueryResult = NonNullable<Awaited<ReturnType<typeof getToNotify>>>
export type GetToNotifyQueryError = HTTPValidationError


export function useGetToNotify<TData = Awaited<ReturnType<typeof getToNotify>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToNotify>>,
          TError,
          Awaited<ReturnType<typeof getToNotify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToNotify<TData = Awaited<ReturnType<typeof getToNotify>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToNotify>>,
          TError,
          Awaited<ReturnType<typeof getToNotify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToNotify<TData = Awaited<ReturnType<typeof getToNotify>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get To Notify
 */

export function useGetToNotify<TData = Awaited<ReturnType<typeof getToNotify>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToNotify>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetToNotifyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Tasks
 */
export const getTasks = (
    bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<TasksOut>(
      {url: `/api/events/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodyGetTasks,
        params, signal
    },
      options);
    }




export const getGetTasksQueryKey = (bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams,) => {
    return [
    'POST', `/api/events/tasks`, ...(params ? [params] : []), bodyGetTasks
    ] as const;
    }


export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = HTTPValidationError>(bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(bodyGetTasks,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(bodyGetTasks,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = HTTPValidationError


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = HTTPValidationError>(
 bodyGetTasks: undefined |  BodyType<BodyGetTasks>,
    params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = HTTPValidationError>(
 bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = HTTPValidationError>(
 bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Tasks
 */

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = HTTPValidationError>(
 bodyGetTasks?: BodyType<BodyGetTasks>,
    params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(bodyGetTasks,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Events
 */
export const getEvents = (
    bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ContainerAnnotatedUnionNoteEventOutInboundEmailEventOutPersonalReminderEventOutPhoneReminderEventOutOutboundEventOutOutboundLetterEventOutOutboundSmsEventOutInboundSmsEventOutInboundCallEventOutFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorKind>(
      {url: `/api/events/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodyGetEvents,
        params, signal
    },
      options);
    }




export const getGetEventsQueryKey = (bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams,) => {
    return [
    'POST', `/api/events/`, ...(params ? [params] : []), bodyGetEvents
    ] as const;
    }


export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = HTTPValidationError>(bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(bodyGetEvents,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(bodyGetEvents,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = HTTPValidationError


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = HTTPValidationError>(
 bodyGetEvents: undefined |  BodyType<BodyGetEvents>,
    params: undefined |  GetEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = HTTPValidationError>(
 bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = HTTPValidationError>(
 bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = HTTPValidationError>(
 bodyGetEvents?: BodyType<BodyGetEvents>,
    params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(bodyGetEvents,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Activity Report
 */
export const getActivityReport = (
    params: GetActivityReportParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ActivitiesOut>(
      {url: `/api/events/activity-report`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetActivityReportQueryKey = (params?: GetActivityReportParams,) => {
    return [
    `/api/events/activity-report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityReportQueryOptions = <TData = Awaited<ReturnType<typeof getActivityReport>>, TError = HTTPValidationError>(params: GetActivityReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityReport>>> = ({ signal }) => getActivityReport(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityReportQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityReport>>>
export type GetActivityReportQueryError = HTTPValidationError


export function useGetActivityReport<TData = Awaited<ReturnType<typeof getActivityReport>>, TError = HTTPValidationError>(
 params: GetActivityReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityReport>>,
          TError,
          Awaited<ReturnType<typeof getActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityReport<TData = Awaited<ReturnType<typeof getActivityReport>>, TError = HTTPValidationError>(
 params: GetActivityReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityReport>>,
          TError,
          Awaited<ReturnType<typeof getActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityReport<TData = Awaited<ReturnType<typeof getActivityReport>>, TError = HTTPValidationError>(
 params: GetActivityReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Activity Report
 */

export function useGetActivityReport<TData = Awaited<ReturnType<typeof getActivityReport>>, TError = HTTPValidationError>(
 params: GetActivityReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Event Thread
 */
export const getEventThread = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<(InboundEmailEventOut | OutboundEventOut)[]>(
      {url: `/api/events/${eventId}/thread/`, method: 'GET', signal
    },
      options);
    }




export const getGetEventThreadQueryKey = (eventId: string,) => {
    return [
    `/api/events/${eventId}/thread/`
    ] as const;
    }


export const getGetEventThreadQueryOptions = <TData = Awaited<ReturnType<typeof getEventThread>>, TError = HTTPValidationError>(eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventThreadQueryKey(eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventThread>>> = ({ signal }) => getEventThread(eventId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getEventThread>>>
export type GetEventThreadQueryError = HTTPValidationError


export function useGetEventThread<TData = Awaited<ReturnType<typeof getEventThread>>, TError = HTTPValidationError>(
 eventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventThread>>,
          TError,
          Awaited<ReturnType<typeof getEventThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventThread<TData = Awaited<ReturnType<typeof getEventThread>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventThread>>,
          TError,
          Awaited<ReturnType<typeof getEventThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventThread<TData = Awaited<ReturnType<typeof getEventThread>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Event Thread
 */

export function useGetEventThread<TData = Awaited<ReturnType<typeof getEventThread>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventThread>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventThreadQueryOptions(eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Send Immediate Sms
 */
export const sendImmediateSms = (
    makeAndSendSms: BodyType<MakeAndSendSms>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string | null>(
      {url: `/api/events/send-sms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: makeAndSendSms, signal
    },
      options);
    }




export const getSendImmediateSmsMutationKey = () => ['sendImmediateSms'] as const;

export const getSendImmediateSmsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendImmediateSms>>, TError,SendImmediateSmsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendImmediateSms>>, TError,SendImmediateSmsMutationVariables, TContext> => {

const mutationKey = getSendImmediateSmsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendImmediateSms>>, SendImmediateSmsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendImmediateSms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendImmediateSmsMutationResult = NonNullable<Awaited<ReturnType<typeof sendImmediateSms>>>
    export type SendImmediateSmsMutationBody = BodyType<MakeAndSendSms>
    export type SendImmediateSmsMutationError = HTTPValidationError
    export type SendImmediateSmsMutationVariables = {data: BodyType<MakeAndSendSms>}

    /**
 * @summary Send Immediate Sms
 */
export const useSendImmediateSms = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendImmediateSms>>, TError,SendImmediateSmsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendImmediateSms>>,
        TError,
        SendImmediateSmsMutationVariables,
        TContext
      > => {
      return useMutation(getSendImmediateSmsMutationOptions(options), queryClient);
    }

/**
 * @summary Send Immediate Email
 */
export const sendImmediateEmail = (
    bodySendImmediateEmail: BodyType<BodySendImmediateEmail>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(bodySendImmediateEmail.customer_id !== undefined && bodySendImmediateEmail.customer_id !== null) {
 formData.append(`customer_id`, bodySendImmediateEmail.customer_id);
 }
formData.append(`subject`, bodySendImmediateEmail.subject);
formData.append(`body`, bodySendImmediateEmail.body);
formData.append(`sender`, bodySendImmediateEmail.sender);
bodySendImmediateEmail.recipients.forEach(value => formData.append(`recipients`, value));
if(bodySendImmediateEmail.cc !== undefined && bodySendImmediateEmail.cc !== null) {
 bodySendImmediateEmail.cc.forEach(value => formData.append(`cc`, value));
 }
if(bodySendImmediateEmail.bcc !== undefined && bodySendImmediateEmail.bcc !== null) {
 bodySendImmediateEmail.bcc.forEach(value => formData.append(`bcc`, value));
 }
if(bodySendImmediateEmail.in_reply_to !== undefined && bodySendImmediateEmail.in_reply_to !== null) {
 formData.append(`in_reply_to`, bodySendImmediateEmail.in_reply_to);
 }
if(bodySendImmediateEmail.invoices !== undefined && bodySendImmediateEmail.invoices !== null) {
 bodySendImmediateEmail.invoices.forEach(value => formData.append(`invoices`, value));
 }
if(bodySendImmediateEmail.attach_invoice !== undefined) {
 formData.append(`attach_invoice`, bodySendImmediateEmail.attach_invoice.toString())
 }
if(bodySendImmediateEmail.attach_invoice_attachments !== undefined) {
 formData.append(`attach_invoice_attachments`, bodySendImmediateEmail.attach_invoice_attachments.toString())
 }
if(bodySendImmediateEmail.statement_type !== undefined && bodySendImmediateEmail.statement_type !== null) {
 formData.append(`statement_type`, bodySendImmediateEmail.statement_type);
 }
if(bodySendImmediateEmail.activity_statement_months !== undefined) {
 formData.append(`activity_statement_months`, bodySendImmediateEmail.activity_statement_months.toString())
 }
if(bodySendImmediateEmail.include_partial !== undefined) {
 formData.append(`include_partial`, bodySendImmediateEmail.include_partial.toString())
 }
if(bodySendImmediateEmail.priority !== undefined && bodySendImmediateEmail.priority !== null) {
 formData.append(`priority`, bodySendImmediateEmail.priority.toString())
 }
if(bodySendImmediateEmail.attachments !== undefined && bodySendImmediateEmail.attachments !== null) {
 bodySendImmediateEmail.attachments.forEach(value => formData.append(`attachments`, value));
 }

      return customClient<string | null>(
      {url: `/api/events/send-email`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getSendImmediateEmailMutationKey = () => ['sendImmediateEmail'] as const;

export const getSendImmediateEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendImmediateEmail>>, TError,SendImmediateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendImmediateEmail>>, TError,SendImmediateEmailMutationVariables, TContext> => {

const mutationKey = getSendImmediateEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendImmediateEmail>>, SendImmediateEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendImmediateEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendImmediateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendImmediateEmail>>>
    export type SendImmediateEmailMutationBody = BodyType<BodySendImmediateEmail>
    export type SendImmediateEmailMutationError = HTTPValidationError
    export type SendImmediateEmailMutationVariables = {data: BodyType<BodySendImmediateEmail>}

    /**
 * @summary Send Immediate Email
 */
export const useSendImmediateEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendImmediateEmail>>, TError,SendImmediateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendImmediateEmail>>,
        TError,
        SendImmediateEmailMutationVariables,
        TContext
      > => {
      return useMutation(getSendImmediateEmailMutationOptions(options), queryClient);
    }

/**
 * @summary Execute Event
 */
export const executeEvent = (
    executeEventBody: BodyType<string[]>,
    params?: ExecuteEventParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/events/execute/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeEventBody,
        params, signal
    },
      options);
    }




export const getExecuteEventMutationKey = () => ['executeEvent'] as const;

export const getExecuteEventMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeEvent>>, TError,ExecuteEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof executeEvent>>, TError,ExecuteEventMutationVariables, TContext> => {

const mutationKey = getExecuteEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeEvent>>, ExecuteEventMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  executeEvent(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteEventMutationResult = NonNullable<Awaited<ReturnType<typeof executeEvent>>>
    export type ExecuteEventMutationBody = BodyType<string[]>
    export type ExecuteEventMutationError = HTTPValidationError
    export type ExecuteEventMutationVariables = {data: BodyType<string[]>;params?: ExecuteEventParams}

    /**
 * @summary Execute Event
 */
export const useExecuteEvent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeEvent>>, TError,ExecuteEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeEvent>>,
        TError,
        ExecuteEventMutationVariables,
        TContext
      > => {
      return useMutation(getExecuteEventMutationOptions(options), queryClient);
    }

/**
 * @summary Bulk Update Read Status
 */
export const bulkUpdateReadStatus = (
    bulkReadStatusIn: BodyType<BulkReadStatusIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/events/bulk-read-status/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkReadStatusIn, signal
    },
      options);
    }




export const getBulkUpdateReadStatusMutationKey = () => ['bulkUpdateReadStatus'] as const;

export const getBulkUpdateReadStatusMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateReadStatus>>, TError,BulkUpdateReadStatusMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateReadStatus>>, TError,BulkUpdateReadStatusMutationVariables, TContext> => {

const mutationKey = getBulkUpdateReadStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateReadStatus>>, BulkUpdateReadStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkUpdateReadStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateReadStatusMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateReadStatus>>>
    export type BulkUpdateReadStatusMutationBody = BodyType<BulkReadStatusIn>
    export type BulkUpdateReadStatusMutationError = HTTPValidationError
    export type BulkUpdateReadStatusMutationVariables = {data: BodyType<BulkReadStatusIn>}

    /**
 * @summary Bulk Update Read Status
 */
export const useBulkUpdateReadStatus = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateReadStatus>>, TError,BulkUpdateReadStatusMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateReadStatus>>,
        TError,
        BulkUpdateReadStatusMutationVariables,
        TContext
      > => {
      return useMutation(getBulkUpdateReadStatusMutationOptions(options), queryClient);
    }

/**
 * @summary Set Workflow Action
 */
export const setWorkflowAction = (
    setAction: BodyType<SetAction>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/events/set-action`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAction, signal
    },
      options);
    }




export const getSetWorkflowActionMutationKey = () => ['setWorkflowAction'] as const;

export const getSetWorkflowActionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkflowAction>>, TError,SetWorkflowActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setWorkflowAction>>, TError,SetWorkflowActionMutationVariables, TContext> => {

const mutationKey = getSetWorkflowActionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWorkflowAction>>, SetWorkflowActionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setWorkflowAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetWorkflowActionMutationResult = NonNullable<Awaited<ReturnType<typeof setWorkflowAction>>>
    export type SetWorkflowActionMutationBody = BodyType<SetAction>
    export type SetWorkflowActionMutationError = HTTPValidationError
    export type SetWorkflowActionMutationVariables = {data: BodyType<SetAction>}

    /**
 * @summary Set Workflow Action
 */
export const useSetWorkflowAction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWorkflowAction>>, TError,SetWorkflowActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setWorkflowAction>>,
        TError,
        SetWorkflowActionMutationVariables,
        TContext
      > => {
      return useMutation(getSetWorkflowActionMutationOptions(options), queryClient);
    }

/**
 * @summary Update Events
 */
export const updateEvents = (
    eventIn: BodyType<EventIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/events`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventIn, signal
    },
      options);
    }




export const getUpdateEventsMutationKey = () => ['updateEvents'] as const;

export const getUpdateEventsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvents>>, TError,UpdateEventsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEvents>>, TError,UpdateEventsMutationVariables, TContext> => {

const mutationKey = getUpdateEventsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEvents>>, UpdateEventsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEventsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvents>>>
    export type UpdateEventsMutationBody = BodyType<EventIn>
    export type UpdateEventsMutationError = HTTPValidationError
    export type UpdateEventsMutationVariables = {data: BodyType<EventIn>}

    /**
 * @summary Update Events
 */
export const useUpdateEvents = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvents>>, TError,UpdateEventsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEvents>>,
        TError,
        UpdateEventsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEventsMutationOptions(options), queryClient);
    }

/**
 * @summary Recovered Revenue
 */
export const recoveredRevenue = (
    params: RecoveredRevenueParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<RecoveredRevenueOut>(
      {url: `/api/customers/recovered-revenue/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRecoveredRevenueQueryKey = (params?: RecoveredRevenueParams,) => {
    return [
    `/api/customers/recovered-revenue/`, ...(params ? [params] : [])
    ] as const;
    }


export const getRecoveredRevenueQueryOptions = <TData = Awaited<ReturnType<typeof recoveredRevenue>>, TError = HTTPValidationError>(params: RecoveredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecoveredRevenueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recoveredRevenue>>> = ({ signal }) => recoveredRevenue(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecoveredRevenueQueryResult = NonNullable<Awaited<ReturnType<typeof recoveredRevenue>>>
export type RecoveredRevenueQueryError = HTTPValidationError


export function useRecoveredRevenue<TData = Awaited<ReturnType<typeof recoveredRevenue>>, TError = HTTPValidationError>(
 params: RecoveredRevenueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recoveredRevenue>>,
          TError,
          Awaited<ReturnType<typeof recoveredRevenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecoveredRevenue<TData = Awaited<ReturnType<typeof recoveredRevenue>>, TError = HTTPValidationError>(
 params: RecoveredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recoveredRevenue>>,
          TError,
          Awaited<ReturnType<typeof recoveredRevenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecoveredRevenue<TData = Awaited<ReturnType<typeof recoveredRevenue>>, TError = HTTPValidationError>(
 params: RecoveredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recovered Revenue
 */

export function useRecoveredRevenue<TData = Awaited<ReturnType<typeof recoveredRevenue>>, TError = HTTPValidationError>(
 params: RecoveredRevenueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recoveredRevenue>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecoveredRevenueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Customer
 */
export const getCustomer = (
    customer: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<CustomerDetailOut>(
      {url: `/api/customers/${customer}`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerQueryKey = (customer: string,) => {
    return [
    `/api/customers/${customer}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = HTTPValidationError>(customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(customer);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(customer, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customer !== null && customer !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = HTTPValidationError


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = HTTPValidationError>(
 customer: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Customer
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerQueryOptions(customer,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Set Parent Customer
 */
export const setParentCustomer = (
    customer: string,
    parentCustomerIn: BodyType<ParentCustomerIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/customers/${customer}/parent_customer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: parentCustomerIn, signal
    },
      options);
    }




export const getSetParentCustomerMutationKey = () => ['setParentCustomer'] as const;

export const getSetParentCustomerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setParentCustomer>>, TError,SetParentCustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setParentCustomer>>, TError,SetParentCustomerMutationVariables, TContext> => {

const mutationKey = getSetParentCustomerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setParentCustomer>>, SetParentCustomerMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  setParentCustomer(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetParentCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof setParentCustomer>>>
    export type SetParentCustomerMutationBody = BodyType<ParentCustomerIn>
    export type SetParentCustomerMutationError = HTTPValidationError
    export type SetParentCustomerMutationVariables = {customer: string;data: BodyType<ParentCustomerIn>}

    /**
 * @summary Set Parent Customer
 */
export const useSetParentCustomer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setParentCustomer>>, TError,SetParentCustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setParentCustomer>>,
        TError,
        SetParentCustomerMutationVariables,
        TContext
      > => {
      return useMutation(getSetParentCustomerMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Subcustomer
 */
export const upsertSubcustomer = (
    customer: string,
    subcustomerIn: BodyType<SubcustomerIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/customers/${customer}/subcustomers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subcustomerIn, signal
    },
      options);
    }




export const getUpsertSubcustomerMutationKey = () => ['upsertSubcustomer'] as const;

export const getUpsertSubcustomerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSubcustomer>>, TError,UpsertSubcustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertSubcustomer>>, TError,UpsertSubcustomerMutationVariables, TContext> => {

const mutationKey = getUpsertSubcustomerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertSubcustomer>>, UpsertSubcustomerMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  upsertSubcustomer(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertSubcustomerMutationResult = NonNullable<Awaited<ReturnType<typeof upsertSubcustomer>>>
    export type UpsertSubcustomerMutationBody = BodyType<SubcustomerIn>
    export type UpsertSubcustomerMutationError = HTTPValidationError
    export type UpsertSubcustomerMutationVariables = {customer: string;data: BodyType<SubcustomerIn>}

    /**
 * @summary Upsert Subcustomer
 */
export const useUpsertSubcustomer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSubcustomer>>, TError,UpsertSubcustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertSubcustomer>>,
        TError,
        UpsertSubcustomerMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertSubcustomerMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Address
 */
export const deleteAddress = (
    customer: string,
    address: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/customers/${customer}/address/${address}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAddressMutationKey = () => ['deleteAddress'] as const;

export const getDeleteAddressMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddress>>, TError,DeleteAddressMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddress>>, TError,DeleteAddressMutationVariables, TContext> => {

const mutationKey = getDeleteAddressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddress>>, DeleteAddressMutationVariables> = (props) => {
          const {customer,address} = props ?? {};

          return  deleteAddress(customer,address,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddressMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddress>>>

    export type DeleteAddressMutationError = HTTPValidationError
    export type DeleteAddressMutationVariables = {customer: string;address: string}

    /**
 * @summary Delete Address
 */
export const useDeleteAddress = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddress>>, TError,DeleteAddressMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddress>>,
        TError,
        DeleteAddressMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAddressMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Address
 */
export const upsertAddress = (
    customer: string,
    addressIn: BodyType<AddressIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<AddressOut>(
      {url: `/api/customers/${customer}/address`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addressIn, signal
    },
      options);
    }




export const getUpsertAddressMutationKey = () => ['upsertAddress'] as const;

export const getUpsertAddressMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAddress>>, TError,UpsertAddressMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertAddress>>, TError,UpsertAddressMutationVariables, TContext> => {

const mutationKey = getUpsertAddressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAddress>>, UpsertAddressMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  upsertAddress(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertAddressMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAddress>>>
    export type UpsertAddressMutationBody = BodyType<AddressIn>
    export type UpsertAddressMutationError = HTTPValidationError
    export type UpsertAddressMutationVariables = {customer: string;data: BodyType<AddressIn>}

    /**
 * @summary Upsert Address
 */
export const useUpsertAddress = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAddress>>, TError,UpsertAddressMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertAddress>>,
        TError,
        UpsertAddressMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertAddressMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Phone
 */
export const deletePhone = (
    customer: string,
    phone: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/customers/${customer}/phone/${phone}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePhoneMutationKey = () => ['deletePhone'] as const;

export const getDeletePhoneMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhone>>, TError,DeletePhoneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePhone>>, TError,DeletePhoneMutationVariables, TContext> => {

const mutationKey = getDeletePhoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePhone>>, DeletePhoneMutationVariables> = (props) => {
          const {customer,phone} = props ?? {};

          return  deletePhone(customer,phone,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePhoneMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhone>>>

    export type DeletePhoneMutationError = HTTPValidationError
    export type DeletePhoneMutationVariables = {customer: string;phone: string}

    /**
 * @summary Delete Phone
 */
export const useDeletePhone = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhone>>, TError,DeletePhoneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePhone>>,
        TError,
        DeletePhoneMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePhoneMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Phone
 */
export const upsertPhone = (
    customer: string,
    phoneIn: BodyType<PhoneIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PhoneOut>(
      {url: `/api/customers/${customer}/phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: phoneIn, signal
    },
      options);
    }




export const getUpsertPhoneMutationKey = () => ['upsertPhone'] as const;

export const getUpsertPhoneMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPhone>>, TError,UpsertPhoneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertPhone>>, TError,UpsertPhoneMutationVariables, TContext> => {

const mutationKey = getUpsertPhoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertPhone>>, UpsertPhoneMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  upsertPhone(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof upsertPhone>>>
    export type UpsertPhoneMutationBody = BodyType<PhoneIn>
    export type UpsertPhoneMutationError = HTTPValidationError
    export type UpsertPhoneMutationVariables = {customer: string;data: BodyType<PhoneIn>}

    /**
 * @summary Upsert Phone
 */
export const useUpsertPhone = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPhone>>, TError,UpsertPhoneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertPhone>>,
        TError,
        UpsertPhoneMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertPhoneMutationOptions(options), queryClient);
    }

/**
 * @summary Get Contacts
 */
export const getContacts = (
    customer: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ContactOut[]>(
      {url: `/api/customers/${customer}/contacts`, method: 'GET', signal
    },
      options);
    }




export const getGetContactsQueryKey = (customer: string,) => {
    return [
    `/api/customers/${customer}/contacts`
    ] as const;
    }


export const getGetContactsQueryOptions = <TData = Awaited<ReturnType<typeof getContacts>>, TError = HTTPValidationError>(customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactsQueryKey(customer);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContacts>>> = ({ signal }) => getContacts(customer, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customer !== null && customer !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getContacts>>>
export type GetContactsQueryError = HTTPValidationError


export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = HTTPValidationError>(
 customer: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contacts
 */

export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactsQueryOptions(customer,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete Contact
 */
export const deleteContact = (
    customer: string,
    contact: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/customers/${customer}/contact/${contact}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteContactMutationKey = () => ['deleteContact'] as const;

export const getDeleteContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContact>>, TError,DeleteContactMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContact>>, TError,DeleteContactMutationVariables, TContext> => {

const mutationKey = getDeleteContactMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContact>>, DeleteContactMutationVariables> = (props) => {
          const {customer,contact} = props ?? {};

          return  deleteContact(customer,contact,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContact>>>

    export type DeleteContactMutationError = HTTPValidationError
    export type DeleteContactMutationVariables = {customer: string;contact: string}

    /**
 * @summary Delete Contact
 */
export const useDeleteContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContact>>, TError,DeleteContactMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContact>>,
        TError,
        DeleteContactMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteContactMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Contact
 */
export const upsertContact = (
    customer: string,
    contactIn: BodyType<ContactIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ContactOut>(
      {url: `/api/customers/${customer}/contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactIn, signal
    },
      options);
    }




export const getUpsertContactMutationKey = () => ['upsertContact'] as const;

export const getUpsertContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertContact>>, TError,UpsertContactMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertContact>>, TError,UpsertContactMutationVariables, TContext> => {

const mutationKey = getUpsertContactMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertContact>>, UpsertContactMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  upsertContact(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertContactMutationResult = NonNullable<Awaited<ReturnType<typeof upsertContact>>>
    export type UpsertContactMutationBody = BodyType<ContactIn>
    export type UpsertContactMutationError = HTTPValidationError
    export type UpsertContactMutationVariables = {customer: string;data: BodyType<ContactIn>}

    /**
 * @summary Upsert Contact
 */
export const useUpsertContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertContact>>, TError,UpsertContactMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertContact>>,
        TError,
        UpsertContactMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertContactMutationOptions(options), queryClient);
    }

/**
 * @summary Get Customers
 */
export const getCustomers = (
    bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ContainerCustomerOut>(
      {url: `/api/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodyGetCustomers,
        params, signal
    },
      options);
    }




export const getGetCustomersInfiniteQueryKey = (bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams,) => {
    return [
    'infinite', 'POST', `/api/customers`, ...(params ? [params] : []), bodyGetCustomers
    ] as const;
    }

export const getGetCustomersQueryKey = (bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams,) => {
    return [
    'POST', `/api/customers`, ...(params ? [params] : []), bodyGetCustomers
    ] as const;
    }


export const getGetCustomersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomers>>, GetCustomersParams['offset']>, TError = HTTPValidationError>(bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersInfiniteQueryKey(bodyGetCustomers,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>, QueryKey, GetCustomersParams['offset']> = ({ signal, pageParam }) => getCustomers(bodyGetCustomers,{...params, 'offset': pageParam ?? params?.['offset']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersInfiniteQueryError = HTTPValidationError


export function useGetCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomers>>, GetCustomersParams['offset']>, TError = HTTPValidationError>(
 bodyGetCustomers: undefined |  BodyType<BodyGetCustomers>,
    params: undefined |  GetCustomersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomers>>, GetCustomersParams['offset']>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomers>>, GetCustomersParams['offset']>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Customers
 */

export function useGetCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomers>>, GetCustomersParams['offset']>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData, QueryKey, GetCustomersParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersInfiniteQueryOptions(bodyGetCustomers,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getCustomers>>, TError = HTTPValidationError>(bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey(bodyGetCustomers,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) => getCustomers(bodyGetCustomers,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = HTTPValidationError


export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = HTTPValidationError>(
 bodyGetCustomers: undefined |  BodyType<BodyGetCustomers>,
    params: undefined |  GetCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Customers
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = HTTPValidationError>(
 bodyGetCustomers?: BodyType<BodyGetCustomers>,
    params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersQueryOptions(bodyGetCustomers,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Pin Note
 */
export const pinNote = (
    customer: string,
    pinNoteIn: BodyType<PinNoteIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/customers/${customer}/pinned-note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pinNoteIn, signal
    },
      options);
    }




export const getPinNoteMutationKey = () => ['pinNote'] as const;

export const getPinNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinNote>>, TError,PinNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pinNote>>, TError,PinNoteMutationVariables, TContext> => {

const mutationKey = getPinNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pinNote>>, PinNoteMutationVariables> = (props) => {
          const {customer,data} = props ?? {};

          return  pinNote(customer,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PinNoteMutationResult = NonNullable<Awaited<ReturnType<typeof pinNote>>>
    export type PinNoteMutationBody = BodyType<PinNoteIn>
    export type PinNoteMutationError = HTTPValidationError
    export type PinNoteMutationVariables = {customer: string;data: BodyType<PinNoteIn>}

    /**
 * @summary Pin Note
 */
export const usePinNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinNote>>, TError,PinNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pinNote>>,
        TError,
        PinNoteMutationVariables,
        TContext
      > => {
      return useMutation(getPinNoteMutationOptions(options), queryClient);
    }

/**
 * @summary Unpin Note
 */
export const unpinNote = (
    customer: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/customers/${customer}/pinned-note`, method: 'DELETE', signal
    },
      options);
    }




export const getUnpinNoteMutationKey = () => ['unpinNote'] as const;

export const getUnpinNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpinNote>>, TError,UnpinNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unpinNote>>, TError,UnpinNoteMutationVariables, TContext> => {

const mutationKey = getUnpinNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unpinNote>>, UnpinNoteMutationVariables> = (props) => {
          const {customer} = props ?? {};

          return  unpinNote(customer,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnpinNoteMutationResult = NonNullable<Awaited<ReturnType<typeof unpinNote>>>

    export type UnpinNoteMutationError = HTTPValidationError
    export type UnpinNoteMutationVariables = {customer: string}

    /**
 * @summary Unpin Note
 */
export const useUnpinNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpinNote>>, TError,UnpinNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unpinNote>>,
        TError,
        UnpinNoteMutationVariables,
        TContext
      > => {
      return useMutation(getUnpinNoteMutationOptions(options), queryClient);
    }

/**
 * @summary Invoices Archive
 */
export const invoicesArchive = (
    customer: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/customers/${customer}/invoices-archive`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getInvoicesArchiveQueryKey = (customer: string,) => {
    return [
    `/api/customers/${customer}/invoices-archive`
    ] as const;
    }


export const getInvoicesArchiveQueryOptions = <TData = Awaited<ReturnType<typeof invoicesArchive>>, TError = HTTPValidationError>(customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoicesArchiveQueryKey(customer);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoicesArchive>>> = ({ signal }) => invoicesArchive(customer, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customer !== null && customer !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoicesArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof invoicesArchive>>>
export type InvoicesArchiveQueryError = HTTPValidationError


export function useInvoicesArchive<TData = Awaited<ReturnType<typeof invoicesArchive>>, TError = HTTPValidationError>(
 customer: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoicesArchive>>,
          TError,
          Awaited<ReturnType<typeof invoicesArchive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoicesArchive<TData = Awaited<ReturnType<typeof invoicesArchive>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoicesArchive>>,
          TError,
          Awaited<ReturnType<typeof invoicesArchive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoicesArchive<TData = Awaited<ReturnType<typeof invoicesArchive>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoices Archive
 */

export function useInvoicesArchive<TData = Awaited<ReturnType<typeof invoicesArchive>>, TError = HTTPValidationError>(
 customer: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoicesArchive>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoicesArchiveQueryOptions(customer,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Workflows
 */
export const getWorkflows = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowOut[]>(
      {url: `/api/workflows/`, method: 'GET', signal
    },
      options);
    }




export const getGetWorkflowsQueryKey = () => {
    return [
    `/api/workflows/`
    ] as const;
    }


export const getGetWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflows>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflows>>> = ({ signal }) => getWorkflows(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflows>>>
export type GetWorkflowsQueryError = HTTPValidationError


export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workflows
 */

export function useGetWorkflows<TData = Awaited<ReturnType<typeof getWorkflows>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Workflow
 */
export const updateWorkflow = (
    workflowIn: BodyType<WorkflowIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowOut>(
      {url: `/api/workflows/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workflowIn, signal
    },
      options);
    }




export const getUpdateWorkflowMutationKey = () => ['updateWorkflow'] as const;

export const getUpdateWorkflowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,UpdateWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,UpdateWorkflowMutationVariables, TContext> => {

const mutationKey = getUpdateWorkflowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflow>>, UpdateWorkflowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflow>>>
    export type UpdateWorkflowMutationBody = BodyType<WorkflowIn>
    export type UpdateWorkflowMutationError = HTTPValidationError
    export type UpdateWorkflowMutationVariables = {data: BodyType<WorkflowIn>}

    /**
 * @summary Update Workflow
 */
export const useUpdateWorkflow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflow>>, TError,UpdateWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflow>>,
        TError,
        UpdateWorkflowMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorkflowMutationOptions(options), queryClient);
    }

/**
 * @summary Create Workflow
 */
export const createWorkflow = (
    workflowIn: BodyType<WorkflowIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowOut>(
      {url: `/api/workflows/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowIn, signal
    },
      options);
    }




export const getCreateWorkflowMutationKey = () => ['createWorkflow'] as const;

export const getCreateWorkflowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,CreateWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,CreateWorkflowMutationVariables, TContext> => {

const mutationKey = getCreateWorkflowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkflow>>, CreateWorkflowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorkflow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkflow>>>
    export type CreateWorkflowMutationBody = BodyType<WorkflowIn>
    export type CreateWorkflowMutationError = HTTPValidationError
    export type CreateWorkflowMutationVariables = {data: BodyType<WorkflowIn>}

    /**
 * @summary Create Workflow
 */
export const useCreateWorkflow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkflow>>, TError,CreateWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkflow>>,
        TError,
        CreateWorkflowMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorkflowMutationOptions(options), queryClient);
    }

/**
 * @summary Update Workflow Order
 */
export const updateWorkflowOrder = (
    updateWorkflowOrderBody: BodyType<string[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/workflows/reorder`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkflowOrderBody, signal
    },
      options);
    }




export const getUpdateWorkflowOrderMutationKey = () => ['updateWorkflowOrder'] as const;

export const getUpdateWorkflowOrderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowOrder>>, TError,UpdateWorkflowOrderMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowOrder>>, TError,UpdateWorkflowOrderMutationVariables, TContext> => {

const mutationKey = getUpdateWorkflowOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflowOrder>>, UpdateWorkflowOrderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateWorkflowOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflowOrder>>>
    export type UpdateWorkflowOrderMutationBody = BodyType<string[]>
    export type UpdateWorkflowOrderMutationError = HTTPValidationError
    export type UpdateWorkflowOrderMutationVariables = {data: BodyType<string[]>}

    /**
 * @summary Update Workflow Order
 */
export const useUpdateWorkflowOrder = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowOrder>>, TError,UpdateWorkflowOrderMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflowOrder>>,
        TError,
        UpdateWorkflowOrderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorkflowOrderMutationOptions(options), queryClient);
    }

/**
 * @summary Get Workflow Actions
 */
export const getWorkflowActions = (
    workflowId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowActionOut[]>(
      {url: `/api/workflows/${workflowId}/actions`, method: 'GET', signal
    },
      options);
    }




export const getGetWorkflowActionsQueryKey = (workflowId: string,) => {
    return [
    `/api/workflows/${workflowId}/actions`
    ] as const;
    }


export const getGetWorkflowActionsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflowActions>>, TError = HTTPValidationError>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowActionsQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowActions>>> = ({ signal }) => getWorkflowActions(workflowId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflowActions>>>
export type GetWorkflowActionsQueryError = HTTPValidationError


export function useGetWorkflowActions<TData = Awaited<ReturnType<typeof getWorkflowActions>>, TError = HTTPValidationError>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowActions>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowActions<TData = Awaited<ReturnType<typeof getWorkflowActions>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowActions>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowActions<TData = Awaited<ReturnType<typeof getWorkflowActions>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workflow Actions
 */

export function useGetWorkflowActions<TData = Awaited<ReturnType<typeof getWorkflowActions>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowActions>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowActionsQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete Workflow Action
 */
export const deleteWorkflowAction = (
    actionId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/workflows/action/${actionId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteWorkflowActionMutationKey = () => ['deleteWorkflowAction'] as const;

export const getDeleteWorkflowActionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowAction>>, TError,DeleteWorkflowActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowAction>>, TError,DeleteWorkflowActionMutationVariables, TContext> => {

const mutationKey = getDeleteWorkflowActionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflowAction>>, DeleteWorkflowActionMutationVariables> = (props) => {
          const {actionId} = props ?? {};

          return  deleteWorkflowAction(actionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowActionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflowAction>>>

    export type DeleteWorkflowActionMutationError = HTTPValidationError
    export type DeleteWorkflowActionMutationVariables = {actionId: string}

    /**
 * @summary Delete Workflow Action
 */
export const useDeleteWorkflowAction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowAction>>, TError,DeleteWorkflowActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflowAction>>,
        TError,
        DeleteWorkflowActionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWorkflowActionMutationOptions(options), queryClient);
    }

/**
 * @summary Save Action
 */
export const saveAction = (
    workflowActionIn: BodyType<WorkflowActionIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/workflows/action/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowActionIn, signal
    },
      options);
    }




export const getSaveActionMutationKey = () => ['saveAction'] as const;

export const getSaveActionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAction>>, TError,SaveActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAction>>, TError,SaveActionMutationVariables, TContext> => {

const mutationKey = getSaveActionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAction>>, SaveActionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveActionMutationResult = NonNullable<Awaited<ReturnType<typeof saveAction>>>
    export type SaveActionMutationBody = BodyType<WorkflowActionIn>
    export type SaveActionMutationError = HTTPValidationError
    export type SaveActionMutationVariables = {data: BodyType<WorkflowActionIn>}

    /**
 * @summary Save Action
 */
export const useSaveAction = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAction>>, TError,SaveActionMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveAction>>,
        TError,
        SaveActionMutationVariables,
        TContext
      > => {
      return useMutation(getSaveActionMutationOptions(options), queryClient);
    }

/**
 * @summary Get Custom Variables
 */
export const getCustomVariables = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<CustomVariablesOut>(
      {url: `/api/workflows/custom-variables`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomVariablesQueryKey = () => {
    return [
    `/api/workflows/custom-variables`
    ] as const;
    }


export const getGetCustomVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getCustomVariables>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomVariablesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomVariables>>> = ({ signal }) => getCustomVariables(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomVariables>>>
export type GetCustomVariablesQueryError = HTTPValidationError


export function useGetCustomVariables<TData = Awaited<ReturnType<typeof getCustomVariables>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomVariables>>,
          TError,
          Awaited<ReturnType<typeof getCustomVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomVariables<TData = Awaited<ReturnType<typeof getCustomVariables>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomVariables>>,
          TError,
          Awaited<ReturnType<typeof getCustomVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomVariables<TData = Awaited<ReturnType<typeof getCustomVariables>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Custom Variables
 */

export function useGetCustomVariables<TData = Awaited<ReturnType<typeof getCustomVariables>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomVariablesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Preview Params
 */
export const getPreviewParams = (
    workflowActionIn: BodyType<WorkflowActionIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PreviewOut>(
      {url: `/api/workflows/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workflowActionIn, signal
    },
      options);
    }




export const getGetPreviewParamsQueryKey = (workflowActionIn?: BodyType<WorkflowActionIn>,) => {
    return [
    'POST', `/api/workflows/preview`, workflowActionIn
    ] as const;
    }


export const getGetPreviewParamsQueryOptions = <TData = Awaited<ReturnType<typeof getPreviewParams>>, TError = HTTPValidationError>(workflowActionIn: BodyType<WorkflowActionIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreviewParamsQueryKey(workflowActionIn);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreviewParams>>> = ({ signal }) => getPreviewParams(workflowActionIn, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreviewParamsQueryResult = NonNullable<Awaited<ReturnType<typeof getPreviewParams>>>
export type GetPreviewParamsQueryError = HTTPValidationError


export function useGetPreviewParams<TData = Awaited<ReturnType<typeof getPreviewParams>>, TError = HTTPValidationError>(
 workflowActionIn: BodyType<WorkflowActionIn>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreviewParams>>,
          TError,
          Awaited<ReturnType<typeof getPreviewParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreviewParams<TData = Awaited<ReturnType<typeof getPreviewParams>>, TError = HTTPValidationError>(
 workflowActionIn: BodyType<WorkflowActionIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreviewParams>>,
          TError,
          Awaited<ReturnType<typeof getPreviewParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreviewParams<TData = Awaited<ReturnType<typeof getPreviewParams>>, TError = HTTPValidationError>(
 workflowActionIn: BodyType<WorkflowActionIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Preview Params
 */

export function useGetPreviewParams<TData = Awaited<ReturnType<typeof getPreviewParams>>, TError = HTTPValidationError>(
 workflowActionIn: BodyType<WorkflowActionIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreviewParams>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreviewParamsQueryOptions(workflowActionIn,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Preview Letter Step
 */
export const previewLetterStep = (
    letterPreviewIn: BodyType<LetterPreviewIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/workflows/preview/letter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: letterPreviewIn, signal
    },
      options);
    }




export const getPreviewLetterStepQueryKey = (letterPreviewIn?: BodyType<LetterPreviewIn>,) => {
    return [
    'POST', `/api/workflows/preview/letter`, letterPreviewIn
    ] as const;
    }


export const getPreviewLetterStepQueryOptions = <TData = Awaited<ReturnType<typeof previewLetterStep>>, TError = HTTPValidationError>(letterPreviewIn: BodyType<LetterPreviewIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewLetterStepQueryKey(letterPreviewIn);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewLetterStep>>> = ({ signal }) => previewLetterStep(letterPreviewIn, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewLetterStepQueryResult = NonNullable<Awaited<ReturnType<typeof previewLetterStep>>>
export type PreviewLetterStepQueryError = HTTPValidationError


export function usePreviewLetterStep<TData = Awaited<ReturnType<typeof previewLetterStep>>, TError = HTTPValidationError>(
 letterPreviewIn: BodyType<LetterPreviewIn>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLetterStep>>,
          TError,
          Awaited<ReturnType<typeof previewLetterStep>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLetterStep<TData = Awaited<ReturnType<typeof previewLetterStep>>, TError = HTTPValidationError>(
 letterPreviewIn: BodyType<LetterPreviewIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewLetterStep>>,
          TError,
          Awaited<ReturnType<typeof previewLetterStep>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewLetterStep<TData = Awaited<ReturnType<typeof previewLetterStep>>, TError = HTTPValidationError>(
 letterPreviewIn: BodyType<LetterPreviewIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Letter Step
 */

export function usePreviewLetterStep<TData = Awaited<ReturnType<typeof previewLetterStep>>, TError = HTTPValidationError>(
 letterPreviewIn: BodyType<LetterPreviewIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewLetterStep>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewLetterStepQueryOptions(letterPreviewIn,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Generate Message
 */
export const generateMessage = (
    generateParams: BodyType<GenerateParams>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<GenerateEmails | null>(
      {url: `/api/workflows/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateParams, signal
    },
      options);
    }




export const getGenerateMessageMutationKey = () => ['generateMessage'] as const;

export const getGenerateMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMessage>>, TError,GenerateMessageMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateMessage>>, TError,GenerateMessageMutationVariables, TContext> => {

const mutationKey = getGenerateMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateMessage>>, GenerateMessageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  generateMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateMessageMutationResult = NonNullable<Awaited<ReturnType<typeof generateMessage>>>
    export type GenerateMessageMutationBody = BodyType<GenerateParams>
    export type GenerateMessageMutationError = HTTPValidationError
    export type GenerateMessageMutationVariables = {data: BodyType<GenerateParams>}

    /**
 * @summary Generate Message
 */
export const useGenerateMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMessage>>, TError,GenerateMessageMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateMessage>>,
        TError,
        GenerateMessageMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateMessageMutationOptions(options), queryClient);
    }

/**
 * @summary Get Workflow
 */
export const getWorkflow = (
    workflowId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<WorkflowOut>(
      {url: `/api/workflows/${workflowId}`, method: 'GET', signal
    },
      options);
    }




export const getGetWorkflowQueryKey = (workflowId: string,) => {
    return [
    `/api/workflows/${workflowId}`
    ] as const;
    }


export const getGetWorkflowQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflow>>, TError = HTTPValidationError>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflow>>> = ({ signal }) => getWorkflow(workflowId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflow>>>
export type GetWorkflowQueryError = HTTPValidationError


export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = HTTPValidationError>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workflow
 */

export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete Workflow
 */
export const deleteWorkflow = (
    workflowId: string,
    params?: DeleteWorkflowParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/workflows/${workflowId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteWorkflowMutationKey = () => ['deleteWorkflow'] as const;

export const getDeleteWorkflowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,DeleteWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,DeleteWorkflowMutationVariables, TContext> => {

const mutationKey = getDeleteWorkflowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflow>>, DeleteWorkflowMutationVariables> = (props) => {
          const {workflowId,params} = props ?? {};

          return  deleteWorkflow(workflowId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflow>>>

    export type DeleteWorkflowMutationError = HTTPValidationError
    export type DeleteWorkflowMutationVariables = {workflowId: string;params?: DeleteWorkflowParams}

    /**
 * @summary Delete Workflow
 */
export const useDeleteWorkflow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflow>>, TError,DeleteWorkflowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflow>>,
        TError,
        DeleteWorkflowMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWorkflowMutationOptions(options), queryClient);
    }

/**
 * @summary Update Email Account
 */
export const updateEmailAccount = (
    emailAccountIn: BodyType<EmailAccountIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emailsettings/accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailAccountIn, signal
    },
      options);
    }




export const getUpdateEmailAccountMutationKey = () => ['updateEmailAccount'] as const;

export const getUpdateEmailAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailAccount>>, TError,UpdateEmailAccountMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailAccount>>, TError,UpdateEmailAccountMutationVariables, TContext> => {

const mutationKey = getUpdateEmailAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailAccount>>, UpdateEmailAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateEmailAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailAccount>>>
    export type UpdateEmailAccountMutationBody = BodyType<EmailAccountIn>
    export type UpdateEmailAccountMutationError = HTTPValidationError
    export type UpdateEmailAccountMutationVariables = {data: BodyType<EmailAccountIn>}

    /**
 * @summary Update Email Account
 */
export const useUpdateEmailAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailAccount>>, TError,UpdateEmailAccountMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailAccount>>,
        TError,
        UpdateEmailAccountMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEmailAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Get Email Accounts
 */
export const getEmailAccounts = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<EmailAccountOut[]>(
      {url: `/api/emailsettings/accounts`, method: 'GET', signal
    },
      options);
    }




export const getGetEmailAccountsQueryKey = () => {
    return [
    `/api/emailsettings/accounts`
    ] as const;
    }


export const getGetEmailAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getEmailAccounts>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailAccounts>>> = ({ signal }) => getEmailAccounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailAccounts>>>
export type GetEmailAccountsQueryError = HTTPValidationError


export function useGetEmailAccounts<TData = Awaited<ReturnType<typeof getEmailAccounts>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailAccounts>>,
          TError,
          Awaited<ReturnType<typeof getEmailAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailAccounts<TData = Awaited<ReturnType<typeof getEmailAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailAccounts>>,
          TError,
          Awaited<ReturnType<typeof getEmailAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailAccounts<TData = Awaited<ReturnType<typeof getEmailAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Email Accounts
 */

export function useGetEmailAccounts<TData = Awaited<ReturnType<typeof getEmailAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Emails
 */
export const getEmails = (
    params?: GetEmailsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<EmailSettingsOut[]>(
      {url: `/api/emailsettings/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEmailsQueryKey = (params?: GetEmailsParams,) => {
    return [
    `/api/emailsettings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmails>>, TError = HTTPValidationError>(params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmails>>> = ({ signal }) => getEmails(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmails>>>
export type GetEmailsQueryError = HTTPValidationError


export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = HTTPValidationError>(
 params: undefined |  GetEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = HTTPValidationError>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = HTTPValidationError>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Emails
 */

export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = HTTPValidationError>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Email Settings
 */
export const updateEmailSettings = (
    emailSettingsIn: BodyType<EmailSettingsIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/emailsettings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailSettingsIn, signal
    },
      options);
    }




export const getUpdateEmailSettingsMutationKey = () => ['updateEmailSettings'] as const;

export const getUpdateEmailSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailSettings>>, TError,UpdateEmailSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailSettings>>, TError,UpdateEmailSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateEmailSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailSettings>>, UpdateEmailSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateEmailSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailSettings>>>
    export type UpdateEmailSettingsMutationBody = BodyType<EmailSettingsIn>
    export type UpdateEmailSettingsMutationError = HTTPValidationError
    export type UpdateEmailSettingsMutationVariables = {data: BodyType<EmailSettingsIn>}

    /**
 * @summary Update Email Settings
 */
export const useUpdateEmailSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailSettings>>, TError,UpdateEmailSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailSettings>>,
        TError,
        UpdateEmailSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEmailSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Settings
 */
export const deleteSettings = (
    emailSettingsId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/emailsettings/${emailSettingsId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSettingsMutationKey = () => ['deleteSettings'] as const;

export const getDeleteSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettings>>, TError,DeleteSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSettings>>, TError,DeleteSettingsMutationVariables, TContext> => {

const mutationKey = getDeleteSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSettings>>, DeleteSettingsMutationVariables> = (props) => {
          const {emailSettingsId} = props ?? {};

          return  deleteSettings(emailSettingsId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSettings>>>

    export type DeleteSettingsMutationError = HTTPValidationError
    export type DeleteSettingsMutationVariables = {emailSettingsId: string}

    /**
 * @summary Delete Settings
 */
export const useDeleteSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettings>>, TError,DeleteSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSettings>>,
        TError,
        DeleteSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Email Groups
 */
export const getEmailGroups = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<EmailGroupOut[]>(
      {url: `/api/emailsettings/groups`, method: 'GET', signal
    },
      options);
    }




export const getGetEmailGroupsQueryKey = () => {
    return [
    `/api/emailsettings/groups`
    ] as const;
    }


export const getGetEmailGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getEmailGroups>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailGroups>>> = ({ signal }) => getEmailGroups(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailGroups>>>
export type GetEmailGroupsQueryError = HTTPValidationError


export function useGetEmailGroups<TData = Awaited<ReturnType<typeof getEmailGroups>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailGroups>>,
          TError,
          Awaited<ReturnType<typeof getEmailGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailGroups<TData = Awaited<ReturnType<typeof getEmailGroups>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailGroups>>,
          TError,
          Awaited<ReturnType<typeof getEmailGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailGroups<TData = Awaited<ReturnType<typeof getEmailGroups>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Email Groups
 */

export function useGetEmailGroups<TData = Awaited<ReturnType<typeof getEmailGroups>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailGroups>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Upsert Email Group
 */
export const upsertEmailGroup = (
    emailGroupIn: BodyType<EmailGroupIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emailsettings/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailGroupIn, signal
    },
      options);
    }




export const getUpsertEmailGroupMutationKey = () => ['upsertEmailGroup'] as const;

export const getUpsertEmailGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEmailGroup>>, TError,UpsertEmailGroupMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertEmailGroup>>, TError,UpsertEmailGroupMutationVariables, TContext> => {

const mutationKey = getUpsertEmailGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertEmailGroup>>, UpsertEmailGroupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertEmailGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertEmailGroupMutationResult = NonNullable<Awaited<ReturnType<typeof upsertEmailGroup>>>
    export type UpsertEmailGroupMutationBody = BodyType<EmailGroupIn>
    export type UpsertEmailGroupMutationError = HTTPValidationError
    export type UpsertEmailGroupMutationVariables = {data: BodyType<EmailGroupIn>}

    /**
 * @summary Upsert Email Group
 */
export const useUpsertEmailGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEmailGroup>>, TError,UpsertEmailGroupMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertEmailGroup>>,
        TError,
        UpsertEmailGroupMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertEmailGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Group
 */
export const deleteGroup = (
    groupId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emailsettings/groups/${groupId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteGroupMutationKey = () => ['deleteGroup'] as const;

export const getDeleteGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,DeleteGroupMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,DeleteGroupMutationVariables, TContext> => {

const mutationKey = getDeleteGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroup>>, DeleteGroupMutationVariables> = (props) => {
          const {groupId} = props ?? {};

          return  deleteGroup(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>

    export type DeleteGroupMutationError = HTTPValidationError
    export type DeleteGroupMutationVariables = {groupId: string}

    /**
 * @summary Delete Group
 */
export const useDeleteGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,DeleteGroupMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroup>>,
        TError,
        DeleteGroupMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Send Verify Email
 */
export const sendVerifyEmail = (
    emailSettingsIn: BodyType<EmailSettingsIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/emailsettings/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailSettingsIn, signal
    },
      options);
    }




export const getSendVerifyEmailMutationKey = () => ['sendVerifyEmail'] as const;

export const getSendVerifyEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVerifyEmail>>, TError,SendVerifyEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendVerifyEmail>>, TError,SendVerifyEmailMutationVariables, TContext> => {

const mutationKey = getSendVerifyEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendVerifyEmail>>, SendVerifyEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendVerifyEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendVerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendVerifyEmail>>>
    export type SendVerifyEmailMutationBody = BodyType<EmailSettingsIn>
    export type SendVerifyEmailMutationError = HTTPValidationError
    export type SendVerifyEmailMutationVariables = {data: BodyType<EmailSettingsIn>}

    /**
 * @summary Send Verify Email
 */
export const useSendVerifyEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVerifyEmail>>, TError,SendVerifyEmailMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendVerifyEmail>>,
        TError,
        SendVerifyEmailMutationVariables,
        TContext
      > => {
      return useMutation(getSendVerifyEmailMutationOptions(options), queryClient);
    }

/**
 * @summary Get Verified Domains
 */
export const getVerifiedDomains = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<VerifiedDomainOut>(
      {url: `/api/emailsettings/verified-domains`, method: 'GET', signal
    },
      options);
    }




export const getGetVerifiedDomainsQueryKey = () => {
    return [
    `/api/emailsettings/verified-domains`
    ] as const;
    }


export const getGetVerifiedDomainsQueryOptions = <TData = Awaited<ReturnType<typeof getVerifiedDomains>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifiedDomainsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifiedDomains>>> = ({ signal }) => getVerifiedDomains(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerifiedDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifiedDomains>>>
export type GetVerifiedDomainsQueryError = HTTPValidationError


export function useGetVerifiedDomains<TData = Awaited<ReturnType<typeof getVerifiedDomains>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiedDomains>>,
          TError,
          Awaited<ReturnType<typeof getVerifiedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedDomains<TData = Awaited<ReturnType<typeof getVerifiedDomains>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiedDomains>>,
          TError,
          Awaited<ReturnType<typeof getVerifiedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiedDomains<TData = Awaited<ReturnType<typeof getVerifiedDomains>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Verified Domains
 */

export function useGetVerifiedDomains<TData = Awaited<ReturnType<typeof getVerifiedDomains>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiedDomains>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifiedDomainsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Top
 */
export const top = (
    params: TopParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SearchOut[]>(
      {url: `/api/search/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTopQueryKey = (params?: TopParams,) => {
    return [
    `/api/search/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTopQueryOptions = <TData = Awaited<ReturnType<typeof top>>, TError = HTTPValidationError>(params: TopParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTopQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof top>>> = ({ signal }) => top(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TopQueryResult = NonNullable<Awaited<ReturnType<typeof top>>>
export type TopQueryError = HTTPValidationError


export function useTop<TData = Awaited<ReturnType<typeof top>>, TError = HTTPValidationError>(
 params: TopParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof top>>,
          TError,
          Awaited<ReturnType<typeof top>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTop<TData = Awaited<ReturnType<typeof top>>, TError = HTTPValidationError>(
 params: TopParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof top>>,
          TError,
          Awaited<ReturnType<typeof top>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTop<TData = Awaited<ReturnType<typeof top>>, TError = HTTPValidationError>(
 params: TopParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Top
 */

export function useTop<TData = Awaited<ReturnType<typeof top>>, TError = HTTPValidationError>(
 params: TopParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof top>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTopQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Templates
 */
export const getTemplates = (
    params?: GetTemplatesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<TemplateOut[]>(
      {url: `/api/templates/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTemplatesQueryKey = (params?: GetTemplatesParams,) => {
    return [
    `/api/templates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getTemplates>>, TError = HTTPValidationError>(params?: GetTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplates>>> = ({ signal }) => getTemplates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplates>>>
export type GetTemplatesQueryError = HTTPValidationError


export function useGetTemplates<TData = Awaited<ReturnType<typeof getTemplates>>, TError = HTTPValidationError>(
 params: undefined |  GetTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplates>>,
          TError,
          Awaited<ReturnType<typeof getTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplates<TData = Awaited<ReturnType<typeof getTemplates>>, TError = HTTPValidationError>(
 params?: GetTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplates>>,
          TError,
          Awaited<ReturnType<typeof getTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplates<TData = Awaited<ReturnType<typeof getTemplates>>, TError = HTTPValidationError>(
 params?: GetTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Templates
 */

export function useGetTemplates<TData = Awaited<ReturnType<typeof getTemplates>>, TError = HTTPValidationError>(
 params?: GetTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplates>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Save Template
 */
export const saveTemplate = (
    templateIn: BodyType<TemplateIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/templates/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: templateIn, signal
    },
      options);
    }




export const getSaveTemplateMutationKey = () => ['saveTemplate'] as const;

export const getSaveTemplateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTemplate>>, TError,SaveTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTemplate>>, TError,SaveTemplateMutationVariables, TContext> => {

const mutationKey = getSaveTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTemplate>>, SaveTemplateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof saveTemplate>>>
    export type SaveTemplateMutationBody = BodyType<TemplateIn>
    export type SaveTemplateMutationError = HTTPValidationError
    export type SaveTemplateMutationVariables = {data: BodyType<TemplateIn>}

    /**
 * @summary Save Template
 */
export const useSaveTemplate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTemplate>>, TError,SaveTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveTemplate>>,
        TError,
        SaveTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getSaveTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Aify
 */
export const aify = (
    aifySentences: BodyType<AifySentences>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<AifySentences>(
      {url: `/api/templates/aify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aifySentences, signal
    },
      options);
    }




export const getAifyMutationKey = () => ['aify'] as const;

export const getAifyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aify>>, TError,AifyMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof aify>>, TError,AifyMutationVariables, TContext> => {

const mutationKey = getAifyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aify>>, AifyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AifyMutationResult = NonNullable<Awaited<ReturnType<typeof aify>>>
    export type AifyMutationBody = BodyType<AifySentences>
    export type AifyMutationError = HTTPValidationError
    export type AifyMutationVariables = {data: BodyType<AifySentences>}

    /**
 * @summary Aify
 */
export const useAify = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aify>>, TError,AifyMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aify>>,
        TError,
        AifyMutationVariables,
        TContext
      > => {
      return useMutation(getAifyMutationOptions(options), queryClient);
    }

/**
 * @summary Get Variables
 */
export const getVariables = (
    params: GetVariablesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<RenderArgs>(
      {url: `/api/templates/variables`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVariablesQueryKey = (params?: GetVariablesParams,) => {
    return [
    `/api/templates/variables`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getVariables>>, TError = HTTPValidationError>(params: GetVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariablesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariables>>> = ({ signal }) => getVariables(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getVariables>>>
export type GetVariablesQueryError = HTTPValidationError


export function useGetVariables<TData = Awaited<ReturnType<typeof getVariables>>, TError = HTTPValidationError>(
 params: GetVariablesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariables>>,
          TError,
          Awaited<ReturnType<typeof getVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariables<TData = Awaited<ReturnType<typeof getVariables>>, TError = HTTPValidationError>(
 params: GetVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariables>>,
          TError,
          Awaited<ReturnType<typeof getVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariables<TData = Awaited<ReturnType<typeof getVariables>>, TError = HTTPValidationError>(
 params: GetVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Variables
 */

export function useGetVariables<TData = Awaited<ReturnType<typeof getVariables>>, TError = HTTPValidationError>(
 params: GetVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariables>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVariablesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Template
 */
export const getTemplate = (
    templateId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<TemplateDetailsOut>(
      {url: `/api/templates/${templateId}`, method: 'GET', signal
    },
      options);
    }




export const getGetTemplateQueryKey = (templateId: string,) => {
    return [
    `/api/templates/${templateId}`
    ] as const;
    }


export const getGetTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getTemplate>>, TError = HTTPValidationError>(templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({ signal }) => getTemplate(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplate>>>
export type GetTemplateQueryError = HTTPValidationError


export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = HTTPValidationError>(
 templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = HTTPValidationError>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = HTTPValidationError>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Template
 */

export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = HTTPValidationError>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete Template
 */
export const deleteTemplate = (
    templateId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/templates/${templateId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTemplateMutationKey = () => ['deleteTemplate'] as const;

export const getDeleteTemplateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext> => {

const mutationKey = getDeleteTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, DeleteTemplateMutationVariables> = (props) => {
          const {templateId} = props ?? {};

          return  deleteTemplate(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>

    export type DeleteTemplateMutationError = HTTPValidationError
    export type DeleteTemplateMutationVariables = {templateId: string}

    /**
 * @summary Delete Template
 */
export const useDeleteTemplate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        DeleteTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Get Updated Invoice Summary
 */
export const getUpdatedInvoiceSummary = (
    params: GetUpdatedInvoiceSummaryParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<GetUpdatedInvoiceSummary200>(
      {url: `/api/invoices/summaries`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUpdatedInvoiceSummaryInfiniteQueryKey = (params?: GetUpdatedInvoiceSummaryParams,) => {
    return [
    'infinite', `/api/invoices/summaries`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetUpdatedInvoiceSummaryQueryKey = (params?: GetUpdatedInvoiceSummaryParams,) => {
    return [
    `/api/invoices/summaries`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUpdatedInvoiceSummaryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>, TError = HTTPValidationError>(params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatedInvoiceSummaryInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>> = ({ signal }) => getUpdatedInvoiceSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdatedInvoiceSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>
export type GetUpdatedInvoiceSummaryInfiniteQueryError = HTTPValidationError


export function useGetUpdatedInvoiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatedInvoiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatedInvoiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Updated Invoice Summary
 */

export function useGetUpdatedInvoiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatedInvoiceSummaryInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdatedInvoiceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError = HTTPValidationError>(params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatedInvoiceSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>> = ({ signal }) => getUpdatedInvoiceSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdatedInvoiceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>>
export type GetUpdatedInvoiceSummaryQueryError = HTTPValidationError


export function useGetUpdatedInvoiceSummary<TData = Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatedInvoiceSummary<TData = Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatedInvoiceSummary<TData = Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Updated Invoice Summary
 */

export function useGetUpdatedInvoiceSummary<TData = Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError = HTTPValidationError>(
 params: GetUpdatedInvoiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatedInvoiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatedInvoiceSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Credits
 */
export const getCredits = (
    params?: GetCreditsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<(CreditNoteOut | OverpaymentOut)[]>(
      {url: `/api/invoices/credits`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCreditsQueryKey = (params?: GetCreditsParams,) => {
    return [
    `/api/invoices/credits`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCreditsQueryOptions = <TData = Awaited<ReturnType<typeof getCredits>>, TError = HTTPValidationError>(params?: GetCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCredits>>> = ({ signal }) => getCredits(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof getCredits>>>
export type GetCreditsQueryError = HTTPValidationError


export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = HTTPValidationError>(
 params: undefined |  GetCreditsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredits>>,
          TError,
          Awaited<ReturnType<typeof getCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = HTTPValidationError>(
 params?: GetCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCredits>>,
          TError,
          Awaited<ReturnType<typeof getCredits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = HTTPValidationError>(
 params?: GetCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Credits
 */

export function useGetCredits<TData = Awaited<ReturnType<typeof getCredits>>, TError = HTTPValidationError>(
 params?: GetCreditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCredits>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Invoices
 */
export const getInvoices = (
    bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ContainerInvoiceOut>(
      {url: `/api/invoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodyGetInvoices,
        params, signal
    },
      options);
    }




export const getGetInvoicesInfiniteQueryKey = (bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams,) => {
    return [
    'infinite', 'POST', `/api/invoices`, ...(params ? [params] : []), bodyGetInvoices
    ] as const;
    }

export const getGetInvoicesQueryKey = (bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams,) => {
    return [
    'POST', `/api/invoices`, ...(params ? [params] : []), bodyGetInvoices
    ] as const;
    }


export const getGetInvoicesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getInvoices>>, GetInvoicesParams['offset']>, TError = HTTPValidationError>(bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesInfiniteQueryKey(bodyGetInvoices,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>, QueryKey, GetInvoicesParams['offset']> = ({ signal, pageParam }) => getInvoices(bodyGetInvoices,{...params, 'offset': pageParam ?? params?.['offset']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesInfiniteQueryError = HTTPValidationError


export function useGetInvoicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvoices>>, GetInvoicesParams['offset']>, TError = HTTPValidationError>(
 bodyGetInvoices: undefined |  BodyType<BodyGetInvoices>,
    params: undefined |  GetInvoicesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvoices>>, GetInvoicesParams['offset']>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvoices>>, GetInvoicesParams['offset']>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoices
 */

export function useGetInvoicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvoices>>, GetInvoicesParams['offset']>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData, QueryKey, GetInvoicesParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesInfiniteQueryOptions(bodyGetInvoices,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = HTTPValidationError>(bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey(bodyGetInvoices,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices(bodyGetInvoices,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = HTTPValidationError


export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = HTTPValidationError>(
 bodyGetInvoices: undefined |  BodyType<BodyGetInvoices>,
    params: undefined |  GetInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoices
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = HTTPValidationError>(
 bodyGetInvoices?: BodyType<BodyGetInvoices>,
    params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesQueryOptions(bodyGetInvoices,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Invoice
 */
export const updateInvoice = (
    invoiceIn: BodyType<InvoiceIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/invoices`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invoiceIn, signal
    },
      options);
    }




export const getUpdateInvoiceMutationKey = () => ['updateInvoice'] as const;

export const getUpdateInvoiceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,UpdateInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,UpdateInvoiceMutationVariables, TContext> => {

const mutationKey = getUpdateInvoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoice>>, UpdateInvoiceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoice>>>
    export type UpdateInvoiceMutationBody = BodyType<InvoiceIn>
    export type UpdateInvoiceMutationError = HTTPValidationError
    export type UpdateInvoiceMutationVariables = {data: BodyType<InvoiceIn>}

    /**
 * @summary Update Invoice
 */
export const useUpdateInvoice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,UpdateInvoiceMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoice>>,
        TError,
        UpdateInvoiceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateInvoiceMutationOptions(options), queryClient);
    }

/**
 * @summary Invoice Download
 */
export const invoiceDownload = (
    invoiceId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/invoices/${invoiceId}/download`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getInvoiceDownloadQueryKey = (invoiceId: string,) => {
    return [
    `/api/invoices/${invoiceId}/download`
    ] as const;
    }


export const getInvoiceDownloadQueryOptions = <TData = Awaited<ReturnType<typeof invoiceDownload>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceDownloadQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceDownload>>> = ({ signal }) => invoiceDownload(invoiceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceDownload>>>
export type InvoiceDownloadQueryError = HTTPValidationError


export function useInvoiceDownload<TData = Awaited<ReturnType<typeof invoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceDownload>>,
          TError,
          Awaited<ReturnType<typeof invoiceDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceDownload<TData = Awaited<ReturnType<typeof invoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceDownload>>,
          TError,
          Awaited<ReturnType<typeof invoiceDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceDownload<TData = Awaited<ReturnType<typeof invoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoice Download
 */

export function useInvoiceDownload<TData = Awaited<ReturnType<typeof invoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceDownloadQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Monthly Dso
 */
export const monthlyDso = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<MonthlyDSOOut[]>(
      {url: `/api/invoices/dso`, method: 'GET', signal
    },
      options);
    }




export const getMonthlyDsoQueryKey = () => {
    return [
    `/api/invoices/dso`
    ] as const;
    }


export const getMonthlyDsoQueryOptions = <TData = Awaited<ReturnType<typeof monthlyDso>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMonthlyDsoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof monthlyDso>>> = ({ signal }) => monthlyDso(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MonthlyDsoQueryResult = NonNullable<Awaited<ReturnType<typeof monthlyDso>>>
export type MonthlyDsoQueryError = HTTPValidationError


export function useMonthlyDso<TData = Awaited<ReturnType<typeof monthlyDso>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof monthlyDso>>,
          TError,
          Awaited<ReturnType<typeof monthlyDso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMonthlyDso<TData = Awaited<ReturnType<typeof monthlyDso>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof monthlyDso>>,
          TError,
          Awaited<ReturnType<typeof monthlyDso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMonthlyDso<TData = Awaited<ReturnType<typeof monthlyDso>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Monthly Dso
 */

export function useMonthlyDso<TData = Awaited<ReturnType<typeof monthlyDso>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof monthlyDso>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMonthlyDsoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Invoice Outcomes
 */
export const invoiceOutcomes = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<InvoiceOutcomes>(
      {url: `/api/invoices/invoice-outcomes`, method: 'GET', signal
    },
      options);
    }




export const getInvoiceOutcomesQueryKey = () => {
    return [
    `/api/invoices/invoice-outcomes`
    ] as const;
    }


export const getInvoiceOutcomesQueryOptions = <TData = Awaited<ReturnType<typeof invoiceOutcomes>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceOutcomesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceOutcomes>>> = ({ signal }) => invoiceOutcomes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvoiceOutcomesQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceOutcomes>>>
export type InvoiceOutcomesQueryError = HTTPValidationError


export function useInvoiceOutcomes<TData = Awaited<ReturnType<typeof invoiceOutcomes>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceOutcomes>>,
          TError,
          Awaited<ReturnType<typeof invoiceOutcomes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceOutcomes<TData = Awaited<ReturnType<typeof invoiceOutcomes>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invoiceOutcomes>>,
          TError,
          Awaited<ReturnType<typeof invoiceOutcomes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvoiceOutcomes<TData = Awaited<ReturnType<typeof invoiceOutcomes>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoice Outcomes
 */

export function useInvoiceOutcomes<TData = Awaited<ReturnType<typeof invoiceOutcomes>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invoiceOutcomes>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvoiceOutcomesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Invoice
 */
export const getInvoice = (
    invoiceId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<InvoiceDetailsOut>(
      {url: `/api/invoices/${invoiceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetInvoiceQueryKey = (invoiceId: string,) => {
    return [
    `/api/invoices/${invoiceId}`
    ] as const;
    }


export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(invoiceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = HTTPValidationError


export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoice
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Rule Fields
 */
export const getRuleFields = (
    params?: GetRuleFieldsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SupportedFields>(
      {url: `/api/tags/rule-fields`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetRuleFieldsQueryKey = (params?: GetRuleFieldsParams,) => {
    return [
    `/api/tags/rule-fields`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRuleFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getRuleFields>>, TError = HTTPValidationError>(params?: GetRuleFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRuleFieldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRuleFields>>> = ({ signal }) => getRuleFields(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRuleFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getRuleFields>>>
export type GetRuleFieldsQueryError = HTTPValidationError


export function useGetRuleFields<TData = Awaited<ReturnType<typeof getRuleFields>>, TError = HTTPValidationError>(
 params: undefined |  GetRuleFieldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRuleFields>>,
          TError,
          Awaited<ReturnType<typeof getRuleFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRuleFields<TData = Awaited<ReturnType<typeof getRuleFields>>, TError = HTTPValidationError>(
 params?: GetRuleFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRuleFields>>,
          TError,
          Awaited<ReturnType<typeof getRuleFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRuleFields<TData = Awaited<ReturnType<typeof getRuleFields>>, TError = HTTPValidationError>(
 params?: GetRuleFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rule Fields
 */

export function useGetRuleFields<TData = Awaited<ReturnType<typeof getRuleFields>>, TError = HTTPValidationError>(
 params?: GetRuleFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuleFields>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRuleFieldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Field Alternatives
 */
export const getFieldAlternatives = (
    entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<LabelId[] | string | null>(
      {url: `/api/tags/field/${entity}/${field}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFieldAlternativesQueryKey = (entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams,) => {
    return [
    `/api/tags/field/${entity}/${field}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFieldAlternativesQueryOptions = <TData = Awaited<ReturnType<typeof getFieldAlternatives>>, TError = HTTPValidationError>(entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFieldAlternativesQueryKey(entity,field,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFieldAlternatives>>> = ({ signal }) => getFieldAlternatives(entity,field,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: entity !== null && entity !== undefined && field !== null && field !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFieldAlternativesQueryResult = NonNullable<Awaited<ReturnType<typeof getFieldAlternatives>>>
export type GetFieldAlternativesQueryError = HTTPValidationError


export function useGetFieldAlternatives<TData = Awaited<ReturnType<typeof getFieldAlternatives>>, TError = HTTPValidationError>(
 entity: WorkflowRuleEntity,
    field: string,
    params: undefined |  GetFieldAlternativesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFieldAlternatives>>,
          TError,
          Awaited<ReturnType<typeof getFieldAlternatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFieldAlternatives<TData = Awaited<ReturnType<typeof getFieldAlternatives>>, TError = HTTPValidationError>(
 entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFieldAlternatives>>,
          TError,
          Awaited<ReturnType<typeof getFieldAlternatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFieldAlternatives<TData = Awaited<ReturnType<typeof getFieldAlternatives>>, TError = HTTPValidationError>(
 entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Field Alternatives
 */

export function useGetFieldAlternatives<TData = Awaited<ReturnType<typeof getFieldAlternatives>>, TError = HTTPValidationError>(
 entity: WorkflowRuleEntity,
    field: string,
    params?: GetFieldAlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldAlternatives>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFieldAlternativesQueryOptions(entity,field,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Rules
 */
export const getRules = (
    workflowId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<RulesOutput>(
      {url: `/api/tags/${workflowId}`, method: 'GET', signal
    },
      options);
    }




export const getGetRulesQueryKey = (workflowId: string,) => {
    return [
    `/api/tags/${workflowId}`
    ] as const;
    }


export const getGetRulesQueryOptions = <TData = Awaited<ReturnType<typeof getRules>>, TError = HTTPValidationError>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRulesQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRules>>> = ({ signal }) => getRules(workflowId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getRules>>>
export type GetRulesQueryError = HTTPValidationError


export function useGetRules<TData = Awaited<ReturnType<typeof getRules>>, TError = HTTPValidationError>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRules>>,
          TError,
          Awaited<ReturnType<typeof getRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRules<TData = Awaited<ReturnType<typeof getRules>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRules>>,
          TError,
          Awaited<ReturnType<typeof getRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRules<TData = Awaited<ReturnType<typeof getRules>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rules
 */

export function useGetRules<TData = Awaited<ReturnType<typeof getRules>>, TError = HTTPValidationError>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRulesQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Save Rules
 */
export const saveRules = (
    workflowId: string,
    rulesInput: BodyType<RulesInput>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/tags/${workflowId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rulesInput, signal
    },
      options);
    }




export const getSaveRulesMutationKey = () => ['saveRules'] as const;

export const getSaveRulesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRules>>, TError,SaveRulesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRules>>, TError,SaveRulesMutationVariables, TContext> => {

const mutationKey = getSaveRulesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRules>>, SaveRulesMutationVariables> = (props) => {
          const {workflowId,data} = props ?? {};

          return  saveRules(workflowId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRulesMutationResult = NonNullable<Awaited<ReturnType<typeof saveRules>>>
    export type SaveRulesMutationBody = BodyType<RulesInput>
    export type SaveRulesMutationError = HTTPValidationError
    export type SaveRulesMutationVariables = {workflowId: string;data: BodyType<RulesInput>}

    /**
 * @summary Save Rules
 */
export const useSaveRules = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRules>>, TError,SaveRulesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRules>>,
        TError,
        SaveRulesMutationVariables,
        TContext
      > => {
      return useMutation(getSaveRulesMutationOptions(options), queryClient);
    }

/**
 * @summary Trace
 */
export const trace = (
    rulesInput: BodyType<RulesInput>,
    params: TraceParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<RulesTrace>(
      {url: `/api/tags/trace`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rulesInput,
        params, signal
    },
      options);
    }




export const getTraceMutationKey = () => ['trace'] as const;

export const getTraceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trace>>, TError,TraceMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof trace>>, TError,TraceMutationVariables, TContext> => {

const mutationKey = getTraceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trace>>, TraceMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  trace(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TraceMutationResult = NonNullable<Awaited<ReturnType<typeof trace>>>
    export type TraceMutationBody = BodyType<RulesInput>
    export type TraceMutationError = HTTPValidationError
    export type TraceMutationVariables = {data: BodyType<RulesInput>;params: TraceParams}

    /**
 * @summary Trace
 */
export const useTrace = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trace>>, TError,TraceMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof trace>>,
        TError,
        TraceMutationVariables,
        TContext
      > => {
      return useMutation(getTraceMutationOptions(options), queryClient);
    }

/**
 * @summary Enroll
 */
export const enroll = (
    workflowId: string,
    enrollIn: BodyType<EnrollIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/tags/${workflowId}/enroll`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollIn, signal
    },
      options);
    }




export const getEnrollMutationKey = () => ['enroll'] as const;

export const getEnrollMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enroll>>, TError,EnrollMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof enroll>>, TError,EnrollMutationVariables, TContext> => {

const mutationKey = getEnrollMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enroll>>, EnrollMutationVariables> = (props) => {
          const {workflowId,data} = props ?? {};

          return  enroll(workflowId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnrollMutationResult = NonNullable<Awaited<ReturnType<typeof enroll>>>
    export type EnrollMutationBody = BodyType<EnrollIn>
    export type EnrollMutationError = HTTPValidationError
    export type EnrollMutationVariables = {workflowId: string;data: BodyType<EnrollIn>}

    /**
 * @summary Enroll
 */
export const useEnroll = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enroll>>, TError,EnrollMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enroll>>,
        TError,
        EnrollMutationVariables,
        TContext
      > => {
      return useMutation(getEnrollMutationOptions(options), queryClient);
    }

/**
 * @summary Get Portal
 */
export const getPortal = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/webhooks/get-portal`, method: 'POST', signal
    },
      options);
    }




export const getGetPortalMutationKey = () => ['getPortal'] as const;

export const getGetPortalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getPortal>>, TError,void, TContext> => {

const mutationKey = getGetPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPortal>>, void> = () => {


          return  getPortal(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPortalMutationResult = NonNullable<Awaited<ReturnType<typeof getPortal>>>

    export type GetPortalMutationError = HTTPValidationError


    /**
 * @summary Get Portal
 */
export const useGetPortal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPortal>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetPortalMutationOptions(options), queryClient);
    }

/**
 * @summary Get Statements
 */
export const getStatements = (
    params?: GetStatementsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<StatementOut[]>(
      {url: `/api/statements/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStatementsQueryKey = (params?: GetStatementsParams,) => {
    return [
    `/api/statements/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatementsQueryOptions = <TData = Awaited<ReturnType<typeof getStatements>>, TError = HTTPValidationError>(params?: GetStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatements>>> = ({ signal }) => getStatements(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatementsQueryResult = NonNullable<Awaited<ReturnType<typeof getStatements>>>
export type GetStatementsQueryError = HTTPValidationError


export function useGetStatements<TData = Awaited<ReturnType<typeof getStatements>>, TError = HTTPValidationError>(
 params: undefined |  GetStatementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatements>>,
          TError,
          Awaited<ReturnType<typeof getStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatements<TData = Awaited<ReturnType<typeof getStatements>>, TError = HTTPValidationError>(
 params?: GetStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatements>>,
          TError,
          Awaited<ReturnType<typeof getStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatements<TData = Awaited<ReturnType<typeof getStatements>>, TError = HTTPValidationError>(
 params?: GetStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Statements
 */

export function useGetStatements<TData = Awaited<ReturnType<typeof getStatements>>, TError = HTTPValidationError>(
 params?: GetStatementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatements>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Statement
 */
export const getStatement = (
    customerId: string,
    params: GetStatementParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<StatementOut | null>(
      {url: `/api/statements/${customerId}/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStatementQueryKey = (customerId: string,
    params?: GetStatementParams,) => {
    return [
    `/api/statements/${customerId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatementQueryOptions = <TData = Awaited<ReturnType<typeof getStatement>>, TError = HTTPValidationError>(customerId: string,
    params: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatementQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatement>>> = ({ signal }) => getStatement(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getStatement>>>
export type GetStatementQueryError = HTTPValidationError


export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetStatementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatement>>,
          TError,
          Awaited<ReturnType<typeof getStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatement>>,
          TError,
          Awaited<ReturnType<typeof getStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Statement
 */

export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatementQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Activity Data
 */
export const getActivityData = (
    customerId: string,
    params: GetActivityDataParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ActivityData[]>(
      {url: `/api/statements/${customerId}/activity/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetActivityDataQueryKey = (customerId: string,
    params?: GetActivityDataParams,) => {
    return [
    `/api/statements/${customerId}/activity/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityDataQueryOptions = <TData = Awaited<ReturnType<typeof getActivityData>>, TError = HTTPValidationError>(customerId: string,
    params: GetActivityDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityDataQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityData>>> = ({ signal }) => getActivityData(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityDataQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityData>>>
export type GetActivityDataQueryError = HTTPValidationError


export function useGetActivityData<TData = Awaited<ReturnType<typeof getActivityData>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetActivityDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityData>>,
          TError,
          Awaited<ReturnType<typeof getActivityData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityData<TData = Awaited<ReturnType<typeof getActivityData>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetActivityDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityData>>,
          TError,
          Awaited<ReturnType<typeof getActivityData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityData<TData = Awaited<ReturnType<typeof getActivityData>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetActivityDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Activity Data
 */

export function useGetActivityData<TData = Awaited<ReturnType<typeof getActivityData>>, TError = HTTPValidationError>(
 customerId: string,
    params: GetActivityDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityData>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityDataQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Publish
 */
export const publish = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/notes/${eventId}/publish`, method: 'POST', signal
    },
      options);
    }




export const getPublishMutationKey = () => ['publish'] as const;

export const getPublishMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,PublishMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,PublishMutationVariables, TContext> => {

const mutationKey = getPublishMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publish>>, PublishMutationVariables> = (props) => {
          const {eventId} = props ?? {};

          return  publish(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishMutationResult = NonNullable<Awaited<ReturnType<typeof publish>>>

    export type PublishMutationError = HTTPValidationError
    export type PublishMutationVariables = {eventId: string}

    /**
 * @summary Publish
 */
export const usePublish = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,PublishMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publish>>,
        TError,
        PublishMutationVariables,
        TContext
      > => {
      return useMutation(getPublishMutationOptions(options), queryClient);
    }

/**
 * @summary Add Note
 */
export const addNote = (
    noteIn: BodyType<NoteIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/notes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteIn, signal
    },
      options);
    }




export const getAddNoteMutationKey = () => ['addNote'] as const;

export const getAddNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext> => {

const mutationKey = getAddNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNote>>, AddNoteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addNote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addNote>>>
    export type AddNoteMutationBody = BodyType<NoteIn>
    export type AddNoteMutationError = HTTPValidationError
    export type AddNoteMutationVariables = {data: BodyType<NoteIn>}

    /**
 * @summary Add Note
 */
export const useAddNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addNote>>,
        TError,
        AddNoteMutationVariables,
        TContext
      > => {
      return useMutation(getAddNoteMutationOptions(options), queryClient);
    }

/**
 * @summary Get Schedule
 */
export const getSchedule = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ScheduleOut | null>(
      {url: `/api/schedule/`, method: 'GET', signal
    },
      options);
    }




export const getGetScheduleQueryKey = () => {
    return [
    `/api/schedule/`
    ] as const;
    }


export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = HTTPValidationError


export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Schedule
 */

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Set Schedule
 */
export const setSchedule = (
    scheduleIn: BodyType<ScheduleIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ScheduleOut>(
      {url: `/api/schedule/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleIn, signal
    },
      options);
    }




export const getSetScheduleMutationKey = () => ['setSchedule'] as const;

export const getSetScheduleMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSchedule>>, TError,SetScheduleMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setSchedule>>, TError,SetScheduleMutationVariables, TContext> => {

const mutationKey = getSetScheduleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSchedule>>, SetScheduleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSchedule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof setSchedule>>>
    export type SetScheduleMutationBody = BodyType<ScheduleIn>
    export type SetScheduleMutationError = HTTPValidationError
    export type SetScheduleMutationVariables = {data: BodyType<ScheduleIn>}

    /**
 * @summary Set Schedule
 */
export const useSetSchedule = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSchedule>>, TError,SetScheduleMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSchedule>>,
        TError,
        SetScheduleMutationVariables,
        TContext
      > => {
      return useMutation(getSetScheduleMutationOptions(options), queryClient);
    }

/**
 * @summary Set Pauses
 */
export const setPauses = (
    pauseIn: BodyType<PauseIn[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/schedule/set-pauses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pauseIn, signal
    },
      options);
    }




export const getSetPausesMutationKey = () => ['setPauses'] as const;

export const getSetPausesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPauses>>, TError,SetPausesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setPauses>>, TError,SetPausesMutationVariables, TContext> => {

const mutationKey = getSetPausesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPauses>>, SetPausesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setPauses(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPausesMutationResult = NonNullable<Awaited<ReturnType<typeof setPauses>>>
    export type SetPausesMutationBody = BodyType<PauseIn[]>
    export type SetPausesMutationError = HTTPValidationError
    export type SetPausesMutationVariables = {data: BodyType<PauseIn[]>}

    /**
 * @summary Set Pauses
 */
export const useSetPauses = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPauses>>, TError,SetPausesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPauses>>,
        TError,
        SetPausesMutationVariables,
        TContext
      > => {
      return useMutation(getSetPausesMutationOptions(options), queryClient);
    }

/**
 * @summary Get Pauses
 */
export const getPauses = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PauseOut[]>(
      {url: `/api/schedule/pauses`, method: 'GET', signal
    },
      options);
    }




export const getGetPausesQueryKey = () => {
    return [
    `/api/schedule/pauses`
    ] as const;
    }


export const getGetPausesQueryOptions = <TData = Awaited<ReturnType<typeof getPauses>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPausesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPauses>>> = ({ signal }) => getPauses(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPausesQueryResult = NonNullable<Awaited<ReturnType<typeof getPauses>>>
export type GetPausesQueryError = HTTPValidationError


export function useGetPauses<TData = Awaited<ReturnType<typeof getPauses>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPauses>>,
          TError,
          Awaited<ReturnType<typeof getPauses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPauses<TData = Awaited<ReturnType<typeof getPauses>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPauses>>,
          TError,
          Awaited<ReturnType<typeof getPauses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPauses<TData = Awaited<ReturnType<typeof getPauses>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pauses
 */

export function useGetPauses<TData = Awaited<ReturnType<typeof getPauses>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPauses>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPausesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Actions By Event
 */
export const getActionsByEvent = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ActionOut[]>(
      {url: `/api/actions/event/${eventId}`, method: 'GET', signal
    },
      options);
    }




export const getGetActionsByEventQueryKey = (eventId: string,) => {
    return [
    `/api/actions/event/${eventId}`
    ] as const;
    }


export const getGetActionsByEventQueryOptions = <TData = Awaited<ReturnType<typeof getActionsByEvent>>, TError = HTTPValidationError>(eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionsByEventQueryKey(eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionsByEvent>>> = ({ signal }) => getActionsByEvent(eventId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionsByEventQueryResult = NonNullable<Awaited<ReturnType<typeof getActionsByEvent>>>
export type GetActionsByEventQueryError = HTTPValidationError


export function useGetActionsByEvent<TData = Awaited<ReturnType<typeof getActionsByEvent>>, TError = HTTPValidationError>(
 eventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionsByEvent>>,
          TError,
          Awaited<ReturnType<typeof getActionsByEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsByEvent<TData = Awaited<ReturnType<typeof getActionsByEvent>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionsByEvent>>,
          TError,
          Awaited<ReturnType<typeof getActionsByEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActionsByEvent<TData = Awaited<ReturnType<typeof getActionsByEvent>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Actions By Event
 */

export function useGetActionsByEvent<TData = Awaited<ReturnType<typeof getActionsByEvent>>, TError = HTTPValidationError>(
 eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionsByEvent>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActionsByEventQueryOptions(eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Silence Actions
 */
export const silenceActions = (
    silenceActionsBody: BodyType<string[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/actions/silence`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: silenceActionsBody, signal
    },
      options);
    }




export const getSilenceActionsMutationKey = () => ['silenceActions'] as const;

export const getSilenceActionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof silenceActions>>, TError,SilenceActionsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof silenceActions>>, TError,SilenceActionsMutationVariables, TContext> => {

const mutationKey = getSilenceActionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof silenceActions>>, SilenceActionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  silenceActions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SilenceActionsMutationResult = NonNullable<Awaited<ReturnType<typeof silenceActions>>>
    export type SilenceActionsMutationBody = BodyType<string[]>
    export type SilenceActionsMutationError = HTTPValidationError
    export type SilenceActionsMutationVariables = {data: BodyType<string[]>}

    /**
 * @summary Silence Actions
 */
export const useSilenceActions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof silenceActions>>, TError,SilenceActionsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof silenceActions>>,
        TError,
        SilenceActionsMutationVariables,
        TContext
      > => {
      return useMutation(getSilenceActionsMutationOptions(options), queryClient);
    }

/**
 * @summary Execute Actions
 */
export const executeActions = (
    executeActionsBody: BodyType<string[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/actions/execute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeActionsBody, signal
    },
      options);
    }




export const getExecuteActionsMutationKey = () => ['executeActions'] as const;

export const getExecuteActionsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeActions>>, TError,ExecuteActionsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof executeActions>>, TError,ExecuteActionsMutationVariables, TContext> => {

const mutationKey = getExecuteActionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeActions>>, ExecuteActionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  executeActions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteActionsMutationResult = NonNullable<Awaited<ReturnType<typeof executeActions>>>
    export type ExecuteActionsMutationBody = BodyType<string[]>
    export type ExecuteActionsMutationError = HTTPValidationError
    export type ExecuteActionsMutationVariables = {data: BodyType<string[]>}

    /**
 * @summary Execute Actions
 */
export const useExecuteActions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeActions>>, TError,ExecuteActionsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeActions>>,
        TError,
        ExecuteActionsMutationVariables,
        TContext
      > => {
      return useMutation(getExecuteActionsMutationOptions(options), queryClient);
    }

/**
 * @summary Silence Action By Event
 */
export const silenceActionByEvent = (
    eventId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/actions/event/${eventId}/silence`, method: 'PUT', signal
    },
      options);
    }




export const getSilenceActionByEventMutationKey = () => ['silenceActionByEvent'] as const;

export const getSilenceActionByEventMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof silenceActionByEvent>>, TError,SilenceActionByEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof silenceActionByEvent>>, TError,SilenceActionByEventMutationVariables, TContext> => {

const mutationKey = getSilenceActionByEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof silenceActionByEvent>>, SilenceActionByEventMutationVariables> = (props) => {
          const {eventId} = props ?? {};

          return  silenceActionByEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SilenceActionByEventMutationResult = NonNullable<Awaited<ReturnType<typeof silenceActionByEvent>>>

    export type SilenceActionByEventMutationError = HTTPValidationError
    export type SilenceActionByEventMutationVariables = {eventId: string}

    /**
 * @summary Silence Action By Event
 */
export const useSilenceActionByEvent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof silenceActionByEvent>>, TError,SilenceActionByEventMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof silenceActionByEvent>>,
        TError,
        SilenceActionByEventMutationVariables,
        TContext
      > => {
      return useMutation(getSilenceActionByEventMutationOptions(options), queryClient);
    }

/**
 * @summary Get Action
 */
export const getAction = (
    actionId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ActionOut>(
      {url: `/api/actions/${actionId}`, method: 'GET', signal
    },
      options);
    }




export const getGetActionQueryKey = (actionId: string,) => {
    return [
    `/api/actions/${actionId}`
    ] as const;
    }


export const getGetActionQueryOptions = <TData = Awaited<ReturnType<typeof getAction>>, TError = HTTPValidationError>(actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionQueryKey(actionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAction>>> = ({ signal }) => getAction(actionId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: actionId !== null && actionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActionQueryResult = NonNullable<Awaited<ReturnType<typeof getAction>>>
export type GetActionQueryError = HTTPValidationError


export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = HTTPValidationError>(
 actionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = HTTPValidationError>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = HTTPValidationError>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Action
 */

export function useGetAction<TData = Awaited<ReturnType<typeof getAction>>, TError = HTTPValidationError>(
 actionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActionQueryOptions(actionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Plan Settings
 */
export const getPlanSettings = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PaymentPlanSettingsOut>(
      {url: `/api/payment-plans/settings/`, method: 'GET', signal
    },
      options);
    }




export const getGetPlanSettingsQueryKey = () => {
    return [
    `/api/payment-plans/settings/`
    ] as const;
    }


export const getGetPlanSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPlanSettings>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanSettings>>> = ({ signal }) => getPlanSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanSettings>>>
export type GetPlanSettingsQueryError = HTTPValidationError


export function useGetPlanSettings<TData = Awaited<ReturnType<typeof getPlanSettings>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanSettings>>,
          TError,
          Awaited<ReturnType<typeof getPlanSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanSettings<TData = Awaited<ReturnType<typeof getPlanSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanSettings>>,
          TError,
          Awaited<ReturnType<typeof getPlanSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanSettings<TData = Awaited<ReturnType<typeof getPlanSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Plan Settings
 */

export function useGetPlanSettings<TData = Awaited<ReturnType<typeof getPlanSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Plan Settings
 */
export const updatePlanSettings = (
    paymentPlanSettingsIn: BodyType<PaymentPlanSettingsIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/payment-plans/settings/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: paymentPlanSettingsIn, signal
    },
      options);
    }




export const getUpdatePlanSettingsMutationKey = () => ['updatePlanSettings'] as const;

export const getUpdatePlanSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlanSettings>>, TError,UpdatePlanSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlanSettings>>, TError,UpdatePlanSettingsMutationVariables, TContext> => {

const mutationKey = getUpdatePlanSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlanSettings>>, UpdatePlanSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePlanSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlanSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlanSettings>>>
    export type UpdatePlanSettingsMutationBody = BodyType<PaymentPlanSettingsIn>
    export type UpdatePlanSettingsMutationError = HTTPValidationError
    export type UpdatePlanSettingsMutationVariables = {data: BodyType<PaymentPlanSettingsIn>}

    /**
 * @summary Update Plan Settings
 */
export const useUpdatePlanSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlanSettings>>, TError,UpdatePlanSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlanSettings>>,
        TError,
        UpdatePlanSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlanSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Plan Settings
 */
export const deletePlanSettings = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/payment-plans/settings/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePlanSettingsMutationKey = () => ['deletePlanSettings'] as const;

export const getDeletePlanSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanSettings>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlanSettings>>, TError,void, TContext> => {

const mutationKey = getDeletePlanSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlanSettings>>, void> = () => {


          return  deletePlanSettings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlanSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlanSettings>>>

    export type DeletePlanSettingsMutationError = HTTPValidationError


    /**
 * @summary Delete Plan Settings
 */
export const useDeletePlanSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanSettings>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlanSettings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeletePlanSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Plans For Customer
 */
export const getPlansForCustomer = (
    customerId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PaymentPlanOut[]>(
      {url: `/api/payment-plans/${customerId}/`, method: 'GET', signal
    },
      options);
    }




export const getGetPlansForCustomerQueryKey = (customerId: string,) => {
    return [
    `/api/payment-plans/${customerId}/`
    ] as const;
    }


export const getGetPlansForCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getPlansForCustomer>>, TError = HTTPValidationError>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansForCustomerQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlansForCustomer>>> = ({ signal }) => getPlansForCustomer(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlansForCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getPlansForCustomer>>>
export type GetPlansForCustomerQueryError = HTTPValidationError


export function useGetPlansForCustomer<TData = Awaited<ReturnType<typeof getPlansForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlansForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getPlansForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlansForCustomer<TData = Awaited<ReturnType<typeof getPlansForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlansForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getPlansForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlansForCustomer<TData = Awaited<ReturnType<typeof getPlansForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Plans For Customer
 */

export function useGetPlansForCustomer<TData = Awaited<ReturnType<typeof getPlansForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlansForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlansForCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Upsert Plans
 */
export const upsertPlans = (
    paymentPlanIn: BodyType<PaymentPlanIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PaymentPlanOut>(
      {url: `/api/payment-plans/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentPlanIn, signal
    },
      options);
    }




export const getUpsertPlansMutationKey = () => ['upsertPlans'] as const;

export const getUpsertPlansMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPlans>>, TError,UpsertPlansMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertPlans>>, TError,UpsertPlansMutationVariables, TContext> => {

const mutationKey = getUpsertPlansMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertPlans>>, UpsertPlansMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertPlans(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertPlansMutationResult = NonNullable<Awaited<ReturnType<typeof upsertPlans>>>
    export type UpsertPlansMutationBody = BodyType<PaymentPlanIn>
    export type UpsertPlansMutationError = HTTPValidationError
    export type UpsertPlansMutationVariables = {data: BodyType<PaymentPlanIn>}

    /**
 * @summary Upsert Plans
 */
export const useUpsertPlans = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPlans>>, TError,UpsertPlansMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertPlans>>,
        TError,
        UpsertPlansMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertPlansMutationOptions(options), queryClient);
    }

/**
 * @summary Portal
 */
export const portal = (
    params: PortalParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PortalCustomerOut>(
      {url: `/api/portal`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPortalQueryKey = (params?: PortalParams,) => {
    return [
    `/api/portal`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortalQueryOptions = <TData = Awaited<ReturnType<typeof portal>>, TError = HTTPValidationError>(params: PortalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portal>>> = ({ signal }) => portal(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortalQueryResult = NonNullable<Awaited<ReturnType<typeof portal>>>
export type PortalQueryError = HTTPValidationError


export function usePortal<TData = Awaited<ReturnType<typeof portal>>, TError = HTTPValidationError>(
 params: PortalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portal>>,
          TError,
          Awaited<ReturnType<typeof portal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortal<TData = Awaited<ReturnType<typeof portal>>, TError = HTTPValidationError>(
 params: PortalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portal>>,
          TError,
          Awaited<ReturnType<typeof portal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortal<TData = Awaited<ReturnType<typeof portal>>, TError = HTTPValidationError>(
 params: PortalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Portal
 */

export function usePortal<TData = Awaited<ReturnType<typeof portal>>, TError = HTTPValidationError>(
 params: PortalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portal>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Portal Invoices
 */
export const portalInvoices = (
    params: PortalInvoicesParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PortalInvoices>(
      {url: `/api/portal/invoices`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPortalInvoicesQueryKey = (params?: PortalInvoicesParams,) => {
    return [
    `/api/portal/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortalInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof portalInvoices>>, TError = HTTPValidationError>(params: PortalInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortalInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portalInvoices>>> = ({ signal }) => portalInvoices(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortalInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof portalInvoices>>>
export type PortalInvoicesQueryError = HTTPValidationError


export function usePortalInvoices<TData = Awaited<ReturnType<typeof portalInvoices>>, TError = HTTPValidationError>(
 params: PortalInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoices>>,
          TError,
          Awaited<ReturnType<typeof portalInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoices<TData = Awaited<ReturnType<typeof portalInvoices>>, TError = HTTPValidationError>(
 params: PortalInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoices>>,
          TError,
          Awaited<ReturnType<typeof portalInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoices<TData = Awaited<ReturnType<typeof portalInvoices>>, TError = HTTPValidationError>(
 params: PortalInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Portal Invoices
 */

export function usePortalInvoices<TData = Awaited<ReturnType<typeof portalInvoices>>, TError = HTTPValidationError>(
 params: PortalInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoices>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortalInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Portal Invoice
 */
export const portalInvoice = (
    invoiceId: string,
    params: PortalInvoiceParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PortalInvoiceDetailsOut>(
      {url: `/api/portal/invoices/${invoiceId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPortalInvoiceQueryKey = (invoiceId: string,
    params?: PortalInvoiceParams,) => {
    return [
    `/api/portal/invoices/${invoiceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortalInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof portalInvoice>>, TError = HTTPValidationError>(invoiceId: string,
    params: PortalInvoiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortalInvoiceQueryKey(invoiceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portalInvoice>>> = ({ signal }) => portalInvoice(invoiceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortalInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof portalInvoice>>>
export type PortalInvoiceQueryError = HTTPValidationError


export function usePortalInvoice<TData = Awaited<ReturnType<typeof portalInvoice>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoice>>,
          TError,
          Awaited<ReturnType<typeof portalInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoice<TData = Awaited<ReturnType<typeof portalInvoice>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoice>>,
          TError,
          Awaited<ReturnType<typeof portalInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoice<TData = Awaited<ReturnType<typeof portalInvoice>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Portal Invoice
 */

export function usePortalInvoice<TData = Awaited<ReturnType<typeof portalInvoice>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortalInvoiceQueryOptions(invoiceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Portal Plan Installment
 */
export const portalPlanInstallment = (
    installmentId: string,
    params: PortalPlanInstallmentParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PortalInstallmentDetailsOut>(
      {url: `/api/portal/installment/${installmentId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPortalPlanInstallmentQueryKey = (installmentId: string,
    params?: PortalPlanInstallmentParams,) => {
    return [
    `/api/portal/installment/${installmentId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortalPlanInstallmentQueryOptions = <TData = Awaited<ReturnType<typeof portalPlanInstallment>>, TError = HTTPValidationError>(installmentId: string,
    params: PortalPlanInstallmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortalPlanInstallmentQueryKey(installmentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portalPlanInstallment>>> = ({ signal }) => portalPlanInstallment(installmentId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: installmentId !== null && installmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortalPlanInstallmentQueryResult = NonNullable<Awaited<ReturnType<typeof portalPlanInstallment>>>
export type PortalPlanInstallmentQueryError = HTTPValidationError


export function usePortalPlanInstallment<TData = Awaited<ReturnType<typeof portalPlanInstallment>>, TError = HTTPValidationError>(
 installmentId: string,
    params: PortalPlanInstallmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalPlanInstallment>>,
          TError,
          Awaited<ReturnType<typeof portalPlanInstallment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalPlanInstallment<TData = Awaited<ReturnType<typeof portalPlanInstallment>>, TError = HTTPValidationError>(
 installmentId: string,
    params: PortalPlanInstallmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalPlanInstallment>>,
          TError,
          Awaited<ReturnType<typeof portalPlanInstallment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalPlanInstallment<TData = Awaited<ReturnType<typeof portalPlanInstallment>>, TError = HTTPValidationError>(
 installmentId: string,
    params: PortalPlanInstallmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Portal Plan Installment
 */

export function usePortalPlanInstallment<TData = Awaited<ReturnType<typeof portalPlanInstallment>>, TError = HTTPValidationError>(
 installmentId: string,
    params: PortalPlanInstallmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalPlanInstallment>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortalPlanInstallmentQueryOptions(installmentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Portal Invoice Download
 */
export const portalInvoiceDownload = (
    invoiceId: string,
    params: PortalInvoiceDownloadParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/portal/invoices/${invoiceId}/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getPortalInvoiceDownloadQueryKey = (invoiceId: string,
    params?: PortalInvoiceDownloadParams,) => {
    return [
    `/api/portal/invoices/${invoiceId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortalInvoiceDownloadQueryOptions = <TData = Awaited<ReturnType<typeof portalInvoiceDownload>>, TError = HTTPValidationError>(invoiceId: string,
    params: PortalInvoiceDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortalInvoiceDownloadQueryKey(invoiceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portalInvoiceDownload>>> = ({ signal }) => portalInvoiceDownload(invoiceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortalInvoiceDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof portalInvoiceDownload>>>
export type PortalInvoiceDownloadQueryError = HTTPValidationError


export function usePortalInvoiceDownload<TData = Awaited<ReturnType<typeof portalInvoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceDownloadParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoiceDownload>>,
          TError,
          Awaited<ReturnType<typeof portalInvoiceDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoiceDownload<TData = Awaited<ReturnType<typeof portalInvoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalInvoiceDownload>>,
          TError,
          Awaited<ReturnType<typeof portalInvoiceDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortalInvoiceDownload<TData = Awaited<ReturnType<typeof portalInvoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Portal Invoice Download
 */

export function usePortalInvoiceDownload<TData = Awaited<ReturnType<typeof portalInvoiceDownload>>, TError = HTTPValidationError>(
 invoiceId: string,
    params: PortalInvoiceDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portalInvoiceDownload>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortalInvoiceDownloadQueryOptions(invoiceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Integrations
 */
export const getIntegrations = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<NotificationProviderOut[]>(
      {url: `/api/notifications/integrations`, method: 'GET', signal
    },
      options);
    }




export const getGetIntegrationsQueryKey = () => {
    return [
    `/api/notifications/integrations`
    ] as const;
    }


export const getGetIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrations>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrations>>> = ({ signal }) => getIntegrations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrations>>>
export type GetIntegrationsQueryError = HTTPValidationError


export function useGetIntegrations<TData = Awaited<ReturnType<typeof getIntegrations>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrations<TData = Awaited<ReturnType<typeof getIntegrations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrations<TData = Awaited<ReturnType<typeof getIntegrations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Integrations
 */

export function useGetIntegrations<TData = Awaited<ReturnType<typeof getIntegrations>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get All Channels
 */
export const getAllChannels = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SlackChannel[]>(
      {url: `/api/notifications/integrations/all-channels`, method: 'GET', signal
    },
      options);
    }




export const getGetAllChannelsQueryKey = () => {
    return [
    `/api/notifications/integrations/all-channels`
    ] as const;
    }


export const getGetAllChannelsQueryOptions = <TData = Awaited<ReturnType<typeof getAllChannels>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllChannelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllChannels>>> = ({ signal }) => getAllChannels(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllChannels>>>
export type GetAllChannelsQueryError = HTTPValidationError


export function useGetAllChannels<TData = Awaited<ReturnType<typeof getAllChannels>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChannels>>,
          TError,
          Awaited<ReturnType<typeof getAllChannels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChannels<TData = Awaited<ReturnType<typeof getAllChannels>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChannels>>,
          TError,
          Awaited<ReturnType<typeof getAllChannels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChannels<TData = Awaited<ReturnType<typeof getAllChannels>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get All Channels
 */

export function useGetAllChannels<TData = Awaited<ReturnType<typeof getAllChannels>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllChannels>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllChannelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get All Users
 */
export const getAllUsers = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SlackChannel[]>(
      {url: `/api/notifications/integrations/all-users`, method: 'GET', signal
    },
      options);
    }




export const getGetAllUsersQueryKey = () => {
    return [
    `/api/notifications/integrations/all-users`
    ] as const;
    }


export const getGetAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAllUsers>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) => getAllUsers(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>
export type GetAllUsersQueryError = HTTPValidationError


export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get All Users
 */

export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Notification
 */
export const updateNotification = (
    notificationIn: BodyType<NotificationIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/notifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationIn, signal
    },
      options);
    }




export const getUpdateNotificationMutationKey = () => ['updateNotification'] as const;

export const getUpdateNotificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotification>>, TError,UpdateNotificationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotification>>, TError,UpdateNotificationMutationVariables, TContext> => {

const mutationKey = getUpdateNotificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotification>>, UpdateNotificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotification>>>
    export type UpdateNotificationMutationBody = BodyType<NotificationIn>
    export type UpdateNotificationMutationError = HTTPValidationError
    export type UpdateNotificationMutationVariables = {data: BodyType<NotificationIn>}

    /**
 * @summary Update Notification
 */
export const useUpdateNotification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotification>>, TError,UpdateNotificationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotification>>,
        TError,
        UpdateNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNotificationMutationOptions(options), queryClient);
    }

/**
 * @summary Get Global Notification
 */
export const getGlobalNotification = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<[NotificationOut, string]>(
      {url: `/api/notifications`, method: 'GET', signal
    },
      options);
    }




export const getGetGlobalNotificationQueryKey = () => {
    return [
    `/api/notifications`
    ] as const;
    }


export const getGetGlobalNotificationQueryOptions = <TData = Awaited<ReturnType<typeof getGlobalNotification>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlobalNotificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlobalNotification>>> = ({ signal }) => getGlobalNotification(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGlobalNotificationQueryResult = NonNullable<Awaited<ReturnType<typeof getGlobalNotification>>>
export type GetGlobalNotificationQueryError = HTTPValidationError


export function useGetGlobalNotification<TData = Awaited<ReturnType<typeof getGlobalNotification>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalNotification>>,
          TError,
          Awaited<ReturnType<typeof getGlobalNotification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGlobalNotification<TData = Awaited<ReturnType<typeof getGlobalNotification>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalNotification>>,
          TError,
          Awaited<ReturnType<typeof getGlobalNotification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGlobalNotification<TData = Awaited<ReturnType<typeof getGlobalNotification>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Global Notification
 */

export function useGetGlobalNotification<TData = Awaited<ReturnType<typeof getGlobalNotification>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalNotification>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGlobalNotificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Reports
 */
export const getReports = (
    params: GetReportsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ReportOut[]>(
      {url: `/api/notifications/reports`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetReportsQueryKey = (params?: GetReportsParams,) => {
    return [
    `/api/notifications/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportsQueryOptions = <TData = Awaited<ReturnType<typeof getReports>>, TError = HTTPValidationError>(params: GetReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReports>>> = ({ signal }) => getReports(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getReports>>>
export type GetReportsQueryError = HTTPValidationError


export function useGetReports<TData = Awaited<ReturnType<typeof getReports>>, TError = HTTPValidationError>(
 params: GetReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReports<TData = Awaited<ReturnType<typeof getReports>>, TError = HTTPValidationError>(
 params: GetReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReports<TData = Awaited<ReturnType<typeof getReports>>, TError = HTTPValidationError>(
 params: GetReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Reports
 */

export function useGetReports<TData = Awaited<ReturnType<typeof getReports>>, TError = HTTPValidationError>(
 params: GetReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Save Report
 */
export const saveReport = (
    reportIn: BodyType<ReportIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/notifications/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportIn, signal
    },
      options);
    }




export const getSaveReportMutationKey = () => ['saveReport'] as const;

export const getSaveReportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReport>>, TError,SaveReportMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveReport>>, TError,SaveReportMutationVariables, TContext> => {

const mutationKey = getSaveReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveReport>>, SaveReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveReportMutationResult = NonNullable<Awaited<ReturnType<typeof saveReport>>>
    export type SaveReportMutationBody = BodyType<ReportIn>
    export type SaveReportMutationError = HTTPValidationError
    export type SaveReportMutationVariables = {data: BodyType<ReportIn>}

    /**
 * @summary Save Report
 */
export const useSaveReport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReport>>, TError,SaveReportMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveReport>>,
        TError,
        SaveReportMutationVariables,
        TContext
      > => {
      return useMutation(getSaveReportMutationOptions(options), queryClient);
    }

/**
 * @summary Get Report
 */
export const getReport = (
    reportId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<ReportDetailsOut>(
      {url: `/api/notifications/reports/${reportId}`, method: 'GET', signal
    },
      options);
    }




export const getGetReportQueryKey = (reportId: string,) => {
    return [
    `/api/notifications/reports/${reportId}`
    ] as const;
    }


export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportQueryKey(reportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) => getReport(reportId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: reportId !== null && reportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>
export type GetReportQueryError = HTTPValidationError


export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Report
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Send Report Now
 */
export const sendReportNow = (
    bodySendReportNow: BodyType<BodySendReportNow>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/notifications/reports/send-now`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bodySendReportNow, signal
    },
      options);
    }




export const getSendReportNowMutationKey = () => ['sendReportNow'] as const;

export const getSendReportNowMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportNow>>, TError,SendReportNowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sendReportNow>>, TError,SendReportNowMutationVariables, TContext> => {

const mutationKey = getSendReportNowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReportNow>>, SendReportNowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendReportNow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendReportNowMutationResult = NonNullable<Awaited<ReturnType<typeof sendReportNow>>>
    export type SendReportNowMutationBody = BodyType<BodySendReportNow>
    export type SendReportNowMutationError = HTTPValidationError
    export type SendReportNowMutationVariables = {data: BodyType<BodySendReportNow>}

    /**
 * @summary Send Report Now
 */
export const useSendReportNow = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReportNow>>, TError,SendReportNowMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendReportNow>>,
        TError,
        SendReportNowMutationVariables,
        TContext
      > => {
      return useMutation(getSendReportNowMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Notification
 */
export const deleteNotification = (
    notificationId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/notifications/${notificationId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteNotificationMutationKey = () => ['deleteNotification'] as const;

export const getDeleteNotificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,DeleteNotificationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,DeleteNotificationMutationVariables, TContext> => {

const mutationKey = getDeleteNotificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotification>>, DeleteNotificationMutationVariables> = (props) => {
          const {notificationId} = props ?? {};

          return  deleteNotification(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotification>>>

    export type DeleteNotificationMutationError = HTTPValidationError
    export type DeleteNotificationMutationVariables = {notificationId: string}

    /**
 * @summary Delete Notification
 */
export const useDeleteNotification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotification>>, TError,DeleteNotificationMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotification>>,
        TError,
        DeleteNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNotificationMutationOptions(options), queryClient);
    }

/**
 * @summary Get Twilio Settings
 */
export const getTwilioSettings = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<TwilioSettingsOut[]>(
      {url: `/api/sms/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetTwilioSettingsQueryKey = () => {
    return [
    `/api/sms/settings`
    ] as const;
    }


export const getGetTwilioSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTwilioSettings>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTwilioSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTwilioSettings>>> = ({ signal }) => getTwilioSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTwilioSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTwilioSettings>>>
export type GetTwilioSettingsQueryError = HTTPValidationError


export function useGetTwilioSettings<TData = Awaited<ReturnType<typeof getTwilioSettings>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioSettings>>,
          TError,
          Awaited<ReturnType<typeof getTwilioSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioSettings<TData = Awaited<ReturnType<typeof getTwilioSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioSettings>>,
          TError,
          Awaited<ReturnType<typeof getTwilioSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioSettings<TData = Awaited<ReturnType<typeof getTwilioSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Twilio Settings
 */

export function useGetTwilioSettings<TData = Awaited<ReturnType<typeof getTwilioSettings>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTwilioSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Sms
 */
export const updateSms = (
    smsId: string,
    smsIn: BodyType<SmsIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/sms/${smsId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: smsIn, signal
    },
      options);
    }




export const getUpdateSmsMutationKey = () => ['updateSms'] as const;

export const getUpdateSmsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,UpdateSmsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,UpdateSmsMutationVariables, TContext> => {

const mutationKey = getUpdateSmsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSms>>, UpdateSmsMutationVariables> = (props) => {
          const {smsId,data} = props ?? {};

          return  updateSms(smsId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSmsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSms>>>
    export type UpdateSmsMutationBody = BodyType<SmsIn>
    export type UpdateSmsMutationError = HTTPValidationError
    export type UpdateSmsMutationVariables = {smsId: string;data: BodyType<SmsIn>}

    /**
 * @summary Update Sms
 */
export const useUpdateSms = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,UpdateSmsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSms>>,
        TError,
        UpdateSmsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSmsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Sms Recording
 */
export const getSmsRecording = (
    smsId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<Blob>(
      {url: `/api/sms/${smsId}/recording`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetSmsRecordingQueryKey = (smsId: string,) => {
    return [
    `/api/sms/${smsId}/recording`
    ] as const;
    }


export const getGetSmsRecordingQueryOptions = <TData = Awaited<ReturnType<typeof getSmsRecording>>, TError = HTTPValidationError>(smsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmsRecordingQueryKey(smsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsRecording>>> = ({ signal }) => getSmsRecording(smsId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: smsId !== null && smsId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSmsRecordingQueryResult = NonNullable<Awaited<ReturnType<typeof getSmsRecording>>>
export type GetSmsRecordingQueryError = HTTPValidationError


export function useGetSmsRecording<TData = Awaited<ReturnType<typeof getSmsRecording>>, TError = HTTPValidationError>(
 smsId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsRecording>>,
          TError,
          Awaited<ReturnType<typeof getSmsRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmsRecording<TData = Awaited<ReturnType<typeof getSmsRecording>>, TError = HTTPValidationError>(
 smsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsRecording>>,
          TError,
          Awaited<ReturnType<typeof getSmsRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmsRecording<TData = Awaited<ReturnType<typeof getSmsRecording>>, TError = HTTPValidationError>(
 smsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sms Recording
 */

export function useGetSmsRecording<TData = Awaited<ReturnType<typeof getSmsRecording>>, TError = HTTPValidationError>(
 smsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsRecording>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSmsRecordingQueryOptions(smsId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Subcustomer Settings
 */
export const getSubcustomerSettings = (
    params: GetSubcustomerSettingsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SubcustomerSettingsOutOutput | null>(
      {url: `/api/subcustomer/settings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSubcustomerSettingsQueryKey = (params?: GetSubcustomerSettingsParams,) => {
    return [
    `/api/subcustomer/settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSubcustomerSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSubcustomerSettings>>, TError = HTTPValidationError>(params: GetSubcustomerSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubcustomerSettingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubcustomerSettings>>> = ({ signal }) => getSubcustomerSettings(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubcustomerSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubcustomerSettings>>>
export type GetSubcustomerSettingsQueryError = HTTPValidationError


export function useGetSubcustomerSettings<TData = Awaited<ReturnType<typeof getSubcustomerSettings>>, TError = HTTPValidationError>(
 params: GetSubcustomerSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubcustomerSettings>>,
          TError,
          Awaited<ReturnType<typeof getSubcustomerSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubcustomerSettings<TData = Awaited<ReturnType<typeof getSubcustomerSettings>>, TError = HTTPValidationError>(
 params: GetSubcustomerSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubcustomerSettings>>,
          TError,
          Awaited<ReturnType<typeof getSubcustomerSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubcustomerSettings<TData = Awaited<ReturnType<typeof getSubcustomerSettings>>, TError = HTTPValidationError>(
 params: GetSubcustomerSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Subcustomer Settings
 */

export function useGetSubcustomerSettings<TData = Awaited<ReturnType<typeof getSubcustomerSettings>>, TError = HTTPValidationError>(
 params: GetSubcustomerSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubcustomerSettingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Set Subcustomer Settings
 */
export const setSubcustomerSettings = (
    subcustomerSettingsOutInput: BodyType<SubcustomerSettingsOutInput>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/subcustomer/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subcustomerSettingsOutInput, signal
    },
      options);
    }




export const getSetSubcustomerSettingsMutationKey = () => ['setSubcustomerSettings'] as const;

export const getSetSubcustomerSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSubcustomerSettings>>, TError,SetSubcustomerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setSubcustomerSettings>>, TError,SetSubcustomerSettingsMutationVariables, TContext> => {

const mutationKey = getSetSubcustomerSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSubcustomerSettings>>, SetSubcustomerSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSubcustomerSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSubcustomerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setSubcustomerSettings>>>
    export type SetSubcustomerSettingsMutationBody = BodyType<SubcustomerSettingsOutInput>
    export type SetSubcustomerSettingsMutationError = HTTPValidationError
    export type SetSubcustomerSettingsMutationVariables = {data: BodyType<SubcustomerSettingsOutInput>}

    /**
 * @summary Set Subcustomer Settings
 */
export const useSetSubcustomerSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSubcustomerSettings>>, TError,SetSubcustomerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSubcustomerSettings>>,
        TError,
        SetSubcustomerSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetSubcustomerSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Subcustomer Settings
 */
export const deleteSubcustomerSettings = (
    params: DeleteSubcustomerSettingsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/subcustomer/settings`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteSubcustomerSettingsMutationKey = () => ['deleteSubcustomerSettings'] as const;

export const getDeleteSubcustomerSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubcustomerSettings>>, TError,DeleteSubcustomerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSubcustomerSettings>>, TError,DeleteSubcustomerSettingsMutationVariables, TContext> => {

const mutationKey = getDeleteSubcustomerSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSubcustomerSettings>>, DeleteSubcustomerSettingsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteSubcustomerSettings(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSubcustomerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSubcustomerSettings>>>

    export type DeleteSubcustomerSettingsMutationError = HTTPValidationError
    export type DeleteSubcustomerSettingsMutationVariables = {params: DeleteSubcustomerSettingsParams}

    /**
 * @summary Delete Subcustomer Settings
 */
export const useDeleteSubcustomerSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubcustomerSettings>>, TError,DeleteSubcustomerSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSubcustomerSettings>>,
        TError,
        DeleteSubcustomerSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSubcustomerSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Subcustomer History
 */
export const getSubcustomerHistory = (
    params: GetSubcustomerHistoryParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SubcustomerHistoryOut[] | ParentCustomerHistoryOut[]>(
      {url: `/api/subcustomer/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSubcustomerHistoryQueryKey = (params?: GetSubcustomerHistoryParams,) => {
    return [
    `/api/subcustomer/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSubcustomerHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getSubcustomerHistory>>, TError = HTTPValidationError>(params: GetSubcustomerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubcustomerHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubcustomerHistory>>> = ({ signal }) => getSubcustomerHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubcustomerHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSubcustomerHistory>>>
export type GetSubcustomerHistoryQueryError = HTTPValidationError


export function useGetSubcustomerHistory<TData = Awaited<ReturnType<typeof getSubcustomerHistory>>, TError = HTTPValidationError>(
 params: GetSubcustomerHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubcustomerHistory>>,
          TError,
          Awaited<ReturnType<typeof getSubcustomerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubcustomerHistory<TData = Awaited<ReturnType<typeof getSubcustomerHistory>>, TError = HTTPValidationError>(
 params: GetSubcustomerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubcustomerHistory>>,
          TError,
          Awaited<ReturnType<typeof getSubcustomerHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubcustomerHistory<TData = Awaited<ReturnType<typeof getSubcustomerHistory>>, TError = HTTPValidationError>(
 params: GetSubcustomerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Subcustomer History
 */

export function useGetSubcustomerHistory<TData = Awaited<ReturnType<typeof getSubcustomerHistory>>, TError = HTTPValidationError>(
 params: GetSubcustomerHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubcustomerHistory>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubcustomerHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Pending Subcustomer
 */
export const getPendingSubcustomer = (
    params: GetPendingSubcustomerParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<SubcustomerHistoryOut[] | ParentCustomerHistoryOut[]>(
      {url: `/api/subcustomer/pending`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPendingSubcustomerQueryKey = (params?: GetPendingSubcustomerParams,) => {
    return [
    `/api/subcustomer/pending`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPendingSubcustomerQueryOptions = <TData = Awaited<ReturnType<typeof getPendingSubcustomer>>, TError = HTTPValidationError>(params: GetPendingSubcustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingSubcustomerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingSubcustomer>>> = ({ signal }) => getPendingSubcustomer(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingSubcustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingSubcustomer>>>
export type GetPendingSubcustomerQueryError = HTTPValidationError


export function useGetPendingSubcustomer<TData = Awaited<ReturnType<typeof getPendingSubcustomer>>, TError = HTTPValidationError>(
 params: GetPendingSubcustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingSubcustomer>>,
          TError,
          Awaited<ReturnType<typeof getPendingSubcustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingSubcustomer<TData = Awaited<ReturnType<typeof getPendingSubcustomer>>, TError = HTTPValidationError>(
 params: GetPendingSubcustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingSubcustomer>>,
          TError,
          Awaited<ReturnType<typeof getPendingSubcustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingSubcustomer<TData = Awaited<ReturnType<typeof getPendingSubcustomer>>, TError = HTTPValidationError>(
 params: GetPendingSubcustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pending Subcustomer
 */

export function useGetPendingSubcustomer<TData = Awaited<ReturnType<typeof getPendingSubcustomer>>, TError = HTTPValidationError>(
 params: GetPendingSubcustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingSubcustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingSubcustomerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Apply Pending
 */
export const applyPending = (
    subcustomerHistoryId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<string>(
      {url: `/api/subcustomer/pending/${subcustomerHistoryId}`, method: 'POST', signal
    },
      options);
    }




export const getApplyPendingMutationKey = () => ['applyPending'] as const;

export const getApplyPendingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPending>>, TError,ApplyPendingMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof applyPending>>, TError,ApplyPendingMutationVariables, TContext> => {

const mutationKey = getApplyPendingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyPending>>, ApplyPendingMutationVariables> = (props) => {
          const {subcustomerHistoryId} = props ?? {};

          return  applyPending(subcustomerHistoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyPendingMutationResult = NonNullable<Awaited<ReturnType<typeof applyPending>>>

    export type ApplyPendingMutationError = HTTPValidationError
    export type ApplyPendingMutationVariables = {subcustomerHistoryId: string}

    /**
 * @summary Apply Pending
 */
export const useApplyPending = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPending>>, TError,ApplyPendingMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyPending>>,
        TError,
        ApplyPendingMutationVariables,
        TContext
      > => {
      return useMutation(getApplyPendingMutationOptions(options), queryClient);
    }

/**
 * @summary Save Lane Customer
 */
export const saveLaneCustomer = (
    laneCustomerIn: BodyType<LaneCustomerIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/crm/lane-customer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: laneCustomerIn, signal
    },
      options);
    }




export const getSaveLaneCustomerMutationKey = () => ['saveLaneCustomer'] as const;

export const getSaveLaneCustomerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLaneCustomer>>, TError,SaveLaneCustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveLaneCustomer>>, TError,SaveLaneCustomerMutationVariables, TContext> => {

const mutationKey = getSaveLaneCustomerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveLaneCustomer>>, SaveLaneCustomerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveLaneCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveLaneCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof saveLaneCustomer>>>
    export type SaveLaneCustomerMutationBody = BodyType<LaneCustomerIn>
    export type SaveLaneCustomerMutationError = HTTPValidationError
    export type SaveLaneCustomerMutationVariables = {data: BodyType<LaneCustomerIn>}

    /**
 * @summary Save Lane Customer
 */
export const useSaveLaneCustomer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveLaneCustomer>>, TError,SaveLaneCustomerMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveLaneCustomer>>,
        TError,
        SaveLaneCustomerMutationVariables,
        TContext
      > => {
      return useMutation(getSaveLaneCustomerMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Lane
 */
export const upsertLane = (
    laneIn: BodyType<LaneIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/crm/lane`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: laneIn, signal
    },
      options);
    }




export const getUpsertLaneMutationKey = () => ['upsertLane'] as const;

export const getUpsertLaneMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLane>>, TError,UpsertLaneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertLane>>, TError,UpsertLaneMutationVariables, TContext> => {

const mutationKey = getUpsertLaneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertLane>>, UpsertLaneMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertLane(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertLaneMutationResult = NonNullable<Awaited<ReturnType<typeof upsertLane>>>
    export type UpsertLaneMutationBody = BodyType<LaneIn>
    export type UpsertLaneMutationError = HTTPValidationError
    export type UpsertLaneMutationVariables = {data: BodyType<LaneIn>}

    /**
 * @summary Upsert Lane
 */
export const useUpsertLane = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLane>>, TError,UpsertLaneMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertLane>>,
        TError,
        UpsertLaneMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertLaneMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert Lanes
 */
export const upsertLanes = (
    laneIn: BodyType<LaneIn[]>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/crm/lanes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: laneIn, signal
    },
      options);
    }




export const getUpsertLanesMutationKey = () => ['upsertLanes'] as const;

export const getUpsertLanesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLanes>>, TError,UpsertLanesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertLanes>>, TError,UpsertLanesMutationVariables, TContext> => {

const mutationKey = getUpsertLanesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertLanes>>, UpsertLanesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertLanes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertLanesMutationResult = NonNullable<Awaited<ReturnType<typeof upsertLanes>>>
    export type UpsertLanesMutationBody = BodyType<LaneIn[]>
    export type UpsertLanesMutationError = HTTPValidationError
    export type UpsertLanesMutationVariables = {data: BodyType<LaneIn[]>}

    /**
 * @summary Upsert Lanes
 */
export const useUpsertLanes = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLanes>>, TError,UpsertLanesMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertLanes>>,
        TError,
        UpsertLanesMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertLanesMutationOptions(options), queryClient);
    }

/**
 * @summary Assign Card
 */
export const assignCard = (
    assignCardBody: BodyType<AssignCard>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/crm/assignee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignCardBody, signal
    },
      options);
    }




export const getAssignCardMutationKey = () => ['assignCard'] as const;

export const getAssignCardMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCard>>, TError,AssignCardMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof assignCard>>, TError,AssignCardMutationVariables, TContext> => {

const mutationKey = getAssignCardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignCard>>, AssignCardMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  assignCard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignCardMutationResult = NonNullable<Awaited<ReturnType<typeof assignCard>>>
    export type AssignCardMutationBody = BodyType<AssignCard>
    export type AssignCardMutationError = HTTPValidationError
    export type AssignCardMutationVariables = {data: BodyType<AssignCard>}

    /**
 * @summary Assign Card
 */
export const useAssignCard = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCard>>, TError,AssignCardMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignCard>>,
        TError,
        AssignCardMutationVariables,
        TContext
      > => {
      return useMutation(getAssignCardMutationOptions(options), queryClient);
    }

/**
 * @summary Get Lane
 */
export const getLane = (
    params: GetLaneParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<LaneOut>(
      {url: `/api/crm/board/more`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLaneInfiniteQueryKey = (params?: GetLaneParams,) => {
    return [
    'infinite', `/api/crm/board/more`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetLaneQueryKey = (params?: GetLaneParams,) => {
    return [
    `/api/crm/board/more`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLaneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLane>>, GetLaneParams['offset']>, TError = HTTPValidationError>(params: GetLaneParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaneInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLane>>, QueryKey, GetLaneParams['offset']> = ({ signal, pageParam }) => getLane({...params, 'offset': pageParam ?? params?.['offset']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLaneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLane>>>
export type GetLaneInfiniteQueryError = HTTPValidationError


export function useGetLaneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLane>>, GetLaneParams['offset']>, TError = HTTPValidationError>(
 params: GetLaneParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLane>>,
          TError,
          Awaited<ReturnType<typeof getLane>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLaneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLane>>, GetLaneParams['offset']>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLane>>,
          TError,
          Awaited<ReturnType<typeof getLane>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLaneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLane>>, GetLaneParams['offset']>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lane
 */

export function useGetLaneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLane>>, GetLaneParams['offset']>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData, QueryKey, GetLaneParams['offset']>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLaneInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLaneQueryOptions = <TData = Awaited<ReturnType<typeof getLane>>, TError = HTTPValidationError>(params: GetLaneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaneQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLane>>> = ({ signal }) => getLane(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLaneQueryResult = NonNullable<Awaited<ReturnType<typeof getLane>>>
export type GetLaneQueryError = HTTPValidationError


export function useGetLane<TData = Awaited<ReturnType<typeof getLane>>, TError = HTTPValidationError>(
 params: GetLaneParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLane>>,
          TError,
          Awaited<ReturnType<typeof getLane>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLane<TData = Awaited<ReturnType<typeof getLane>>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLane>>,
          TError,
          Awaited<ReturnType<typeof getLane>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLane<TData = Awaited<ReturnType<typeof getLane>>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lane
 */

export function useGetLane<TData = Awaited<ReturnType<typeof getLane>>, TError = HTTPValidationError>(
 params: GetLaneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLane>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLaneQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Board
 */
export const getBoard = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<BoardOut>(
      {url: `/api/crm/board`, method: 'GET', signal
    },
      options);
    }




export const getGetBoardQueryKey = () => {
    return [
    `/api/crm/board`
    ] as const;
    }


export const getGetBoardQueryOptions = <TData = Awaited<ReturnType<typeof getBoard>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBoardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoard>>> = ({ signal }) => getBoard(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getBoard>>>
export type GetBoardQueryError = HTTPValidationError


export function useGetBoard<TData = Awaited<ReturnType<typeof getBoard>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoard>>,
          TError,
          Awaited<ReturnType<typeof getBoard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoard<TData = Awaited<ReturnType<typeof getBoard>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoard>>,
          TError,
          Awaited<ReturnType<typeof getBoard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoard<TData = Awaited<ReturnType<typeof getBoard>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Board
 */

export function useGetBoard<TData = Awaited<ReturnType<typeof getBoard>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBoardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Bank Accounts
 */
export const getBankAccounts = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<GetBankAccounts200>(
      {url: `/api/payment-fees/accounts`, method: 'GET', signal
    },
      options);
    }




export const getGetBankAccountsQueryKey = () => {
    return [
    `/api/payment-fees/accounts`
    ] as const;
    }


export const getGetBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccounts>>> = ({ signal }) => getBankAccounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccounts>>>
export type GetBankAccountsQueryError = HTTPValidationError


export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bank Accounts
 */

export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Workflow Fees Settings
 */
export const getWorkflowFeesSettings = (
    params?: GetWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<PaymentFeeSettingsOut | null>(
      {url: `/api/payment-fees/settings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkflowFeesSettingsQueryKey = (params?: GetWorkflowFeesSettingsParams,) => {
    return [
    `/api/payment-fees/settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkflowFeesSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = HTTPValidationError>(params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowFeesSettingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowFeesSettings>>> = ({ signal }) => getWorkflowFeesSettings(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowFeesSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflowFeesSettings>>>
export type GetWorkflowFeesSettingsQueryError = HTTPValidationError


export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = HTTPValidationError>(
 params: undefined |  GetWorkflowFeesSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = HTTPValidationError>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = HTTPValidationError>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workflow Fees Settings
 */

export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = HTTPValidationError>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowFeesSettingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Workflow Fees Settings
 */
export const updateWorkflowFeesSettings = (
    paymentFeeSettingsIn: BodyType<PaymentFeeSettingsIn>,
    params?: UpdateWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/payment-fees/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeSettingsIn,
        params, signal
    },
      options);
    }




export const getUpdateWorkflowFeesSettingsMutationKey = () => ['updateWorkflowFeesSettings'] as const;

export const getUpdateWorkflowFeesSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,UpdateWorkflowFeesSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,UpdateWorkflowFeesSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateWorkflowFeesSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, UpdateWorkflowFeesSettingsMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateWorkflowFeesSettings(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowFeesSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>>
    export type UpdateWorkflowFeesSettingsMutationBody = BodyType<PaymentFeeSettingsIn>
    export type UpdateWorkflowFeesSettingsMutationError = HTTPValidationError
    export type UpdateWorkflowFeesSettingsMutationVariables = {data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams}

    /**
 * @summary Update Workflow Fees Settings
 */
export const useUpdateWorkflowFeesSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,UpdateWorkflowFeesSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflowFeesSettings>>,
        TError,
        UpdateWorkflowFeesSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWorkflowFeesSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Workflow Fees Settings
 */
export const deleteWorkflowFeesSettings = (
    params?: DeleteWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<unknown>(
      {url: `/api/payment-fees/settings`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteWorkflowFeesSettingsMutationKey = () => ['deleteWorkflowFeesSettings'] as const;

export const getDeleteWorkflowFeesSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,DeleteWorkflowFeesSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,DeleteWorkflowFeesSettingsMutationVariables, TContext> => {

const mutationKey = getDeleteWorkflowFeesSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, DeleteWorkflowFeesSettingsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteWorkflowFeesSettings(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowFeesSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>>

    export type DeleteWorkflowFeesSettingsMutationError = HTTPValidationError
    export type DeleteWorkflowFeesSettingsMutationVariables = {params?: DeleteWorkflowFeesSettingsParams}

    /**
 * @summary Delete Workflow Fees Settings
 */
export const useDeleteWorkflowFeesSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,DeleteWorkflowFeesSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>,
        TError,
        DeleteWorkflowFeesSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWorkflowFeesSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Fees For Customer
 */
export const getFeesForCustomer = (
    customerId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<FeeInvoiceDetailsOut[]>(
      {url: `/api/payment-fees/for-customer/${customerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetFeesForCustomerQueryKey = (customerId: string,) => {
    return [
    `/api/payment-fees/for-customer/${customerId}`
    ] as const;
    }


export const getGetFeesForCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = HTTPValidationError>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeesForCustomerQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeesForCustomer>>> = ({ signal }) => getFeesForCustomer(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeesForCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getFeesForCustomer>>>
export type GetFeesForCustomerQueryError = HTTPValidationError


export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getFeesForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getFeesForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fees For Customer
 */

export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = HTTPValidationError>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeesForCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Get Fees For Invoice
 */
export const getFeesForInvoice = (
    invoiceId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<FeeInvoiceDetailsOut | null>(
      {url: `/api/payment-fees/for-invoice/${invoiceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetFeesForInvoiceQueryKey = (invoiceId: string,) => {
    return [
    `/api/payment-fees/for-invoice/${invoiceId}`
    ] as const;
    }


export const getGetFeesForInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = HTTPValidationError>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeesForInvoiceQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeesForInvoice>>> = ({ signal }) => getFeesForInvoice(invoiceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeesForInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getFeesForInvoice>>>
export type GetFeesForInvoiceQueryError = HTTPValidationError


export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForInvoice>>,
          TError,
          Awaited<ReturnType<typeof getFeesForInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForInvoice>>,
          TError,
          Awaited<ReturnType<typeof getFeesForInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fees For Invoice
 */

export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = HTTPValidationError>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeesForInvoiceQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Preview Fee
 */
export const previewFee = (
    paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<FeePreviewOut[]>(
      {url: `/api/payment-fees/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeCreateIn, signal
    },
      options);
    }




export const getPreviewFeeQueryKey = (paymentFeeCreateIn?: BodyType<PaymentFeeCreateIn>,) => {
    return [
    'POST', `/api/payment-fees/preview`, paymentFeeCreateIn
    ] as const;
    }


export const getPreviewFeeQueryOptions = <TData = Awaited<ReturnType<typeof previewFee>>, TError = HTTPValidationError>(paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewFeeQueryKey(paymentFeeCreateIn);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewFee>>> = ({ signal }) => previewFee(paymentFeeCreateIn, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewFeeQueryResult = NonNullable<Awaited<ReturnType<typeof previewFee>>>
export type PreviewFeeQueryError = HTTPValidationError


export function usePreviewFee<TData = Awaited<ReturnType<typeof previewFee>>, TError = HTTPValidationError>(
 paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFee>>,
          TError,
          Awaited<ReturnType<typeof previewFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFee<TData = Awaited<ReturnType<typeof previewFee>>, TError = HTTPValidationError>(
 paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFee>>,
          TError,
          Awaited<ReturnType<typeof previewFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewFee<TData = Awaited<ReturnType<typeof previewFee>>, TError = HTTPValidationError>(
 paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Fee
 */

export function usePreviewFee<TData = Awaited<ReturnType<typeof previewFee>>, TError = HTTPValidationError>(
 paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFee>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewFeeQueryOptions(paymentFeeCreateIn,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create Fee
 */
export const createFee = (
    paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/payment-fees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeCreateIn, signal
    },
      options);
    }




export const getCreateFeeMutationKey = () => ['createFee'] as const;

export const getCreateFeeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,CreateFeeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,CreateFeeMutationVariables, TContext> => {

const mutationKey = getCreateFeeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFee>>, CreateFeeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFeeMutationResult = NonNullable<Awaited<ReturnType<typeof createFee>>>
    export type CreateFeeMutationBody = BodyType<PaymentFeeCreateIn>
    export type CreateFeeMutationError = HTTPValidationError
    export type CreateFeeMutationVariables = {data: BodyType<PaymentFeeCreateIn>}

    /**
 * @summary Create Fee
 */
export const useCreateFee = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,CreateFeeMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFee>>,
        TError,
        CreateFeeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFeeMutationOptions(options), queryClient);
    }

/**
 * @summary Get Account
 */
export const getAccount = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<AccountOut | null>(
      {url: `/api/accounts/primary`, method: 'GET', signal
    },
      options);
    }




export const getGetAccountQueryKey = () => {
    return [
    `/api/accounts/primary`
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = HTTPValidationError


export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Account
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update Account
 */
export const updateAccount = (
    accountIn: BodyType<AccountIn>,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/accounts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accountIn, signal
    },
      options);
    }




export const getUpdateAccountMutationKey = () => ['updateAccount'] as const;

export const getUpdateAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,UpdateAccountMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,UpdateAccountMutationVariables, TContext> => {

const mutationKey = getUpdateAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, UpdateAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = BodyType<AccountIn>
    export type UpdateAccountMutationError = HTTPValidationError
    export type UpdateAccountMutationVariables = {data: BodyType<AccountIn>}

    /**
 * @summary Update Account
 */
export const useUpdateAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,UpdateAccountMutationVariables, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        UpdateAccountMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Refresh Account
 */
export const refreshAccount = (

 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {


      return customClient<boolean>(
      {url: `/api/accounts/refresh`, method: 'POST', signal
    },
      options);
    }




export const getRefreshAccountMutationKey = () => ['refreshAccount'] as const;

export const getRefreshAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext> => {

const mutationKey = getRefreshAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccount>>, void> = () => {


          return  refreshAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccount>>>

    export type RefreshAccountMutationError = HTTPValidationError


    /**
 * @summary Refresh Account
 */
export const useRefreshAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshAccountMutationOptions(options), queryClient);
    }
